/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */

// @ts-ignore
// prettier-ignore
// @ts-ignore
// prettier-ignore
import type { RequestConfig,RequestFunctionRestArgs } from 'yapi-to-typescript';
import {
  Method,
  prepare,
  QueryStringArrayFormat,
  RequestBodyType,
  ResponseBodyType,
} from 'yapi-to-typescript';
// @ts-ignore
import request from '../ajax/index';

type UserRequestRestArgs = RequestFunctionRestArgs<typeof request>;

// Request: 目前 React Hooks 功能有用到
export type Request<
  TRequestData,
  TRequestConfig extends RequestConfig,
  TRequestResult,
> = (TRequestConfig['requestDataOptional'] extends true
  ? (requestData?: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult
  : (
      requestData: TRequestData,
      ...args: RequestFunctionRestArgs<typeof request>
    ) => TRequestResult) & {
  requestConfig: TRequestConfig;
};

const mockUrl_0_2_0_0 = 'http://yapi.cai-inc.com/mock/3096' as any;
const devUrl_0_2_0_0 = '' as any;
const prodUrl_0_2_0_0 = '' as any;
const dataKey_0_2_0_0 = 'data' as any;

/**
 * 接口 [通用的四则运算 例如 ：6*(5+(2+3)*8+3)↗](http://yapi.cai-inc.com/project/3096/interface/api/233734) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [CommonController↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_36715)
 * @请求头 `GET /zlb/api/sop/common/calculator`
 * @更新时间 `2023-03-21 09:57:46`
 * @项目ID 3096
 */
export interface ZlbApiSopCommonCalculatorGetRequest {
  calculatorText?: string;
}

/**
 * 接口 [通用的四则运算 例如 ：6*(5+(2+3)*8+3)↗](http://yapi.cai-inc.com/project/3096/interface/api/233734) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [CommonController↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_36715)
 * @请求头 `GET /zlb/api/sop/common/calculator`
 * @更新时间 `2023-03-21 09:57:46`
 * @项目ID 3096
 */
export interface ZlbApiSopCommonCalculatorGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: string;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [通用的四则运算 例如 ：6*(5+(2+3)*8+3)↗](http://yapi.cai-inc.com/project/3096/interface/api/233734) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [CommonController↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_36715)
 * @请求头 `GET /zlb/api/sop/common/calculator`
 * @更新时间 `2023-03-21 09:57:46`
 * @项目ID 3096
 */
type ZlbApiSopCommonCalculatorGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/common/calculator',
    'data',
    string,
    'calculatorText',
    false
  >
>;

/**
 * 接口 [通用的四则运算 例如 ：6*(5+(2+3)*8+3)↗](http://yapi.cai-inc.com/project/3096/interface/api/233734) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [CommonController↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_36715)
 * @请求头 `GET /zlb/api/sop/common/calculator`
 * @更新时间 `2023-03-21 09:57:46`
 * @项目ID 3096
 */
const zlbApiSopCommonCalculatorGetRequestConfig: ZlbApiSopCommonCalculatorGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_0,
    devUrl: devUrl_0_2_0_0,
    prodUrl: prodUrl_0_2_0_0,
    path: '/zlb/api/sop/common/calculator',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_0,
    paramNames: [],
    queryNames: ['calculatorText'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopCommonCalculatorGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [通用的四则运算 例如 ：6*(5+(2+3)*8+3)↗](http://yapi.cai-inc.com/project/3096/interface/api/233734) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [CommonController↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_36715)
 * @请求头 `GET /zlb/api/sop/common/calculator`
 * @更新时间 `2023-03-21 09:57:46`
 * @项目ID 3096
 */
export const zlbApiSopCommonCalculatorGet = /*#__PURE__*/ (
  requestData: ZlbApiSopCommonCalculatorGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopCommonCalculatorGetResponse>(
    prepare(zlbApiSopCommonCalculatorGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopCommonCalculatorGet.requestConfig = zlbApiSopCommonCalculatorGetRequestConfig;

/**
 * 接口 [查询用户的业务查看权限↗](http://yapi.cai-inc.com/project/3096/interface/api/233742) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [CommonController↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_36715)
 * @请求头 `GET /zlb/api/sop/common/authority`
 * @更新时间 `2023-03-21 09:57:47`
 * @项目ID 3096
 */
export interface ZlbApiSopCommonAuthorityGetRequest {}

/**
 * 接口 [查询用户的业务查看权限↗](http://yapi.cai-inc.com/project/3096/interface/api/233742) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [CommonController↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_36715)
 * @请求头 `GET /zlb/api/sop/common/authority`
 * @更新时间 `2023-03-21 09:57:47`
 * @项目ID 3096
 */
export interface ZlbApiSopCommonAuthorityGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 业务编码
     */
    resourceType?: string;
    /**
     * 权限
     * true：有权限，false：无权限
     */
    authority?: boolean;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询用户的业务查看权限↗](http://yapi.cai-inc.com/project/3096/interface/api/233742) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [CommonController↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_36715)
 * @请求头 `GET /zlb/api/sop/common/authority`
 * @更新时间 `2023-03-21 09:57:47`
 * @项目ID 3096
 */
type ZlbApiSopCommonAuthorityGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/common/authority',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [查询用户的业务查看权限↗](http://yapi.cai-inc.com/project/3096/interface/api/233742) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [CommonController↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_36715)
 * @请求头 `GET /zlb/api/sop/common/authority`
 * @更新时间 `2023-03-21 09:57:47`
 * @项目ID 3096
 */
const zlbApiSopCommonAuthorityGetRequestConfig: ZlbApiSopCommonAuthorityGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_0,
    devUrl: devUrl_0_2_0_0,
    prodUrl: prodUrl_0_2_0_0,
    path: '/zlb/api/sop/common/authority',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopCommonAuthorityGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询用户的业务查看权限↗](http://yapi.cai-inc.com/project/3096/interface/api/233742) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [CommonController↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_36715)
 * @请求头 `GET /zlb/api/sop/common/authority`
 * @更新时间 `2023-03-21 09:57:47`
 * @项目ID 3096
 */
export const zlbApiSopCommonAuthorityGet = /*#__PURE__*/ (
  requestData?: ZlbApiSopCommonAuthorityGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopCommonAuthorityGetResponse>(
    prepare(zlbApiSopCommonAuthorityGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopCommonAuthorityGet.requestConfig = zlbApiSopCommonAuthorityGetRequestConfig;

/**
 * 接口 [通用鉴权↗](http://yapi.cai-inc.com/project/3096/interface/api/240422) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [CommonController↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_36715)
 * @请求头 `GET /zlb/api/sop/common/authority-backup`
 * @更新时间 `2023-03-21 09:57:46`
 * @项目ID 3096
 */
export interface ZlbApiSopCommonAuthorityBackupGetRequest {}

/**
 * 接口 [通用鉴权↗](http://yapi.cai-inc.com/project/3096/interface/api/240422) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [CommonController↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_36715)
 * @请求头 `GET /zlb/api/sop/common/authority-backup`
 * @更新时间 `2023-03-21 09:57:46`
 * @项目ID 3096
 */
export interface ZlbApiSopCommonAuthorityBackupGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    key?: boolean;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [通用鉴权↗](http://yapi.cai-inc.com/project/3096/interface/api/240422) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [CommonController↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_36715)
 * @请求头 `GET /zlb/api/sop/common/authority-backup`
 * @更新时间 `2023-03-21 09:57:46`
 * @项目ID 3096
 */
type ZlbApiSopCommonAuthorityBackupGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/common/authority-backup',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [通用鉴权↗](http://yapi.cai-inc.com/project/3096/interface/api/240422) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [CommonController↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_36715)
 * @请求头 `GET /zlb/api/sop/common/authority-backup`
 * @更新时间 `2023-03-21 09:57:46`
 * @项目ID 3096
 */
const zlbApiSopCommonAuthorityBackupGetRequestConfig: ZlbApiSopCommonAuthorityBackupGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_0,
    devUrl: devUrl_0_2_0_0,
    prodUrl: prodUrl_0_2_0_0,
    path: '/zlb/api/sop/common/authority-backup',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopCommonAuthorityBackupGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [通用鉴权↗](http://yapi.cai-inc.com/project/3096/interface/api/240422) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [CommonController↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_36715)
 * @请求头 `GET /zlb/api/sop/common/authority-backup`
 * @更新时间 `2023-03-21 09:57:46`
 * @项目ID 3096
 */
export const zlbApiSopCommonAuthorityBackupGet = /*#__PURE__*/ (
  requestData?: ZlbApiSopCommonAuthorityBackupGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopCommonAuthorityBackupGetResponse>(
    prepare(zlbApiSopCommonAuthorityBackupGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopCommonAuthorityBackupGet.requestConfig = zlbApiSopCommonAuthorityBackupGetRequestConfig;

/**
 * 接口 [比较时间↗](http://yapi.cai-inc.com/project/3096/interface/api/273170) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [CommonController↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_36715)
 * @请求头 `GET /zlb/api/sop/common/compare-time`
 * @更新时间 `2023-03-21 09:57:47`
 * @项目ID 3096
 */
export interface ZlbApiSopCommonCompareTimeGetRequest {
  time: string;
}

/**
 * 接口 [比较时间↗](http://yapi.cai-inc.com/project/3096/interface/api/273170) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [CommonController↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_36715)
 * @请求头 `GET /zlb/api/sop/common/compare-time`
 * @更新时间 `2023-03-21 09:57:47`
 * @项目ID 3096
 */
export interface ZlbApiSopCommonCompareTimeGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: number;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [比较时间↗](http://yapi.cai-inc.com/project/3096/interface/api/273170) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [CommonController↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_36715)
 * @请求头 `GET /zlb/api/sop/common/compare-time`
 * @更新时间 `2023-03-21 09:57:47`
 * @项目ID 3096
 */
type ZlbApiSopCommonCompareTimeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/common/compare-time',
    'data',
    string,
    'time',
    false
  >
>;

/**
 * 接口 [比较时间↗](http://yapi.cai-inc.com/project/3096/interface/api/273170) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [CommonController↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_36715)
 * @请求头 `GET /zlb/api/sop/common/compare-time`
 * @更新时间 `2023-03-21 09:57:47`
 * @项目ID 3096
 */
const zlbApiSopCommonCompareTimeGetRequestConfig: ZlbApiSopCommonCompareTimeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_0,
    devUrl: devUrl_0_2_0_0,
    prodUrl: prodUrl_0_2_0_0,
    path: '/zlb/api/sop/common/compare-time',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_0,
    paramNames: [],
    queryNames: ['time'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopCommonCompareTimeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [比较时间↗](http://yapi.cai-inc.com/project/3096/interface/api/273170) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [CommonController↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_36715)
 * @请求头 `GET /zlb/api/sop/common/compare-time`
 * @更新时间 `2023-03-21 09:57:47`
 * @项目ID 3096
 */
export const zlbApiSopCommonCompareTimeGet = /*#__PURE__*/ (
  requestData: ZlbApiSopCommonCompareTimeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopCommonCompareTimeGetResponse>(
    prepare(zlbApiSopCommonCompareTimeGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopCommonCompareTimeGet.requestConfig = zlbApiSopCommonCompareTimeGetRequestConfig;

/**
 * 接口 [待审批统计↗](http://yapi.cai-inc.com/project/3096/interface/api/316858) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [CommonController↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_36715)
 * @请求头 `GET /zlb/api/sop/common/approval-pending-statistics`
 * @更新时间 `2023-03-21 09:57:47`
 * @项目ID 3096
 */
export interface ZlbApiSopCommonApprovalPendingStatisticsGetRequest {}

/**
 * 接口 [待审批统计↗](http://yapi.cai-inc.com/project/3096/interface/api/316858) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [CommonController↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_36715)
 * @请求头 `GET /zlb/api/sop/common/approval-pending-statistics`
 * @更新时间 `2023-03-21 09:57:47`
 * @项目ID 3096
 */
export interface ZlbApiSopCommonApprovalPendingStatisticsGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 统计类型
     * 0：申请单 1：报销单 2：工资申报单 3：收入登记
     */
    statisticsType?: number;
    /**
     * 枚举类型名称
     */
    statisticsTypeName?: string;
    /**
     * 待审批总数
     */
    totalCount?: number;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [待审批统计↗](http://yapi.cai-inc.com/project/3096/interface/api/316858) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [CommonController↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_36715)
 * @请求头 `GET /zlb/api/sop/common/approval-pending-statistics`
 * @更新时间 `2023-03-21 09:57:47`
 * @项目ID 3096
 */
type ZlbApiSopCommonApprovalPendingStatisticsGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/common/approval-pending-statistics',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [待审批统计↗](http://yapi.cai-inc.com/project/3096/interface/api/316858) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [CommonController↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_36715)
 * @请求头 `GET /zlb/api/sop/common/approval-pending-statistics`
 * @更新时间 `2023-03-21 09:57:47`
 * @项目ID 3096
 */
const zlbApiSopCommonApprovalPendingStatisticsGetRequestConfig: ZlbApiSopCommonApprovalPendingStatisticsGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_0,
    devUrl: devUrl_0_2_0_0,
    prodUrl: prodUrl_0_2_0_0,
    path: '/zlb/api/sop/common/approval-pending-statistics',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopCommonApprovalPendingStatisticsGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [待审批统计↗](http://yapi.cai-inc.com/project/3096/interface/api/316858) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [CommonController↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_36715)
 * @请求头 `GET /zlb/api/sop/common/approval-pending-statistics`
 * @更新时间 `2023-03-21 09:57:47`
 * @项目ID 3096
 */
export const zlbApiSopCommonApprovalPendingStatisticsGet = /*#__PURE__*/ (
  requestData?: ZlbApiSopCommonApprovalPendingStatisticsGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopCommonApprovalPendingStatisticsGetResponse>(
    prepare(zlbApiSopCommonApprovalPendingStatisticsGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopCommonApprovalPendingStatisticsGet.requestConfig =
  zlbApiSopCommonApprovalPendingStatisticsGetRequestConfig;

/**
 * 接口 [机构统计↗](http://yapi.cai-inc.com/project/3096/interface/api/358986) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [CommonController↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_36715)
 * @请求头 `POST /zlb/api/sop/common/org-form-statistics`
 * @更新时间 `2023-03-21 09:57:48`
 * @项目ID 3096
 */
export interface ZlbApiSopCommonOrgFormStatisticsPostRequest {
  orgId: number;
  /**
   * 部门列表
   */
  deptIds?: number[];
}

/**
 * 接口 [机构统计↗](http://yapi.cai-inc.com/project/3096/interface/api/358986) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [CommonController↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_36715)
 * @请求头 `POST /zlb/api/sop/common/org-form-statistics`
 * @更新时间 `2023-03-21 09:57:48`
 * @项目ID 3096
 */
export interface ZlbApiSopCommonOrgFormStatisticsPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 统计类型
     * 0：申请单 1：报销单 2：工资申报单 3：收入登记
     */
    statisticsType?: number;
    /**
     * 枚举类型名称
     */
    statisticsTypeName?: string;
    /**
     * 待审批总数
     */
    totalCount?: number;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [机构统计↗](http://yapi.cai-inc.com/project/3096/interface/api/358986) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [CommonController↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_36715)
 * @请求头 `POST /zlb/api/sop/common/org-form-statistics`
 * @更新时间 `2023-03-21 09:57:48`
 * @项目ID 3096
 */
type ZlbApiSopCommonOrgFormStatisticsPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/common/org-form-statistics',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [机构统计↗](http://yapi.cai-inc.com/project/3096/interface/api/358986) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [CommonController↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_36715)
 * @请求头 `POST /zlb/api/sop/common/org-form-statistics`
 * @更新时间 `2023-03-21 09:57:48`
 * @项目ID 3096
 */
const zlbApiSopCommonOrgFormStatisticsPostRequestConfig: ZlbApiSopCommonOrgFormStatisticsPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_0,
    devUrl: devUrl_0_2_0_0,
    prodUrl: prodUrl_0_2_0_0,
    path: '/zlb/api/sop/common/org-form-statistics',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopCommonOrgFormStatisticsPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [机构统计↗](http://yapi.cai-inc.com/project/3096/interface/api/358986) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [CommonController↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_36715)
 * @请求头 `POST /zlb/api/sop/common/org-form-statistics`
 * @更新时间 `2023-03-21 09:57:48`
 * @项目ID 3096
 */
export const zlbApiSopCommonOrgFormStatisticsPost = /*#__PURE__*/ (
  requestData: ZlbApiSopCommonOrgFormStatisticsPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopCommonOrgFormStatisticsPostResponse>(
    prepare(zlbApiSopCommonOrgFormStatisticsPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopCommonOrgFormStatisticsPost.requestConfig =
  zlbApiSopCommonOrgFormStatisticsPostRequestConfig;

/**
 * 接口 [approvalPendingCount↗](http://yapi.cai-inc.com/project/3096/interface/api/430578) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [CommonController↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_36715)
 * @请求头 `GET /zlb/api/sop/common/approval-pending-count`
 * @更新时间 `2023-03-21 09:57:48`
 * @项目ID 3096
 */
export interface ZlbApiSopCommonApprovalPendingCountGetRequest {}

/**
 * 接口 [approvalPendingCount↗](http://yapi.cai-inc.com/project/3096/interface/api/430578) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [CommonController↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_36715)
 * @请求头 `GET /zlb/api/sop/common/approval-pending-count`
 * @更新时间 `2023-03-21 09:57:48`
 * @项目ID 3096
 */
export interface ZlbApiSopCommonApprovalPendingCountGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: number;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [approvalPendingCount↗](http://yapi.cai-inc.com/project/3096/interface/api/430578) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [CommonController↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_36715)
 * @请求头 `GET /zlb/api/sop/common/approval-pending-count`
 * @更新时间 `2023-03-21 09:57:48`
 * @项目ID 3096
 */
type ZlbApiSopCommonApprovalPendingCountGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/common/approval-pending-count',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [approvalPendingCount↗](http://yapi.cai-inc.com/project/3096/interface/api/430578) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [CommonController↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_36715)
 * @请求头 `GET /zlb/api/sop/common/approval-pending-count`
 * @更新时间 `2023-03-21 09:57:48`
 * @项目ID 3096
 */
const zlbApiSopCommonApprovalPendingCountGetRequestConfig: ZlbApiSopCommonApprovalPendingCountGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_0,
    devUrl: devUrl_0_2_0_0,
    prodUrl: prodUrl_0_2_0_0,
    path: '/zlb/api/sop/common/approval-pending-count',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopCommonApprovalPendingCountGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [approvalPendingCount↗](http://yapi.cai-inc.com/project/3096/interface/api/430578) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [CommonController↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_36715)
 * @请求头 `GET /zlb/api/sop/common/approval-pending-count`
 * @更新时间 `2023-03-21 09:57:48`
 * @项目ID 3096
 */
export const zlbApiSopCommonApprovalPendingCountGet = /*#__PURE__*/ (
  requestData?: ZlbApiSopCommonApprovalPendingCountGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopCommonApprovalPendingCountGetResponse>(
    prepare(zlbApiSopCommonApprovalPendingCountGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopCommonApprovalPendingCountGet.requestConfig =
  zlbApiSopCommonApprovalPendingCountGetRequestConfig;

/**
 * 接口 [根据不同字典编码查询类型（多级，级联显示）↗](http://yapi.cai-inc.com/project/3096/interface/api/502146) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [CommonController↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_36715)
 * @请求头 `GET /zlb/api/sop/common/dic/getCatalog`
 * @更新时间 `2023-07-14 13:55:53`
 * @项目ID 3096
 */
export interface ZlbApiSopCommonDicGetCatalogGetRequest {
  /**
   * :CONTENT_TYPE(文章类型);
   */
  configCode?: string;
}

/**
 * 接口 [根据不同字典编码查询类型（多级，级联显示）↗](http://yapi.cai-inc.com/project/3096/interface/api/502146) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [CommonController↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_36715)
 * @请求头 `GET /zlb/api/sop/common/dic/getCatalog`
 * @更新时间 `2023-07-14 13:55:53`
 * @项目ID 3096
 */
export interface ZlbApiSopCommonDicGetCatalogGetResponse {
  success?: boolean;
  result?: {
    /**
     * code
     */
    typeCode?: string;
    /**
     * 类型名称
     */
    typeName?: string;
    /**
     * 父code
     */
    parentTypeCode?: string;
    /**
     * 子目录
     */
    children?: {
      /**
       * code
       */
      typeCode?: string;
      /**
       * 类型名称
       */
      typeName?: string;
      /**
       * 父code
       */
      parentTypeCode?: string;
      /**
       * 子目录
       */
      children?: {}[];
    }[];
  }[];
  code?: string;
  message?: string;
}

/**
 * 接口 [根据不同字典编码查询类型（多级，级联显示）↗](http://yapi.cai-inc.com/project/3096/interface/api/502146) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [CommonController↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_36715)
 * @请求头 `GET /zlb/api/sop/common/dic/getCatalog`
 * @更新时间 `2023-07-14 13:55:53`
 * @项目ID 3096
 */
type ZlbApiSopCommonDicGetCatalogGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/common/dic/getCatalog',
    'data',
    string,
    'configCode',
    false
  >
>;

/**
 * 接口 [根据不同字典编码查询类型（多级，级联显示）↗](http://yapi.cai-inc.com/project/3096/interface/api/502146) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [CommonController↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_36715)
 * @请求头 `GET /zlb/api/sop/common/dic/getCatalog`
 * @更新时间 `2023-07-14 13:55:53`
 * @项目ID 3096
 */
const zlbApiSopCommonDicGetCatalogGetRequestConfig: ZlbApiSopCommonDicGetCatalogGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_0,
    devUrl: devUrl_0_2_0_0,
    prodUrl: prodUrl_0_2_0_0,
    path: '/zlb/api/sop/common/dic/getCatalog',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_0,
    paramNames: [],
    queryNames: ['configCode'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopCommonDicGetCatalogGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [根据不同字典编码查询类型（多级，级联显示）↗](http://yapi.cai-inc.com/project/3096/interface/api/502146) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [CommonController↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_36715)
 * @请求头 `GET /zlb/api/sop/common/dic/getCatalog`
 * @更新时间 `2023-07-14 13:55:53`
 * @项目ID 3096
 */
export const zlbApiSopCommonDicGetCatalogGet = /*#__PURE__*/ (
  requestData: ZlbApiSopCommonDicGetCatalogGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopCommonDicGetCatalogGetResponse>(
    prepare(zlbApiSopCommonDicGetCatalogGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopCommonDicGetCatalogGet.requestConfig = zlbApiSopCommonDicGetCatalogGetRequestConfig;

const mockUrl_0_2_0_1 = 'http://yapi.cai-inc.com/mock/3096' as any;
const devUrl_0_2_0_1 = '' as any;
const prodUrl_0_2_0_1 = '' as any;
const dataKey_0_2_0_1 = 'data' as any;

/**
 * 接口 [保存↗](http://yapi.cai-inc.com/project/3096/interface/api/274026) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [公告通知↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_47949)
 * @请求头 `POST /zlb/api/sop/notice/save`
 * @更新时间 `2023-07-18 11:49:10`
 * @项目ID 3096
 */
export interface ZlbApiSopNoticeSavePostRequest {
  /**
   * 接收范围类型 1、按租户 2、按机构
   */
  rangeType: number;
  /**
   * 接收范围
   * 区划或机构
   */
  rangeInfoList: {
    /**
     * 权限code （租户or机构）
     */
    rangeCode: string;
    /**
     * 权限名称 （租户or机构）
     */
    rangeName: string;
  }[];
  /**
   * 状态： 0:禁用 1:启用
   */
  status: number;
  /**
   * 排序
   */
  sort: number;
  /**
   * 公告通知唯一code
   */
  noticeCode?: string;
  /**
   * 公告通知类型 1：图片弹窗 2：系统公告-版本更新 3：系统公告-紧急通知 4、系统公告-营销活动
   */
  noticeType: 1 | 2 | 3 | 4;
  /**
   * 通知弹窗标题
   */
  noticeTitle: string;
  /**
   * 通知弹窗内容
   */
  noticeContent?: string;
  /**
   * 弹窗位置 1、用户端 2、区划后台 3、运营后台
   */
  noticeLocation?: number;
  /**
   * 关联内容类型 0：链接
   */
  linkContentType?: number;
  /**
   * 生效开始时间 时间戳
   */
  effectiveStartTime?: string;
  /**
   * 生效结束时间 时间戳
   */
  effectiveEndTime?: string;
  /**
   * 弹窗频率 1：每日一次 2：每周一次
   */
  noticeFreq?: number;
  /**
   * 扩展字段
   */
  extendInfo?: string;
  /**
   * 附件图片列表
   */
  files?: {
    /**
     * 附件OSSId
     */
    fileId?: string;
    /**
     * 附件名称
     */
    name?: string;
    /**
     * 附件大小
     */
    size?: number;
    /**
     * 附件格式
     */
    type?: string;
    /**
     * 附件地址
     */
    url?: string;
    /**
     * 附件类型：1-封面图，2-附件 3-公告图
     */
    bizType?: number;
    /**
     * 业务子类型 1-PC 2-APP
     */
    subType?: 1 | 2;
  }[];
  /**
   * 链接地址
   */
  noticeLink?: {
    /**
     * APP
     */
    appLink?: string;
    /**
     * PC
     */
    pcLink?: string;
  };
}

/**
 * 接口 [保存↗](http://yapi.cai-inc.com/project/3096/interface/api/274026) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [公告通知↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_47949)
 * @请求头 `POST /zlb/api/sop/notice/save`
 * @更新时间 `2023-07-18 11:49:10`
 * @项目ID 3096
 */
export interface ZlbApiSopNoticeSavePostResponse {
  success?: boolean;
  result?: boolean;
  code?: string;
  message?: string;
}

/**
 * 接口 [保存↗](http://yapi.cai-inc.com/project/3096/interface/api/274026) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [公告通知↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_47949)
 * @请求头 `POST /zlb/api/sop/notice/save`
 * @更新时间 `2023-07-18 11:49:10`
 * @项目ID 3096
 */
type ZlbApiSopNoticeSavePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/notice/save',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [保存↗](http://yapi.cai-inc.com/project/3096/interface/api/274026) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [公告通知↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_47949)
 * @请求头 `POST /zlb/api/sop/notice/save`
 * @更新时间 `2023-07-18 11:49:10`
 * @项目ID 3096
 */
const zlbApiSopNoticeSavePostRequestConfig: ZlbApiSopNoticeSavePostRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_2_0_1,
  devUrl: devUrl_0_2_0_1,
  prodUrl: prodUrl_0_2_0_1,
  path: '/zlb/api/sop/notice/save',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_2_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'zlbApiSopNoticeSavePost',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 [保存↗](http://yapi.cai-inc.com/project/3096/interface/api/274026) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [公告通知↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_47949)
 * @请求头 `POST /zlb/api/sop/notice/save`
 * @更新时间 `2023-07-18 11:49:10`
 * @项目ID 3096
 */
export const zlbApiSopNoticeSavePost = /*#__PURE__*/ (
  requestData: ZlbApiSopNoticeSavePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopNoticeSavePostResponse>(
    prepare(zlbApiSopNoticeSavePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopNoticeSavePost.requestConfig = zlbApiSopNoticeSavePostRequestConfig;

/**
 * 接口 [查看详情↗](http://yapi.cai-inc.com/project/3096/interface/api/274034) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [公告通知↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_47949)
 * @请求头 `GET /zlb/api/sop/notice/{noticeCode}`
 * @更新时间 `2023-07-18 11:49:10`
 * @项目ID 3096
 */
export interface ZlbApiSopNoticeNoticeCodeGetRequest {
  /**
   * 公告通知code唯一编码
   */
  noticeCode: string;
}

/**
 * 接口 [查看详情↗](http://yapi.cai-inc.com/project/3096/interface/api/274034) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [公告通知↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_47949)
 * @请求头 `GET /zlb/api/sop/notice/{noticeCode}`
 * @更新时间 `2023-07-18 11:49:10`
 * @项目ID 3096
 */
export interface ZlbApiSopNoticeNoticeCodeGetResponse {
  success?: boolean;
  result?: {
    /**
     * 状态： 0:启用 1:禁用
     */
    statusDesc?: string;
    status?: number;
    /**
     * 接收范围类型 1、按区划 2、按机构
     */
    rangeType?: number;
    /**
     * 接收范围类型 1、按区划 2、按机构
     */
    rangeTypeDesc?: string;
    /**
     * 区划或机构
     */
    rangeInfoList?: {
      /**
       * 权限code （租户or机构）
       */
      rangeCode: string;
      /**
       * 权限名称 （租户or机构）
       */
      rangeName: string;
    }[];
    /**
     * 排序
     */
    sort?: number;
    /**
     * 公告通知唯一code
     */
    noticeCode?: string;
    /**
     * 公告通知类型 1：图片 2：文字
     */
    noticeType?: number;
    /**
     * 弹窗位置
     */
    noticeLocation?: number;
    /**
     * 通知弹窗标题
     */
    noticeTitle?: string;
    /**
     * 通知弹窗内容
     */
    noticeContent?: string;
    /**
     * 关联内容类型 0：数据排行
     */
    linkContentType?: number;
    /**
     * 关联内容设置 0:区划数据排行
     */
    linkContentSettings?: number;
    /**
     * 生效开始时间
     */
    effectiveStartTime?: string;
    /**
     * 生效结束时间
     */
    effectiveEndTime?: string;
    /**
     * 弹窗频率 1：每日一次 2：每周一次
     */
    noticeFreq?: number;
    /**
     * 扩展字段
     */
    extendInfo?: string;
    /**
     * 附件图片列表
     */
    files?: {
      /**
       * 附件OSSId
       */
      fileId?: string;
      /**
       * 附件名称
       */
      name?: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 附件格式
       */
      type?: string;
      /**
       * url
       */
      url?: string;
      /**
       * 文件类型 1-标题图片，2-附件
       */
      bizType?: number;
      /**
       * 子业务类型 1-pc   2-app
       */
      subType?: number;
    }[];
    noticeLink?: {
      /**
       * APP
       */
      appLink?: string;
      /**
       * PC
       */
      pcLink?: string;
    };
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [查看详情↗](http://yapi.cai-inc.com/project/3096/interface/api/274034) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [公告通知↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_47949)
 * @请求头 `GET /zlb/api/sop/notice/{noticeCode}`
 * @更新时间 `2023-07-18 11:49:10`
 * @项目ID 3096
 */
type ZlbApiSopNoticeNoticeCodeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/notice/{noticeCode}',
    'data',
    'noticeCode',
    string,
    false
  >
>;

/**
 * 接口 [查看详情↗](http://yapi.cai-inc.com/project/3096/interface/api/274034) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [公告通知↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_47949)
 * @请求头 `GET /zlb/api/sop/notice/{noticeCode}`
 * @更新时间 `2023-07-18 11:49:10`
 * @项目ID 3096
 */
const zlbApiSopNoticeNoticeCodeGetRequestConfig: ZlbApiSopNoticeNoticeCodeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_1,
    devUrl: devUrl_0_2_0_1,
    prodUrl: prodUrl_0_2_0_1,
    path: '/zlb/api/sop/notice/{noticeCode}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_1,
    paramNames: ['noticeCode'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopNoticeNoticeCodeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查看详情↗](http://yapi.cai-inc.com/project/3096/interface/api/274034) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [公告通知↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_47949)
 * @请求头 `GET /zlb/api/sop/notice/{noticeCode}`
 * @更新时间 `2023-07-18 11:49:10`
 * @项目ID 3096
 */
export const zlbApiSopNoticeNoticeCodeGet = /*#__PURE__*/ (
  requestData: ZlbApiSopNoticeNoticeCodeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopNoticeNoticeCodeGetResponse>(
    prepare(zlbApiSopNoticeNoticeCodeGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopNoticeNoticeCodeGet.requestConfig = zlbApiSopNoticeNoticeCodeGetRequestConfig;

/**
 * 接口 [删除↗](http://yapi.cai-inc.com/project/3096/interface/api/274058) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [公告通知↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_47949)
 * @请求头 `DELETE /zlb/api/sop/notice/delete/{noticeCode}`
 * @更新时间 `2023-07-18 11:49:10`
 * @项目ID 3096
 */
export interface ZlbApiSopNoticeDeleteNoticeCodeDeleteRequest {
  /**
   * 公告通知code唯一编码
   */
  noticeCode: string;
}

/**
 * 接口 [删除↗](http://yapi.cai-inc.com/project/3096/interface/api/274058) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [公告通知↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_47949)
 * @请求头 `DELETE /zlb/api/sop/notice/delete/{noticeCode}`
 * @更新时间 `2023-07-18 11:49:10`
 * @项目ID 3096
 */
export interface ZlbApiSopNoticeDeleteNoticeCodeDeleteResponse {
  success?: boolean;
  result?: boolean;
  code?: string;
  message?: string;
}

/**
 * 接口 [删除↗](http://yapi.cai-inc.com/project/3096/interface/api/274058) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [公告通知↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_47949)
 * @请求头 `DELETE /zlb/api/sop/notice/delete/{noticeCode}`
 * @更新时间 `2023-07-18 11:49:10`
 * @项目ID 3096
 */
type ZlbApiSopNoticeDeleteNoticeCodeDeleteRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/notice/delete/{noticeCode}',
    'data',
    'noticeCode',
    string,
    false
  >
>;

/**
 * 接口 [删除↗](http://yapi.cai-inc.com/project/3096/interface/api/274058) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [公告通知↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_47949)
 * @请求头 `DELETE /zlb/api/sop/notice/delete/{noticeCode}`
 * @更新时间 `2023-07-18 11:49:10`
 * @项目ID 3096
 */
const zlbApiSopNoticeDeleteNoticeCodeDeleteRequestConfig: ZlbApiSopNoticeDeleteNoticeCodeDeleteRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_1,
    devUrl: devUrl_0_2_0_1,
    prodUrl: prodUrl_0_2_0_1,
    path: '/zlb/api/sop/notice/delete/{noticeCode}',
    method: Method.DELETE,
    requestHeaders: {},
    requestBodyType: RequestBodyType.none,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_1,
    paramNames: ['noticeCode'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopNoticeDeleteNoticeCodeDelete',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [删除↗](http://yapi.cai-inc.com/project/3096/interface/api/274058) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [公告通知↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_47949)
 * @请求头 `DELETE /zlb/api/sop/notice/delete/{noticeCode}`
 * @更新时间 `2023-07-18 11:49:10`
 * @项目ID 3096
 */
export const zlbApiSopNoticeDeleteNoticeCodeDelete = /*#__PURE__*/ (
  requestData: ZlbApiSopNoticeDeleteNoticeCodeDeleteRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopNoticeDeleteNoticeCodeDeleteResponse>(
    prepare(zlbApiSopNoticeDeleteNoticeCodeDeleteRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopNoticeDeleteNoticeCodeDelete.requestConfig =
  zlbApiSopNoticeDeleteNoticeCodeDeleteRequestConfig;

/**
 * 接口 [查询通知列表（分页） 运营侧↗](http://yapi.cai-inc.com/project/3096/interface/api/274066) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [公告通知↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_47949)
 * @请求头 `POST /zlb/api/sop/notice/list`
 * @更新时间 `2023-07-18 11:49:11`
 * @项目ID 3096
 */
export interface ZlbApiSopNoticeListPostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 接收范围类型 1、按区划 2、按机构
   */
  rangeType?: number;
  /**
   * 区划或机构
   */
  rangeContent?: string;
  /**
   * 状态： 0:启用 1:禁用
   */
  status?: number;
  /**
   * 租户code
   */
  tenantCode?: string;
  /**
   * 通知弹窗标题
   */
  noticeTitle?: string;
  /**
   * 数据来源： 1:运营后台 1:治理端
   */
  dataSource?: number[];
}

/**
 * 接口 [查询通知列表（分页） 运营侧↗](http://yapi.cai-inc.com/project/3096/interface/api/274066) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [公告通知↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_47949)
 * @请求头 `POST /zlb/api/sop/notice/list`
 * @更新时间 `2023-07-18 11:49:11`
 * @项目ID 3096
 */
export interface ZlbApiSopNoticeListPostResponse {
  success?: boolean;
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 状态： 0:启用 1:禁用
       */
      statusDesc?: string;
      status?: number;
      /**
       * 接收范围类型 1、按区划 2、按机构
       */
      rangeType?: number;
      /**
       * 接收范围类型 1、按区划 2、按机构
       */
      rangeTypeDesc?: string;
      /**
       * 区划或机构
       */
      rangeInfoList?: {
        /**
         * 权限code （租户or机构）
         */
        rangeCode: string;
        /**
         * 权限名称 （租户or机构）
         */
        rangeName: string;
      }[];
      /**
       * 排序
       */
      sort?: number;
      /**
       * 公告通知唯一code
       */
      noticeCode?: string;
      /**
       * 通知弹窗标题
       */
      noticeTitle?: string;
      /**
       * 通知弹窗内容
       */
      noticeContent?: string;
      noticeLocation?: number;
      /**
       * 通知弹窗类型
       */
      noticeType?: number;
      /**
       * 通知弹窗类型
       */
      noticeTypeName?: string;
      /**
       * 生效开始时间 时间戳
       */
      effectiveStartTime?: string;
      /**
       * 生效结束时间 时间戳
       */
      effectiveEndTime?: string;
      /**
       * 弹窗频率 1：每日一次 2：每周一次
       */
      noticeFreqName?: string;
      /**
       * 附件图片列表
       */
      files?: {
        /**
         * 附件OSSId
         */
        fileId?: string;
        /**
         * 附件名称
         */
        name?: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 附件格式
         */
        type?: string;
        /**
         * url
         */
        url?: string;
        /**
         * 文件类型 1-标题图片，2-附件
         */
        bizType?: number;
        /**
         * 子业务类型 1-pc   2-app
         */
        subType?: number;
      }[];
      /**
       * 链接地址
       */
      noticeLink?: {
        /**
         * APP
         */
        appLink?: string;
        /**
         * PC
         */
        pcLink?: string;
      };
      /**
       * 数据来源： 1:运营后台 1:治理端
       */
      dataSource?: number;
      /**
       * 数据来源描述： 1:运营后台 1:治理端
       */
      dataSourceDesc?: string;
    }[];
    /**
     * 第几页
     */
    pageNum?: number;
    /**
     * 每页记录数
     */
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 当前页的数量 <= pageSize，该属性来自ArrayList的size属性
     */
    size?: number;
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [查询通知列表（分页） 运营侧↗](http://yapi.cai-inc.com/project/3096/interface/api/274066) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [公告通知↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_47949)
 * @请求头 `POST /zlb/api/sop/notice/list`
 * @更新时间 `2023-07-18 11:49:11`
 * @项目ID 3096
 */
type ZlbApiSopNoticeListPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/notice/list',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [查询通知列表（分页） 运营侧↗](http://yapi.cai-inc.com/project/3096/interface/api/274066) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [公告通知↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_47949)
 * @请求头 `POST /zlb/api/sop/notice/list`
 * @更新时间 `2023-07-18 11:49:11`
 * @项目ID 3096
 */
const zlbApiSopNoticeListPostRequestConfig: ZlbApiSopNoticeListPostRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_2_0_1,
  devUrl: devUrl_0_2_0_1,
  prodUrl: prodUrl_0_2_0_1,
  path: '/zlb/api/sop/notice/list',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_2_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'zlbApiSopNoticeListPost',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 [查询通知列表（分页） 运营侧↗](http://yapi.cai-inc.com/project/3096/interface/api/274066) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [公告通知↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_47949)
 * @请求头 `POST /zlb/api/sop/notice/list`
 * @更新时间 `2023-07-18 11:49:11`
 * @项目ID 3096
 */
export const zlbApiSopNoticeListPost = /*#__PURE__*/ (
  requestData: ZlbApiSopNoticeListPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopNoticeListPostResponse>(
    prepare(zlbApiSopNoticeListPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopNoticeListPost.requestConfig = zlbApiSopNoticeListPostRequestConfig;

/**
 * 接口 [弹出公告（此公告会根据条件和操作人进行展示）↗](http://yapi.cai-inc.com/project/3096/interface/api/275890) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [公告通知↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_47949)
 * @请求头 `GET /zlb/api/sop/notice/showNotice`
 * @更新时间 `2023-07-18 11:49:11`
 * @项目ID 3096
 */
export interface ZlbApiSopNoticeShowNoticeGetRequest {
  /**
   * 区划code
   */
  tenantCode: string;
  /**
   * 机构orgId
   */
  orgId: string;
}

/**
 * 接口 [弹出公告（此公告会根据条件和操作人进行展示）↗](http://yapi.cai-inc.com/project/3096/interface/api/275890) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [公告通知↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_47949)
 * @请求头 `GET /zlb/api/sop/notice/showNotice`
 * @更新时间 `2023-07-18 11:49:11`
 * @项目ID 3096
 */
export interface ZlbApiSopNoticeShowNoticeGetResponse {
  success?: boolean;
  result?: {
    /**
     * 状态： 0:启用 1:禁用
     */
    statusDesc?: string;
    status?: number;
    /**
     * 接收范围类型 1、按区划 2、按机构
     */
    rangeType?: number;
    /**
     * 接收范围类型 1、按区划 2、按机构
     */
    rangeTypeDesc?: string;
    /**
     * 区划或机构
     */
    rangeInfoList?: {
      /**
       * 权限code （租户or机构）
       */
      rangeCode: string;
      /**
       * 权限名称 （租户or机构）
       */
      rangeName: string;
    }[];
    /**
     * 排序
     */
    sort?: number;
    /**
     * 公告通知唯一code
     */
    noticeCode?: string;
    /**
     * 通知弹窗标题
     */
    noticeTitle?: string;
    /**
     * 通知弹窗内容
     */
    noticeContent?: string;
    noticeLocation?: number;
    /**
     * 通知弹窗类型
     */
    noticeType?: number;
    /**
     * 通知弹窗类型
     */
    noticeTypeName?: string;
    /**
     * 生效开始时间 时间戳
     */
    effectiveStartTime?: string;
    /**
     * 生效结束时间 时间戳
     */
    effectiveEndTime?: string;
    /**
     * 弹窗频率 1：每日一次 2：每周一次
     */
    noticeFreqName?: string;
    /**
     * 附件图片列表
     */
    files?: {
      /**
       * 附件OSSId
       */
      fileId?: string;
      /**
       * 附件名称
       */
      name?: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 附件格式
       */
      type?: string;
      /**
       * url
       */
      url?: string;
      /**
       * 文件类型 1-标题图片，2-附件
       */
      bizType?: number;
      /**
       * 子业务类型 1-pc   2-app
       */
      subType?: number;
    }[];
    /**
     * 链接地址
     */
    noticeLink?: {
      /**
       * APP
       */
      appLink?: string;
      /**
       * PC
       */
      pcLink?: string;
    };
    /**
     * 数据来源： 1:运营后台 1:治理端
     */
    dataSource?: number;
    /**
     * 数据来源描述： 1:运营后台 1:治理端
     */
    dataSourceDesc?: string;
  }[];
  code?: string;
  message?: string;
}

/**
 * 接口 [弹出公告（此公告会根据条件和操作人进行展示）↗](http://yapi.cai-inc.com/project/3096/interface/api/275890) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [公告通知↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_47949)
 * @请求头 `GET /zlb/api/sop/notice/showNotice`
 * @更新时间 `2023-07-18 11:49:11`
 * @项目ID 3096
 */
type ZlbApiSopNoticeShowNoticeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/notice/showNotice',
    'data',
    string,
    'tenantCode' | 'orgId',
    false
  >
>;

/**
 * 接口 [弹出公告（此公告会根据条件和操作人进行展示）↗](http://yapi.cai-inc.com/project/3096/interface/api/275890) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [公告通知↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_47949)
 * @请求头 `GET /zlb/api/sop/notice/showNotice`
 * @更新时间 `2023-07-18 11:49:11`
 * @项目ID 3096
 */
const zlbApiSopNoticeShowNoticeGetRequestConfig: ZlbApiSopNoticeShowNoticeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_1,
    devUrl: devUrl_0_2_0_1,
    prodUrl: prodUrl_0_2_0_1,
    path: '/zlb/api/sop/notice/showNotice',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_1,
    paramNames: [],
    queryNames: ['tenantCode', 'orgId'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopNoticeShowNoticeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [弹出公告（此公告会根据条件和操作人进行展示）↗](http://yapi.cai-inc.com/project/3096/interface/api/275890) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [公告通知↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_47949)
 * @请求头 `GET /zlb/api/sop/notice/showNotice`
 * @更新时间 `2023-07-18 11:49:11`
 * @项目ID 3096
 */
export const zlbApiSopNoticeShowNoticeGet = /*#__PURE__*/ (
  requestData: ZlbApiSopNoticeShowNoticeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopNoticeShowNoticeGetResponse>(
    prepare(zlbApiSopNoticeShowNoticeGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopNoticeShowNoticeGet.requestConfig = zlbApiSopNoticeShowNoticeGetRequestConfig;

/**
 * 接口 [公告通知确认已阅↗](http://yapi.cai-inc.com/project/3096/interface/api/294994) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [公告通知↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_47949)
 * @请求头 `PUT /zlb/api/sop/notice/confirmRead/{noticeCode}`
 * @更新时间 `2022-08-25 10:35:18`
 * @项目ID 3096
 */
export interface ZlbApiSopNoticeConfirmReadNoticeCodePutRequest {
  /**
   * 公告通知唯一编码
   */
  noticeCode: string;
}

/**
 * 接口 [公告通知确认已阅↗](http://yapi.cai-inc.com/project/3096/interface/api/294994) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [公告通知↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_47949)
 * @请求头 `PUT /zlb/api/sop/notice/confirmRead/{noticeCode}`
 * @更新时间 `2022-08-25 10:35:18`
 * @项目ID 3096
 */
export interface ZlbApiSopNoticeConfirmReadNoticeCodePutResponse {
  success?: boolean;
  result?: boolean;
  code?: string;
  message?: string;
}

/**
 * 接口 [公告通知确认已阅↗](http://yapi.cai-inc.com/project/3096/interface/api/294994) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [公告通知↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_47949)
 * @请求头 `PUT /zlb/api/sop/notice/confirmRead/{noticeCode}`
 * @更新时间 `2022-08-25 10:35:18`
 * @项目ID 3096
 */
type ZlbApiSopNoticeConfirmReadNoticeCodePutRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/notice/confirmRead/{noticeCode}',
    'data',
    'noticeCode',
    string,
    false
  >
>;

/**
 * 接口 [公告通知确认已阅↗](http://yapi.cai-inc.com/project/3096/interface/api/294994) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [公告通知↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_47949)
 * @请求头 `PUT /zlb/api/sop/notice/confirmRead/{noticeCode}`
 * @更新时间 `2022-08-25 10:35:18`
 * @项目ID 3096
 */
const zlbApiSopNoticeConfirmReadNoticeCodePutRequestConfig: ZlbApiSopNoticeConfirmReadNoticeCodePutRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_1,
    devUrl: devUrl_0_2_0_1,
    prodUrl: prodUrl_0_2_0_1,
    path: '/zlb/api/sop/notice/confirmRead/{noticeCode}',
    method: Method.PUT,
    requestHeaders: {},
    requestBodyType: RequestBodyType.none,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_1,
    paramNames: ['noticeCode'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopNoticeConfirmReadNoticeCodePut',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [公告通知确认已阅↗](http://yapi.cai-inc.com/project/3096/interface/api/294994) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [公告通知↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_47949)
 * @请求头 `PUT /zlb/api/sop/notice/confirmRead/{noticeCode}`
 * @更新时间 `2022-08-25 10:35:18`
 * @项目ID 3096
 */
export const zlbApiSopNoticeConfirmReadNoticeCodePut = /*#__PURE__*/ (
  requestData: ZlbApiSopNoticeConfirmReadNoticeCodePutRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopNoticeConfirmReadNoticeCodePutResponse>(
    prepare(zlbApiSopNoticeConfirmReadNoticeCodePutRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopNoticeConfirmReadNoticeCodePut.requestConfig =
  zlbApiSopNoticeConfirmReadNoticeCodePutRequestConfig;

/**
 * 接口 [公告通知确认已阅↗](http://yapi.cai-inc.com/project/3096/interface/api/295538) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [公告通知↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_47949)
 * @请求头 `POST /zlb/api/sop/notice/confirmRead/{noticeCode}`
 * @更新时间 `2023-07-18 11:49:11`
 * @项目ID 3096
 */
export interface ZlbApiSopNoticeConfirmReadNoticeCodePostRequest {
  /**
   * 公告通知唯一编码
   */
  noticeCode: string;
}

/**
 * 接口 [公告通知确认已阅↗](http://yapi.cai-inc.com/project/3096/interface/api/295538) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [公告通知↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_47949)
 * @请求头 `POST /zlb/api/sop/notice/confirmRead/{noticeCode}`
 * @更新时间 `2023-07-18 11:49:11`
 * @项目ID 3096
 */
export interface ZlbApiSopNoticeConfirmReadNoticeCodePostResponse {
  success?: boolean;
  result?: boolean;
  code?: string;
  message?: string;
}

/**
 * 接口 [公告通知确认已阅↗](http://yapi.cai-inc.com/project/3096/interface/api/295538) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [公告通知↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_47949)
 * @请求头 `POST /zlb/api/sop/notice/confirmRead/{noticeCode}`
 * @更新时间 `2023-07-18 11:49:11`
 * @项目ID 3096
 */
type ZlbApiSopNoticeConfirmReadNoticeCodePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/notice/confirmRead/{noticeCode}',
    'data',
    'noticeCode',
    string,
    false
  >
>;

/**
 * 接口 [公告通知确认已阅↗](http://yapi.cai-inc.com/project/3096/interface/api/295538) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [公告通知↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_47949)
 * @请求头 `POST /zlb/api/sop/notice/confirmRead/{noticeCode}`
 * @更新时间 `2023-07-18 11:49:11`
 * @项目ID 3096
 */
const zlbApiSopNoticeConfirmReadNoticeCodePostRequestConfig: ZlbApiSopNoticeConfirmReadNoticeCodePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_1,
    devUrl: devUrl_0_2_0_1,
    prodUrl: prodUrl_0_2_0_1,
    path: '/zlb/api/sop/notice/confirmRead/{noticeCode}',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.none,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_1,
    paramNames: ['noticeCode'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopNoticeConfirmReadNoticeCodePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [公告通知确认已阅↗](http://yapi.cai-inc.com/project/3096/interface/api/295538) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [公告通知↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_47949)
 * @请求头 `POST /zlb/api/sop/notice/confirmRead/{noticeCode}`
 * @更新时间 `2023-07-18 11:49:11`
 * @项目ID 3096
 */
export const zlbApiSopNoticeConfirmReadNoticeCodePost = /*#__PURE__*/ (
  requestData: ZlbApiSopNoticeConfirmReadNoticeCodePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopNoticeConfirmReadNoticeCodePostResponse>(
    prepare(zlbApiSopNoticeConfirmReadNoticeCodePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopNoticeConfirmReadNoticeCodePost.requestConfig =
  zlbApiSopNoticeConfirmReadNoticeCodePostRequestConfig;

const mockUrl_0_2_0_2 = 'http://yapi.cai-inc.com/mock/3096' as any;
const devUrl_0_2_0_2 = '' as any;
const prodUrl_0_2_0_2 = '' as any;
const dataKey_0_2_0_2 = 'data' as any;

/**
 * 接口 [查询配置↗](http://yapi.cai-inc.com/project/3096/interface/api/473786) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [巡检配置相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51963)
 * @请求头 `GET /zlb/api/sop/inspection/config/query-application`
 * @更新时间 `2023-06-05 11:04:50`
 * @项目ID 3096
 */
export interface ZlbApiSopInspectionConfigQueryApplicationGetRequest {
  districtCode?: string;
}

/**
 * 接口 [查询配置↗](http://yapi.cai-inc.com/project/3096/interface/api/473786) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [巡检配置相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51963)
 * @请求头 `GET /zlb/api/sop/inspection/config/query-application`
 * @更新时间 `2023-06-05 11:04:50`
 * @项目ID 3096
 */
export interface ZlbApiSopInspectionConfigQueryApplicationGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 开启状态（0：关闭，1：开启）
     */
    status?: number;
    /**
     * 版本（0：试用版，1：正式版）
     */
    version?: number;
    /**
     * 开始时间
     */
    starTime?: string;
    /**
     * 结束时间
     */
    endTime?: string;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询配置↗](http://yapi.cai-inc.com/project/3096/interface/api/473786) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [巡检配置相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51963)
 * @请求头 `GET /zlb/api/sop/inspection/config/query-application`
 * @更新时间 `2023-06-05 11:04:50`
 * @项目ID 3096
 */
type ZlbApiSopInspectionConfigQueryApplicationGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/inspection/config/query-application',
    'data',
    string,
    'districtCode',
    false
  >
>;

/**
 * 接口 [查询配置↗](http://yapi.cai-inc.com/project/3096/interface/api/473786) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [巡检配置相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51963)
 * @请求头 `GET /zlb/api/sop/inspection/config/query-application`
 * @更新时间 `2023-06-05 11:04:50`
 * @项目ID 3096
 */
const zlbApiSopInspectionConfigQueryApplicationGetRequestConfig: ZlbApiSopInspectionConfigQueryApplicationGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_2,
    devUrl: devUrl_0_2_0_2,
    prodUrl: prodUrl_0_2_0_2,
    path: '/zlb/api/sop/inspection/config/query-application',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_2,
    paramNames: [],
    queryNames: ['districtCode'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopInspectionConfigQueryApplicationGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询配置↗](http://yapi.cai-inc.com/project/3096/interface/api/473786) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [巡检配置相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51963)
 * @请求头 `GET /zlb/api/sop/inspection/config/query-application`
 * @更新时间 `2023-06-05 11:04:50`
 * @项目ID 3096
 */
export const zlbApiSopInspectionConfigQueryApplicationGet = /*#__PURE__*/ (
  requestData: ZlbApiSopInspectionConfigQueryApplicationGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopInspectionConfigQueryApplicationGetResponse>(
    prepare(zlbApiSopInspectionConfigQueryApplicationGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopInspectionConfigQueryApplicationGet.requestConfig =
  zlbApiSopInspectionConfigQueryApplicationGetRequestConfig;

/**
 * 接口 [编辑配置↗](http://yapi.cai-inc.com/project/3096/interface/api/473794) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [巡检配置相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51963)
 * @请求头 `POST /zlb/api/sop/inspection/config/update-application`
 * @更新时间 `2023-06-05 11:04:50`
 * @项目ID 3096
 */
export interface ZlbApiSopInspectionConfigUpdateApplicationPostRequest {
  /**
   * 区划code
   */
  districtCode: string;
  /**
   * 开启状态（0：关闭，1：开启）
   */
  status: number;
  /**
   * 版本（0：试用版，1：正式版）
   */
  version?: number;
  /**
   * 开始时间
   */
  starTime?: string;
  /**
   * 结束时间
   */
  endTime?: string;
}

/**
 * 接口 [编辑配置↗](http://yapi.cai-inc.com/project/3096/interface/api/473794) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [巡检配置相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51963)
 * @请求头 `POST /zlb/api/sop/inspection/config/update-application`
 * @更新时间 `2023-06-05 11:04:50`
 * @项目ID 3096
 */
export interface ZlbApiSopInspectionConfigUpdateApplicationPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [编辑配置↗](http://yapi.cai-inc.com/project/3096/interface/api/473794) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [巡检配置相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51963)
 * @请求头 `POST /zlb/api/sop/inspection/config/update-application`
 * @更新时间 `2023-06-05 11:04:50`
 * @项目ID 3096
 */
type ZlbApiSopInspectionConfigUpdateApplicationPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/inspection/config/update-application',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [编辑配置↗](http://yapi.cai-inc.com/project/3096/interface/api/473794) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [巡检配置相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51963)
 * @请求头 `POST /zlb/api/sop/inspection/config/update-application`
 * @更新时间 `2023-06-05 11:04:50`
 * @项目ID 3096
 */
const zlbApiSopInspectionConfigUpdateApplicationPostRequestConfig: ZlbApiSopInspectionConfigUpdateApplicationPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_2,
    devUrl: devUrl_0_2_0_2,
    prodUrl: prodUrl_0_2_0_2,
    path: '/zlb/api/sop/inspection/config/update-application',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopInspectionConfigUpdateApplicationPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [编辑配置↗](http://yapi.cai-inc.com/project/3096/interface/api/473794) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [巡检配置相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51963)
 * @请求头 `POST /zlb/api/sop/inspection/config/update-application`
 * @更新时间 `2023-06-05 11:04:50`
 * @项目ID 3096
 */
export const zlbApiSopInspectionConfigUpdateApplicationPost = /*#__PURE__*/ (
  requestData: ZlbApiSopInspectionConfigUpdateApplicationPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopInspectionConfigUpdateApplicationPostResponse>(
    prepare(zlbApiSopInspectionConfigUpdateApplicationPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopInspectionConfigUpdateApplicationPost.requestConfig =
  zlbApiSopInspectionConfigUpdateApplicationPostRequestConfig;

/**
 * 接口 [编辑巡检报告通知配置↗](http://yapi.cai-inc.com/project/3096/interface/api/473802) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [巡检配置相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51963)
 * @请求头 `POST /zlb/api/sop/inspection/config/update-alert`
 * @更新时间 `2023-06-05 11:04:50`
 * @项目ID 3096
 */
export interface ZlbApiSopInspectionConfigUpdateAlertPostRequest {
  /**
   * 配置key
   */
  configKey: string;
  /**
   * 区划code
   */
  districtCode: string;
  /**
   * 通知人员OperatorId
   */
  operatorIdList: number[];
}

/**
 * 接口 [编辑巡检报告通知配置↗](http://yapi.cai-inc.com/project/3096/interface/api/473802) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [巡检配置相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51963)
 * @请求头 `POST /zlb/api/sop/inspection/config/update-alert`
 * @更新时间 `2023-06-05 11:04:50`
 * @项目ID 3096
 */
export interface ZlbApiSopInspectionConfigUpdateAlertPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [编辑巡检报告通知配置↗](http://yapi.cai-inc.com/project/3096/interface/api/473802) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [巡检配置相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51963)
 * @请求头 `POST /zlb/api/sop/inspection/config/update-alert`
 * @更新时间 `2023-06-05 11:04:50`
 * @项目ID 3096
 */
type ZlbApiSopInspectionConfigUpdateAlertPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/inspection/config/update-alert',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [编辑巡检报告通知配置↗](http://yapi.cai-inc.com/project/3096/interface/api/473802) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [巡检配置相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51963)
 * @请求头 `POST /zlb/api/sop/inspection/config/update-alert`
 * @更新时间 `2023-06-05 11:04:50`
 * @项目ID 3096
 */
const zlbApiSopInspectionConfigUpdateAlertPostRequestConfig: ZlbApiSopInspectionConfigUpdateAlertPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_2,
    devUrl: devUrl_0_2_0_2,
    prodUrl: prodUrl_0_2_0_2,
    path: '/zlb/api/sop/inspection/config/update-alert',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopInspectionConfigUpdateAlertPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [编辑巡检报告通知配置↗](http://yapi.cai-inc.com/project/3096/interface/api/473802) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [巡检配置相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51963)
 * @请求头 `POST /zlb/api/sop/inspection/config/update-alert`
 * @更新时间 `2023-06-05 11:04:50`
 * @项目ID 3096
 */
export const zlbApiSopInspectionConfigUpdateAlertPost = /*#__PURE__*/ (
  requestData: ZlbApiSopInspectionConfigUpdateAlertPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopInspectionConfigUpdateAlertPostResponse>(
    prepare(zlbApiSopInspectionConfigUpdateAlertPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopInspectionConfigUpdateAlertPost.requestConfig =
  zlbApiSopInspectionConfigUpdateAlertPostRequestConfig;

const mockUrl_0_2_0_3 = 'http://yapi.cai-inc.com/mock/3096' as any;
const devUrl_0_2_0_3 = '' as any;
const prodUrl_0_2_0_3 = '' as any;
const dataKey_0_2_0_3 = 'data' as any;

/**
 * 接口 [查询事件详情↗](http://yapi.cai-inc.com/project/3096/interface/api/473810) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `GET /zlb/api/sop/manage/inspection-detail/{eventNo}`
 * @更新时间 `2023-12-21 16:49:21`
 * @项目ID 3096
 */
export interface ZlbApiSopManageInspectionDetailEventNoGetRequest {
  /**
   * 事件编号
   */
  eventNo: string;
}

/**
 * 接口 [查询事件详情↗](http://yapi.cai-inc.com/project/3096/interface/api/473810) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `GET /zlb/api/sop/manage/inspection-detail/{eventNo}`
 * @更新时间 `2023-12-21 16:49:21`
 * @项目ID 3096
 */
export interface ZlbApiSopManageInspectionDetailEventNoGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 事件编号
     */
    eventNo?: string;
    /**
     * 巡检记录名称
     */
    inspectionLogName?: string;
    /**
     * 巡检次数
     */
    inspectionCount?: number;
    /**
     * 区划code
     */
    districtCode?: string;
    /**
     * 区划名称
     */
    districtName?: string;
    /**
     * 机构id
     */
    orgId?: number;
    /**
     * 单位名称
     */
    orgName?: string;
    /**
     * 创建时间
     */
    rAddTime?: string;
    /**
     * 巡检时间
     */
    inspectionDate?: string;
    /**
     * 事件类型
     */
    eventType?: number;
    /**
     * 事件类型描述
     */
    eventTypeDesc?: string;
    /**
     * 事件说明
     */
    eventDesc?: string;
    status?: number;
    statusDesc?: string;
    /**
     * 操作流转日志
     */
    flowLogList?: {
      /**
       * 操作时间
       */
      operatorTime?: string;
      /**
       * 操作时间
       */
      operatorDate?: string;
      /**
       * 操作内容
       */
      operatorContent?: string;
      /**
       * 备注
       */
      remarks?: string;
      /**
       * 操作用户
       */
      operatorUser?: string;
      /**
       * fileId
       */
      attachDtoList?: {
        name?: string;
        size?: number;
        type?: string;
        fileId?: string;
      }[];
    }[];
    /**
     * 操作按钮
     */
    operateButton?: {
      /**
       * 详情
       */
      detail?: boolean;
      /**
       * 重新打开
       */
      restart?: boolean;
      /**
       * 处理
       */
      edit?: boolean;
      /**
       * 转交
       */
      transfer?: boolean;
      /**
       * 催办
       */
      reminders?: boolean;
    };
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询事件详情↗](http://yapi.cai-inc.com/project/3096/interface/api/473810) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `GET /zlb/api/sop/manage/inspection-detail/{eventNo}`
 * @更新时间 `2023-12-21 16:49:21`
 * @项目ID 3096
 */
type ZlbApiSopManageInspectionDetailEventNoGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/manage/inspection-detail/{eventNo}',
    'data',
    'eventNo',
    string,
    false
  >
>;

/**
 * 接口 [查询事件详情↗](http://yapi.cai-inc.com/project/3096/interface/api/473810) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `GET /zlb/api/sop/manage/inspection-detail/{eventNo}`
 * @更新时间 `2023-12-21 16:49:21`
 * @项目ID 3096
 */
const zlbApiSopManageInspectionDetailEventNoGetRequestConfig: ZlbApiSopManageInspectionDetailEventNoGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_3,
    devUrl: devUrl_0_2_0_3,
    prodUrl: prodUrl_0_2_0_3,
    path: '/zlb/api/sop/manage/inspection-detail/{eventNo}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_3,
    paramNames: ['eventNo'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopManageInspectionDetailEventNoGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询事件详情↗](http://yapi.cai-inc.com/project/3096/interface/api/473810) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `GET /zlb/api/sop/manage/inspection-detail/{eventNo}`
 * @更新时间 `2023-12-21 16:49:21`
 * @项目ID 3096
 */
export const zlbApiSopManageInspectionDetailEventNoGet = /*#__PURE__*/ (
  requestData: ZlbApiSopManageInspectionDetailEventNoGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopManageInspectionDetailEventNoGetResponse>(
    prepare(zlbApiSopManageInspectionDetailEventNoGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopManageInspectionDetailEventNoGet.requestConfig =
  zlbApiSopManageInspectionDetailEventNoGetRequestConfig;

/**
 * 接口 [查询巡检状态枚举↗](http://yapi.cai-inc.com/project/3096/interface/api/473818) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `GET /zlb/api/sop/manage/inspection-status/{type}`
 * @更新时间 `2023-12-21 16:49:24`
 * @项目ID 3096
 */
export interface ZlbApiSopManageInspectionStatusTypeGetRequest {
  /**
   * 1：租户 2：单位侧
   */
  type: string;
}

/**
 * 接口 [查询巡检状态枚举↗](http://yapi.cai-inc.com/project/3096/interface/api/473818) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `GET /zlb/api/sop/manage/inspection-status/{type}`
 * @更新时间 `2023-12-21 16:49:24`
 * @项目ID 3096
 */
export interface ZlbApiSopManageInspectionStatusTypeGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    code?: number;
    desc?: string;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询巡检状态枚举↗](http://yapi.cai-inc.com/project/3096/interface/api/473818) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `GET /zlb/api/sop/manage/inspection-status/{type}`
 * @更新时间 `2023-12-21 16:49:24`
 * @项目ID 3096
 */
type ZlbApiSopManageInspectionStatusTypeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/manage/inspection-status/{type}',
    'data',
    'type',
    string,
    false
  >
>;

/**
 * 接口 [查询巡检状态枚举↗](http://yapi.cai-inc.com/project/3096/interface/api/473818) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `GET /zlb/api/sop/manage/inspection-status/{type}`
 * @更新时间 `2023-12-21 16:49:24`
 * @项目ID 3096
 */
const zlbApiSopManageInspectionStatusTypeGetRequestConfig: ZlbApiSopManageInspectionStatusTypeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_3,
    devUrl: devUrl_0_2_0_3,
    prodUrl: prodUrl_0_2_0_3,
    path: '/zlb/api/sop/manage/inspection-status/{type}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_3,
    paramNames: ['type'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopManageInspectionStatusTypeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询巡检状态枚举↗](http://yapi.cai-inc.com/project/3096/interface/api/473818) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `GET /zlb/api/sop/manage/inspection-status/{type}`
 * @更新时间 `2023-12-21 16:49:24`
 * @项目ID 3096
 */
export const zlbApiSopManageInspectionStatusTypeGet = /*#__PURE__*/ (
  requestData: ZlbApiSopManageInspectionStatusTypeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopManageInspectionStatusTypeGetResponse>(
    prepare(zlbApiSopManageInspectionStatusTypeGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopManageInspectionStatusTypeGet.requestConfig =
  zlbApiSopManageInspectionStatusTypeGetRequestConfig;

/**
 * 接口 [查询巡检风险类型↗](http://yapi.cai-inc.com/project/3096/interface/api/474978) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `GET /zlb/api/sop/manage/inspection-risk-type`
 * @更新时间 `2023-12-21 16:49:24`
 * @项目ID 3096
 */
export interface ZlbApiSopManageInspectionRiskTypeGetRequest {}

/**
 * 接口 [查询巡检风险类型↗](http://yapi.cai-inc.com/project/3096/interface/api/474978) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `GET /zlb/api/sop/manage/inspection-risk-type`
 * @更新时间 `2023-12-21 16:49:24`
 * @项目ID 3096
 */
export interface ZlbApiSopManageInspectionRiskTypeGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    type?: number;
    typeDesc?: string;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询巡检风险类型↗](http://yapi.cai-inc.com/project/3096/interface/api/474978) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `GET /zlb/api/sop/manage/inspection-risk-type`
 * @更新时间 `2023-12-21 16:49:24`
 * @项目ID 3096
 */
type ZlbApiSopManageInspectionRiskTypeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/manage/inspection-risk-type',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [查询巡检风险类型↗](http://yapi.cai-inc.com/project/3096/interface/api/474978) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `GET /zlb/api/sop/manage/inspection-risk-type`
 * @更新时间 `2023-12-21 16:49:24`
 * @项目ID 3096
 */
const zlbApiSopManageInspectionRiskTypeGetRequestConfig: ZlbApiSopManageInspectionRiskTypeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_3,
    devUrl: devUrl_0_2_0_3,
    prodUrl: prodUrl_0_2_0_3,
    path: '/zlb/api/sop/manage/inspection-risk-type',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopManageInspectionRiskTypeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询巡检风险类型↗](http://yapi.cai-inc.com/project/3096/interface/api/474978) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `GET /zlb/api/sop/manage/inspection-risk-type`
 * @更新时间 `2023-12-21 16:49:24`
 * @项目ID 3096
 */
export const zlbApiSopManageInspectionRiskTypeGet = /*#__PURE__*/ (
  requestData?: ZlbApiSopManageInspectionRiskTypeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopManageInspectionRiskTypeGetResponse>(
    prepare(zlbApiSopManageInspectionRiskTypeGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopManageInspectionRiskTypeGet.requestConfig =
  zlbApiSopManageInspectionRiskTypeGetRequestConfig;

/**
 * 接口 [查询事件业务↗](http://yapi.cai-inc.com/project/3096/interface/api/481354) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `GET /zlb/api/sop/manage/inspection-event-page`
 * @更新时间 `2023-12-21 16:49:22`
 * @项目ID 3096
 */
export interface ZlbApiSopManageInspectionEventPageGetRequest {
  eventNo?: string;
  /**
   * 页面大小
   */
  pageSize?: string;
  /**
   * 页码
   */
  pageNo?: string;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
}

/**
 * 接口 [查询事件业务↗](http://yapi.cai-inc.com/project/3096/interface/api/481354) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `GET /zlb/api/sop/manage/inspection-event-page`
 * @更新时间 `2023-12-21 16:49:22`
 * @项目ID 3096
 */
export interface ZlbApiSopManageInspectionEventPageGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 业务类型（1：申请单，2：报销单）
       */
      businessType?: number;
      /**
       * 业务类型描述
       */
      businessTypeDesc?: string;
      /**
       * 业务编号
       */
      businessNo?: string;
      /**
       * 业务code
       */
      businessCode?: string;
      /**
       * 业务说明
       */
      businessDesc?: string;
      /**
       * 业务经办人名称
       */
      businessOperatorName?: string;
      /**
       * 报销单单据类型
       */
      expenseFormType?: number;
      /**
       * 报销单单据类型描述
       */
      expenseFormTypeDesc?: string;
      /**
       * 单据创建事件
       */
      createTime?: number;
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询事件业务↗](http://yapi.cai-inc.com/project/3096/interface/api/481354) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `GET /zlb/api/sop/manage/inspection-event-page`
 * @更新时间 `2023-12-21 16:49:22`
 * @项目ID 3096
 */
type ZlbApiSopManageInspectionEventPageGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/manage/inspection-event-page',
    'data',
    string,
    'eventNo' | 'pageSize' | 'pageNo' | 'sortField' | 'sortBy',
    false
  >
>;

/**
 * 接口 [查询事件业务↗](http://yapi.cai-inc.com/project/3096/interface/api/481354) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `GET /zlb/api/sop/manage/inspection-event-page`
 * @更新时间 `2023-12-21 16:49:22`
 * @项目ID 3096
 */
const zlbApiSopManageInspectionEventPageGetRequestConfig: ZlbApiSopManageInspectionEventPageGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_3,
    devUrl: devUrl_0_2_0_3,
    prodUrl: prodUrl_0_2_0_3,
    path: '/zlb/api/sop/manage/inspection-event-page',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_3,
    paramNames: [],
    queryNames: ['eventNo', 'pageSize', 'pageNo', 'sortField', 'sortBy'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopManageInspectionEventPageGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询事件业务↗](http://yapi.cai-inc.com/project/3096/interface/api/481354) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `GET /zlb/api/sop/manage/inspection-event-page`
 * @更新时间 `2023-12-21 16:49:22`
 * @项目ID 3096
 */
export const zlbApiSopManageInspectionEventPageGet = /*#__PURE__*/ (
  requestData: ZlbApiSopManageInspectionEventPageGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopManageInspectionEventPageGetResponse>(
    prepare(zlbApiSopManageInspectionEventPageGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopManageInspectionEventPageGet.requestConfig =
  zlbApiSopManageInspectionEventPageGetRequestConfig;

/**
 * 接口 [查询用户所拥有的区划数据权限↗](http://yapi.cai-inc.com/project/3096/interface/api/481362) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `GET /zlb/api/sop/manage/query-district-rule-data`
 * @更新时间 `2023-12-21 16:49:22`
 * @项目ID 3096
 */
export interface ZlbApiSopManageQueryDistrictRuleDataGetRequest {
  /**
   * 区划code
   */
  districtCode?: string;
}

/**
 * 接口 [查询用户所拥有的区划数据权限↗](http://yapi.cai-inc.com/project/3096/interface/api/481362) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `GET /zlb/api/sop/manage/query-district-rule-data`
 * @更新时间 `2023-12-21 16:49:22`
 * @项目ID 3096
 */
export interface ZlbApiSopManageQueryDistrictRuleDataGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 区划code
     */
    districtCode?: string;
    /**
     * 区划名称
     */
    districtName?: string;
    /**
     * 类型
     * 省 province
     * 市 city
     * 区/县 region
     */
    type?: string;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询用户所拥有的区划数据权限↗](http://yapi.cai-inc.com/project/3096/interface/api/481362) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `GET /zlb/api/sop/manage/query-district-rule-data`
 * @更新时间 `2023-12-21 16:49:22`
 * @项目ID 3096
 */
type ZlbApiSopManageQueryDistrictRuleDataGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/manage/query-district-rule-data',
    'data',
    string,
    'districtCode',
    false
  >
>;

/**
 * 接口 [查询用户所拥有的区划数据权限↗](http://yapi.cai-inc.com/project/3096/interface/api/481362) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `GET /zlb/api/sop/manage/query-district-rule-data`
 * @更新时间 `2023-12-21 16:49:22`
 * @项目ID 3096
 */
const zlbApiSopManageQueryDistrictRuleDataGetRequestConfig: ZlbApiSopManageQueryDistrictRuleDataGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_3,
    devUrl: devUrl_0_2_0_3,
    prodUrl: prodUrl_0_2_0_3,
    path: '/zlb/api/sop/manage/query-district-rule-data',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_3,
    paramNames: [],
    queryNames: ['districtCode'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopManageQueryDistrictRuleDataGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询用户所拥有的区划数据权限↗](http://yapi.cai-inc.com/project/3096/interface/api/481362) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `GET /zlb/api/sop/manage/query-district-rule-data`
 * @更新时间 `2023-12-21 16:49:22`
 * @项目ID 3096
 */
export const zlbApiSopManageQueryDistrictRuleDataGet = /*#__PURE__*/ (
  requestData: ZlbApiSopManageQueryDistrictRuleDataGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopManageQueryDistrictRuleDataGetResponse>(
    prepare(zlbApiSopManageQueryDistrictRuleDataGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopManageQueryDistrictRuleDataGet.requestConfig =
  zlbApiSopManageQueryDistrictRuleDataGetRequestConfig;

/**
 * 接口 [查询用户所有的区划数据权限↗](http://yapi.cai-inc.com/project/3096/interface/api/481370) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `GET /zlb/api/sop/manage/query-all-district-rule`
 * @更新时间 `2023-12-21 16:49:22`
 * @项目ID 3096
 */
export interface ZlbApiSopManageQueryAllDistrictRuleGetRequest {}

/**
 * 接口 [查询用户所有的区划数据权限↗](http://yapi.cai-inc.com/project/3096/interface/api/481370) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `GET /zlb/api/sop/manage/query-all-district-rule`
 * @更新时间 `2023-12-21 16:49:22`
 * @项目ID 3096
 */
export interface ZlbApiSopManageQueryAllDistrictRuleGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 区划code
     */
    districtCode?: string;
    /**
     * 区划名称
     */
    districtName?: string;
    /**
     * 类型
     * 省 province
     * 市 city
     * 区/县 region
     */
    type?: string;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询用户所有的区划数据权限↗](http://yapi.cai-inc.com/project/3096/interface/api/481370) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `GET /zlb/api/sop/manage/query-all-district-rule`
 * @更新时间 `2023-12-21 16:49:22`
 * @项目ID 3096
 */
type ZlbApiSopManageQueryAllDistrictRuleGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/manage/query-all-district-rule',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [查询用户所有的区划数据权限↗](http://yapi.cai-inc.com/project/3096/interface/api/481370) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `GET /zlb/api/sop/manage/query-all-district-rule`
 * @更新时间 `2023-12-21 16:49:22`
 * @项目ID 3096
 */
const zlbApiSopManageQueryAllDistrictRuleGetRequestConfig: ZlbApiSopManageQueryAllDistrictRuleGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_3,
    devUrl: devUrl_0_2_0_3,
    prodUrl: prodUrl_0_2_0_3,
    path: '/zlb/api/sop/manage/query-all-district-rule',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopManageQueryAllDistrictRuleGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询用户所有的区划数据权限↗](http://yapi.cai-inc.com/project/3096/interface/api/481370) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `GET /zlb/api/sop/manage/query-all-district-rule`
 * @更新时间 `2023-12-21 16:49:22`
 * @项目ID 3096
 */
export const zlbApiSopManageQueryAllDistrictRuleGet = /*#__PURE__*/ (
  requestData?: ZlbApiSopManageQueryAllDistrictRuleGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopManageQueryAllDistrictRuleGetResponse>(
    prepare(zlbApiSopManageQueryAllDistrictRuleGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopManageQueryAllDistrictRuleGet.requestConfig =
  zlbApiSopManageQueryAllDistrictRuleGetRequestConfig;

/**
 * 接口 [查询用户所拥有的机构数据权限↗](http://yapi.cai-inc.com/project/3096/interface/api/481378) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/sop/manage/query-all-org-rule`
 * @更新时间 `2023-12-21 16:49:23`
 * @项目ID 3096
 */
export interface ZlbApiSopManageQueryAllOrgRuleGetRequest {
  status?: string;
}

/**
 * 接口 [查询用户所拥有的机构数据权限↗](http://yapi.cai-inc.com/project/3096/interface/api/481378) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/sop/manage/query-all-org-rule`
 * @更新时间 `2023-12-21 16:49:23`
 * @项目ID 3096
 */
export interface ZlbApiSopManageQueryAllOrgRuleGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 机构id
     */
    orgId?: number;
    /**
     * 机构名称
     */
    orgName?: string;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询用户所拥有的机构数据权限↗](http://yapi.cai-inc.com/project/3096/interface/api/481378) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/sop/manage/query-all-org-rule`
 * @更新时间 `2023-12-21 16:49:23`
 * @项目ID 3096
 */
type ZlbApiSopManageQueryAllOrgRuleGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/manage/query-all-org-rule',
    'data',
    string,
    'status',
    false
  >
>;

/**
 * 接口 [查询用户所拥有的机构数据权限↗](http://yapi.cai-inc.com/project/3096/interface/api/481378) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/sop/manage/query-all-org-rule`
 * @更新时间 `2023-12-21 16:49:23`
 * @项目ID 3096
 */
const zlbApiSopManageQueryAllOrgRuleGetRequestConfig: ZlbApiSopManageQueryAllOrgRuleGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_3,
    devUrl: devUrl_0_2_0_3,
    prodUrl: prodUrl_0_2_0_3,
    path: '/zlb/api/sop/manage/query-all-org-rule',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_3,
    paramNames: [],
    queryNames: ['status'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopManageQueryAllOrgRuleGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询用户所拥有的机构数据权限↗](http://yapi.cai-inc.com/project/3096/interface/api/481378) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/sop/manage/query-all-org-rule`
 * @更新时间 `2023-12-21 16:49:23`
 * @项目ID 3096
 */
export const zlbApiSopManageQueryAllOrgRuleGet = /*#__PURE__*/ (
  requestData: ZlbApiSopManageQueryAllOrgRuleGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopManageQueryAllOrgRuleGetResponse>(
    prepare(zlbApiSopManageQueryAllOrgRuleGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopManageQueryAllOrgRuleGet.requestConfig = zlbApiSopManageQueryAllOrgRuleGetRequestConfig;

/**
 * 接口 [查询机构用户信息↗](http://yapi.cai-inc.com/project/3096/interface/api/481386) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `GET /zlb/api/sop/manage/query-org-user`
 * @更新时间 `2023-12-21 16:49:23`
 * @项目ID 3096
 */
export interface ZlbApiSopManageQueryOrgUserGetRequest {
  /**
   * 用户名称
   */
  userName?: string;
  /**
   * 0：停用 1：启用
   */
  status?: string;
}

/**
 * 接口 [查询机构用户信息↗](http://yapi.cai-inc.com/project/3096/interface/api/481386) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `GET /zlb/api/sop/manage/query-org-user`
 * @更新时间 `2023-12-21 16:49:23`
 * @项目ID 3096
 */
export interface ZlbApiSopManageQueryOrgUserGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 操作人id
     */
    operatorId?: number;
    /**
     * 用户名称
     */
    userName?: string;
    /**
     * 手机号
     */
    phone?: string;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询机构用户信息↗](http://yapi.cai-inc.com/project/3096/interface/api/481386) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `GET /zlb/api/sop/manage/query-org-user`
 * @更新时间 `2023-12-21 16:49:23`
 * @项目ID 3096
 */
type ZlbApiSopManageQueryOrgUserGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/manage/query-org-user',
    'data',
    string,
    'userName' | 'status',
    false
  >
>;

/**
 * 接口 [查询机构用户信息↗](http://yapi.cai-inc.com/project/3096/interface/api/481386) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `GET /zlb/api/sop/manage/query-org-user`
 * @更新时间 `2023-12-21 16:49:23`
 * @项目ID 3096
 */
const zlbApiSopManageQueryOrgUserGetRequestConfig: ZlbApiSopManageQueryOrgUserGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_3,
    devUrl: devUrl_0_2_0_3,
    prodUrl: prodUrl_0_2_0_3,
    path: '/zlb/api/sop/manage/query-org-user',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_3,
    paramNames: [],
    queryNames: ['userName', 'status'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopManageQueryOrgUserGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询机构用户信息↗](http://yapi.cai-inc.com/project/3096/interface/api/481386) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `GET /zlb/api/sop/manage/query-org-user`
 * @更新时间 `2023-12-21 16:49:23`
 * @项目ID 3096
 */
export const zlbApiSopManageQueryOrgUserGet = /*#__PURE__*/ (
  requestData: ZlbApiSopManageQueryOrgUserGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopManageQueryOrgUserGetResponse>(
    prepare(zlbApiSopManageQueryOrgUserGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopManageQueryOrgUserGet.requestConfig = zlbApiSopManageQueryOrgUserGetRequestConfig;

/**
 * 接口 [查询巡检次数↗](http://yapi.cai-inc.com/project/3096/interface/api/481394) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `GET /zlb/api/sop/manage/inspection-log-count`
 * @更新时间 `2023-12-21 16:49:23`
 * @项目ID 3096
 */
export interface ZlbApiSopManageInspectionLogCountGetRequest {
  districtCode: string;
  /**
   * 年份
   */
  year: string;
  /**
   * 月份
   */
  month: string;
}

/**
 * 接口 [查询巡检次数↗](http://yapi.cai-inc.com/project/3096/interface/api/481394) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `GET /zlb/api/sop/manage/inspection-log-count`
 * @更新时间 `2023-12-21 16:49:23`
 * @项目ID 3096
 */
export interface ZlbApiSopManageInspectionLogCountGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: number[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询巡检次数↗](http://yapi.cai-inc.com/project/3096/interface/api/481394) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `GET /zlb/api/sop/manage/inspection-log-count`
 * @更新时间 `2023-12-21 16:49:23`
 * @项目ID 3096
 */
type ZlbApiSopManageInspectionLogCountGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/manage/inspection-log-count',
    'data',
    string,
    'districtCode' | 'year' | 'month',
    false
  >
>;

/**
 * 接口 [查询巡检次数↗](http://yapi.cai-inc.com/project/3096/interface/api/481394) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `GET /zlb/api/sop/manage/inspection-log-count`
 * @更新时间 `2023-12-21 16:49:23`
 * @项目ID 3096
 */
const zlbApiSopManageInspectionLogCountGetRequestConfig: ZlbApiSopManageInspectionLogCountGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_3,
    devUrl: devUrl_0_2_0_3,
    prodUrl: prodUrl_0_2_0_3,
    path: '/zlb/api/sop/manage/inspection-log-count',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_3,
    paramNames: [],
    queryNames: ['districtCode', 'year', 'month'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopManageInspectionLogCountGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询巡检次数↗](http://yapi.cai-inc.com/project/3096/interface/api/481394) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `GET /zlb/api/sop/manage/inspection-log-count`
 * @更新时间 `2023-12-21 16:49:23`
 * @项目ID 3096
 */
export const zlbApiSopManageInspectionLogCountGet = /*#__PURE__*/ (
  requestData: ZlbApiSopManageInspectionLogCountGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopManageInspectionLogCountGetResponse>(
    prepare(zlbApiSopManageInspectionLogCountGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopManageInspectionLogCountGet.requestConfig =
  zlbApiSopManageInspectionLogCountGetRequestConfig;

/**
 * 接口 [查询巡检提示↗](http://yapi.cai-inc.com/project/3096/interface/api/481402) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `GET /zlb/api/sop/manage/query-inspection-tips`
 * @更新时间 `2023-12-21 16:49:25`
 * @项目ID 3096
 */
export interface ZlbApiSopManageQueryInspectionTipsGetRequest {}

/**
 * 接口 [查询巡检提示↗](http://yapi.cai-inc.com/project/3096/interface/api/481402) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `GET /zlb/api/sop/manage/query-inspection-tips`
 * @更新时间 `2023-12-21 16:49:25`
 * @项目ID 3096
 */
export interface ZlbApiSopManageQueryInspectionTipsGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * true：展示， false：不展示
     */
    isTips?: boolean;
    /**
     * 提示文案
     */
    tips?: string;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询巡检提示↗](http://yapi.cai-inc.com/project/3096/interface/api/481402) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `GET /zlb/api/sop/manage/query-inspection-tips`
 * @更新时间 `2023-12-21 16:49:25`
 * @项目ID 3096
 */
type ZlbApiSopManageQueryInspectionTipsGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/manage/query-inspection-tips',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [查询巡检提示↗](http://yapi.cai-inc.com/project/3096/interface/api/481402) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `GET /zlb/api/sop/manage/query-inspection-tips`
 * @更新时间 `2023-12-21 16:49:25`
 * @项目ID 3096
 */
const zlbApiSopManageQueryInspectionTipsGetRequestConfig: ZlbApiSopManageQueryInspectionTipsGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_3,
    devUrl: devUrl_0_2_0_3,
    prodUrl: prodUrl_0_2_0_3,
    path: '/zlb/api/sop/manage/query-inspection-tips',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopManageQueryInspectionTipsGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询巡检提示↗](http://yapi.cai-inc.com/project/3096/interface/api/481402) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `GET /zlb/api/sop/manage/query-inspection-tips`
 * @更新时间 `2023-12-21 16:49:25`
 * @项目ID 3096
 */
export const zlbApiSopManageQueryInspectionTipsGet = /*#__PURE__*/ (
  requestData?: ZlbApiSopManageQueryInspectionTipsGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopManageQueryInspectionTipsGetResponse>(
    prepare(zlbApiSopManageQueryInspectionTipsGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopManageQueryInspectionTipsGet.requestConfig =
  zlbApiSopManageQueryInspectionTipsGetRequestConfig;

/**
 * 接口 [关闭巡检提示↗](http://yapi.cai-inc.com/project/3096/interface/api/481410) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `GET /zlb/api/sop/manage/close-inspection-tips`
 * @更新时间 `2023-12-21 16:49:25`
 * @项目ID 3096
 */
export interface ZlbApiSopManageCloseInspectionTipsGetRequest {}

/**
 * 接口 [关闭巡检提示↗](http://yapi.cai-inc.com/project/3096/interface/api/481410) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `GET /zlb/api/sop/manage/close-inspection-tips`
 * @更新时间 `2023-12-21 16:49:25`
 * @项目ID 3096
 */
export interface ZlbApiSopManageCloseInspectionTipsGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [关闭巡检提示↗](http://yapi.cai-inc.com/project/3096/interface/api/481410) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `GET /zlb/api/sop/manage/close-inspection-tips`
 * @更新时间 `2023-12-21 16:49:25`
 * @项目ID 3096
 */
type ZlbApiSopManageCloseInspectionTipsGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/manage/close-inspection-tips',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [关闭巡检提示↗](http://yapi.cai-inc.com/project/3096/interface/api/481410) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `GET /zlb/api/sop/manage/close-inspection-tips`
 * @更新时间 `2023-12-21 16:49:25`
 * @项目ID 3096
 */
const zlbApiSopManageCloseInspectionTipsGetRequestConfig: ZlbApiSopManageCloseInspectionTipsGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_3,
    devUrl: devUrl_0_2_0_3,
    prodUrl: prodUrl_0_2_0_3,
    path: '/zlb/api/sop/manage/close-inspection-tips',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopManageCloseInspectionTipsGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [关闭巡检提示↗](http://yapi.cai-inc.com/project/3096/interface/api/481410) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `GET /zlb/api/sop/manage/close-inspection-tips`
 * @更新时间 `2023-12-21 16:49:25`
 * @项目ID 3096
 */
export const zlbApiSopManageCloseInspectionTipsGet = /*#__PURE__*/ (
  requestData?: ZlbApiSopManageCloseInspectionTipsGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopManageCloseInspectionTipsGetResponse>(
    prepare(zlbApiSopManageCloseInspectionTipsGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopManageCloseInspectionTipsGet.requestConfig =
  zlbApiSopManageCloseInspectionTipsGetRequestConfig;

/**
 * 接口 [查询父级租户code↗](http://yapi.cai-inc.com/project/3096/interface/api/493458) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/sop/manage/query-parent-tenant-code/{tenantCode}`
 * @更新时间 `2023-12-21 16:49:26`
 * @项目ID 3096
 */
export interface ZlbApiSopManageQueryParentTenantCodeTenantCodeGetRequest {
  tenantCode: string;
}

/**
 * 接口 [查询父级租户code↗](http://yapi.cai-inc.com/project/3096/interface/api/493458) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/sop/manage/query-parent-tenant-code/{tenantCode}`
 * @更新时间 `2023-12-21 16:49:26`
 * @项目ID 3096
 */
export interface ZlbApiSopManageQueryParentTenantCodeTenantCodeGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 省级租户code
     */
    districtProvinceCode?: string;
    /**
     * 市级租户code
     */
    districtCityCode?: string;
    /**
     * 区级租户code
     */
    districtRegionCode?: string;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询父级租户code↗](http://yapi.cai-inc.com/project/3096/interface/api/493458) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/sop/manage/query-parent-tenant-code/{tenantCode}`
 * @更新时间 `2023-12-21 16:49:26`
 * @项目ID 3096
 */
type ZlbApiSopManageQueryParentTenantCodeTenantCodeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/manage/query-parent-tenant-code/{tenantCode}',
    'data',
    'tenantCode',
    string,
    false
  >
>;

/**
 * 接口 [查询父级租户code↗](http://yapi.cai-inc.com/project/3096/interface/api/493458) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/sop/manage/query-parent-tenant-code/{tenantCode}`
 * @更新时间 `2023-12-21 16:49:26`
 * @项目ID 3096
 */
const zlbApiSopManageQueryParentTenantCodeTenantCodeGetRequestConfig: ZlbApiSopManageQueryParentTenantCodeTenantCodeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_3,
    devUrl: devUrl_0_2_0_3,
    prodUrl: prodUrl_0_2_0_3,
    path: '/zlb/api/sop/manage/query-parent-tenant-code/{tenantCode}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_3,
    paramNames: ['tenantCode'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopManageQueryParentTenantCodeTenantCodeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询父级租户code↗](http://yapi.cai-inc.com/project/3096/interface/api/493458) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/sop/manage/query-parent-tenant-code/{tenantCode}`
 * @更新时间 `2023-12-21 16:49:26`
 * @项目ID 3096
 */
export const zlbApiSopManageQueryParentTenantCodeTenantCodeGet = /*#__PURE__*/ (
  requestData: ZlbApiSopManageQueryParentTenantCodeTenantCodeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopManageQueryParentTenantCodeTenantCodeGetResponse>(
    prepare(zlbApiSopManageQueryParentTenantCodeTenantCodeGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopManageQueryParentTenantCodeTenantCodeGet.requestConfig =
  zlbApiSopManageQueryParentTenantCodeTenantCodeGetRequestConfig;

/**
 * 接口 [查询用户所拥有的机构数据权限↗](http://yapi.cai-inc.com/project/3096/interface/api/498810) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `POST /zlb/api/sop/manage/query-district-org-rule`
 * @更新时间 `2023-12-21 16:49:26`
 * @项目ID 3096
 */
export interface ZlbApiSopManageQueryDistrictOrgRulePostRequest {
  /**
   * 机构id
   */
  orgIdList?: number[];
  /**
   * 区划code
   */
  districtCode?: string;
  /**
   * 机构名称
   */
  orgName?: string;
  /**
   * 机构状态
   * -2, "删除",
   * -1，描述：锁定，冻结
   * 0，描述：停用，未生效
   * -3，描述：待激活，未生效
   * 1，描述：启用，生效
   */
  status?: number;
  /**
   * 01类别：采购单位
   * 默认查询采购单位
   */
  userType?: string;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 每页大小
   */
  pageSize?: number;
}

/**
 * 接口 [查询用户所拥有的机构数据权限↗](http://yapi.cai-inc.com/project/3096/interface/api/498810) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `POST /zlb/api/sop/manage/query-district-org-rule`
 * @更新时间 `2023-12-21 16:49:26`
 * @项目ID 3096
 */
export interface ZlbApiSopManageQueryDistrictOrgRulePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 机构id
     */
    orgId?: number;
    /**
     * 机构名称
     */
    orgName?: string;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询用户所拥有的机构数据权限↗](http://yapi.cai-inc.com/project/3096/interface/api/498810) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `POST /zlb/api/sop/manage/query-district-org-rule`
 * @更新时间 `2023-12-21 16:49:26`
 * @项目ID 3096
 */
type ZlbApiSopManageQueryDistrictOrgRulePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/manage/query-district-org-rule',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [查询用户所拥有的机构数据权限↗](http://yapi.cai-inc.com/project/3096/interface/api/498810) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `POST /zlb/api/sop/manage/query-district-org-rule`
 * @更新时间 `2023-12-21 16:49:26`
 * @项目ID 3096
 */
const zlbApiSopManageQueryDistrictOrgRulePostRequestConfig: ZlbApiSopManageQueryDistrictOrgRulePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_3,
    devUrl: devUrl_0_2_0_3,
    prodUrl: prodUrl_0_2_0_3,
    path: '/zlb/api/sop/manage/query-district-org-rule',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopManageQueryDistrictOrgRulePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询用户所拥有的机构数据权限↗](http://yapi.cai-inc.com/project/3096/interface/api/498810) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [巡检通用相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51964)
 * @请求头 `POST /zlb/api/sop/manage/query-district-org-rule`
 * @更新时间 `2023-12-21 16:49:26`
 * @项目ID 3096
 */
export const zlbApiSopManageQueryDistrictOrgRulePost = /*#__PURE__*/ (
  requestData: ZlbApiSopManageQueryDistrictOrgRulePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopManageQueryDistrictOrgRulePostResponse>(
    prepare(zlbApiSopManageQueryDistrictOrgRulePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopManageQueryDistrictOrgRulePost.requestConfig =
  zlbApiSopManageQueryDistrictOrgRulePostRequestConfig;

const mockUrl_0_2_0_4 = 'http://yapi.cai-inc.com/mock/3096' as any;
const devUrl_0_2_0_4 = '' as any;
const prodUrl_0_2_0_4 = '' as any;
const dataKey_0_2_0_4 = 'data' as any;

/**
 * 接口 [查询巡检列表（分页）↗](http://yapi.cai-inc.com/project/3096/interface/api/482922) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [运营平台相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51965)
 * @请求头 `POST /zlb/api/sop/inspection/operation/inspection-page`
 * @更新时间 `2023-07-03 14:35:54`
 * @项目ID 3096
 */
export interface ZlbApiSopInspectionOperationInspectionPagePostRequest {
  pageSize?: number;
  pageNo?: number;
  sortField?: string;
  sortBy?: string;
  /**
   * 事件编号
   */
  eventNo?: string;
  /**
   * 机构id
   */
  orgIdList?: number[];
  /**
   * 统一社会信用代码
   */
  creditCode?: string;
  /**
   * 巡检状态(0：待下发，1：已下发，待处理，2：单位已处理，待确认，3：单位申请复议，待处理，4：已完结，5：已完结-误判)
   */
  statusList?: number[];
  /**
   * 事件类型
   */
  eventType?: number;
  /**
   * 区划code
   */
  districtCode?: string;
}

/**
 * 接口 [查询巡检列表（分页）↗](http://yapi.cai-inc.com/project/3096/interface/api/482922) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [运营平台相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51965)
 * @请求头 `POST /zlb/api/sop/inspection/operation/inspection-page`
 * @更新时间 `2023-07-03 14:35:54`
 * @项目ID 3096
 */
export interface ZlbApiSopInspectionOperationInspectionPagePostResponse {
  success?: boolean;
  result?: {
    total?: number;
    data?: {
      /**
       * 事件编号
       */
      eventNo?: string;
      /**
       * 巡检记录
       */
      inspectionLogName?: string;
      /**
       * 巡检次数
       */
      inspectionCount?: number;
      /**
       * 区划名称
       */
      districtName?: string;
      /**
       * 单位名称
       */
      orgName?: string;
      /**
       * 事件类型
       */
      eventType?: number;
      /**
       * 事件类型描述
       */
      eventTypeDesc?: string;
      /**
       * 催办次数
       */
      urgeCount?: number;
      /**
       * 巡检状态
       */
      status?: number;
      /**
       * 巡检状态描述
       */
      statusDesc?: string;
      /**
       * 创建时间
       */
      rAddTime?: string;
      /**
       * 巡检时间
       */
      inspectionDate?: string;
      /**
       * 操作按钮
       */
      operateButton?: {
        /**
         * 详情
         */
        detail?: boolean;
        /**
         * 重新打开
         */
        restart?: boolean;
        /**
         * 处理
         */
        edit?: boolean;
        /**
         * 转交
         */
        transfer?: boolean;
        /**
         * 催办
         */
        reminders?: boolean;
      };
    }[];
    pageNum?: number;
    pageSize?: number;
    pages?: number;
    size?: number;
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [查询巡检列表（分页）↗](http://yapi.cai-inc.com/project/3096/interface/api/482922) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [运营平台相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51965)
 * @请求头 `POST /zlb/api/sop/inspection/operation/inspection-page`
 * @更新时间 `2023-07-03 14:35:54`
 * @项目ID 3096
 */
type ZlbApiSopInspectionOperationInspectionPagePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/inspection/operation/inspection-page',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [查询巡检列表（分页）↗](http://yapi.cai-inc.com/project/3096/interface/api/482922) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [运营平台相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51965)
 * @请求头 `POST /zlb/api/sop/inspection/operation/inspection-page`
 * @更新时间 `2023-07-03 14:35:54`
 * @项目ID 3096
 */
const zlbApiSopInspectionOperationInspectionPagePostRequestConfig: ZlbApiSopInspectionOperationInspectionPagePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_4,
    devUrl: devUrl_0_2_0_4,
    prodUrl: prodUrl_0_2_0_4,
    path: '/zlb/api/sop/inspection/operation/inspection-page',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopInspectionOperationInspectionPagePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询巡检列表（分页）↗](http://yapi.cai-inc.com/project/3096/interface/api/482922) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [运营平台相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51965)
 * @请求头 `POST /zlb/api/sop/inspection/operation/inspection-page`
 * @更新时间 `2023-07-03 14:35:54`
 * @项目ID 3096
 */
export const zlbApiSopInspectionOperationInspectionPagePost = /*#__PURE__*/ (
  requestData: ZlbApiSopInspectionOperationInspectionPagePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopInspectionOperationInspectionPagePostResponse>(
    prepare(zlbApiSopInspectionOperationInspectionPagePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopInspectionOperationInspectionPagePost.requestConfig =
  zlbApiSopInspectionOperationInspectionPagePostRequestConfig;

const mockUrl_0_2_0_5 = 'http://yapi.cai-inc.com/mock/3096' as any;
const devUrl_0_2_0_5 = '' as any;
const prodUrl_0_2_0_5 = '' as any;
const dataKey_0_2_0_5 = 'data' as any;

/**
 * 接口 [事件处理↗](http://yapi.cai-inc.com/project/3096/interface/api/473842) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [巡检单位侧相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51967)
 * @请求头 `POST /zlb/api/sop/org/inspection/dispose`
 * @更新时间 `2023-06-15 16:32:17`
 * @项目ID 3096
 */
export interface ZlbApiSopOrgInspectionDisposePostRequest {
  /**
   * 处理状态
   */
  status: number;
  /**
   * 备注
   */
  remark?: string;
  /**
   * 事件编号
   */
  eventNoList: string[];
  /**
   * 附件集合
   */
  attachDtoList?: {
    /**
     * 附件名称
     */
    name?: string;
    /**
     * 附件大小
     */
    size?: number;
    /**
     * 附件mime类型
     */
    type?: string;
    /**
     * 附件文件ID
     */
    fileId?: string;
  }[];
}

/**
 * 接口 [事件处理↗](http://yapi.cai-inc.com/project/3096/interface/api/473842) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [巡检单位侧相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51967)
 * @请求头 `POST /zlb/api/sop/org/inspection/dispose`
 * @更新时间 `2023-06-15 16:32:17`
 * @项目ID 3096
 */
export interface ZlbApiSopOrgInspectionDisposePostResponse {
  success?: boolean;
  result?: boolean;
  code?: string;
  message?: string;
}

/**
 * 接口 [事件处理↗](http://yapi.cai-inc.com/project/3096/interface/api/473842) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [巡检单位侧相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51967)
 * @请求头 `POST /zlb/api/sop/org/inspection/dispose`
 * @更新时间 `2023-06-15 16:32:17`
 * @项目ID 3096
 */
type ZlbApiSopOrgInspectionDisposePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/org/inspection/dispose',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [事件处理↗](http://yapi.cai-inc.com/project/3096/interface/api/473842) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [巡检单位侧相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51967)
 * @请求头 `POST /zlb/api/sop/org/inspection/dispose`
 * @更新时间 `2023-06-15 16:32:17`
 * @项目ID 3096
 */
const zlbApiSopOrgInspectionDisposePostRequestConfig: ZlbApiSopOrgInspectionDisposePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_5,
    devUrl: devUrl_0_2_0_5,
    prodUrl: prodUrl_0_2_0_5,
    path: '/zlb/api/sop/org/inspection/dispose',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopOrgInspectionDisposePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [事件处理↗](http://yapi.cai-inc.com/project/3096/interface/api/473842) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [巡检单位侧相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51967)
 * @请求头 `POST /zlb/api/sop/org/inspection/dispose`
 * @更新时间 `2023-06-15 16:32:17`
 * @项目ID 3096
 */
export const zlbApiSopOrgInspectionDisposePost = /*#__PURE__*/ (
  requestData: ZlbApiSopOrgInspectionDisposePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopOrgInspectionDisposePostResponse>(
    prepare(zlbApiSopOrgInspectionDisposePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopOrgInspectionDisposePost.requestConfig = zlbApiSopOrgInspectionDisposePostRequestConfig;

/**
 * 接口 [事件转交↗](http://yapi.cai-inc.com/project/3096/interface/api/473850) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [巡检单位侧相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51967)
 * @请求头 `POST /zlb/api/sop/org/inspection/transfer`
 * @更新时间 `2023-06-15 16:32:17`
 * @项目ID 3096
 */
export interface ZlbApiSopOrgInspectionTransferPostRequest {
  /**
   * 事件编号
   */
  eventNoList: string[];
  /**
   * 转交的操作人id
   */
  operatorIdList: number[];
}

/**
 * 接口 [事件转交↗](http://yapi.cai-inc.com/project/3096/interface/api/473850) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [巡检单位侧相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51967)
 * @请求头 `POST /zlb/api/sop/org/inspection/transfer`
 * @更新时间 `2023-06-15 16:32:17`
 * @项目ID 3096
 */
export interface ZlbApiSopOrgInspectionTransferPostResponse {
  success?: boolean;
  result?: boolean;
  code?: string;
  message?: string;
}

/**
 * 接口 [事件转交↗](http://yapi.cai-inc.com/project/3096/interface/api/473850) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [巡检单位侧相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51967)
 * @请求头 `POST /zlb/api/sop/org/inspection/transfer`
 * @更新时间 `2023-06-15 16:32:17`
 * @项目ID 3096
 */
type ZlbApiSopOrgInspectionTransferPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/org/inspection/transfer',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [事件转交↗](http://yapi.cai-inc.com/project/3096/interface/api/473850) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [巡检单位侧相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51967)
 * @请求头 `POST /zlb/api/sop/org/inspection/transfer`
 * @更新时间 `2023-06-15 16:32:17`
 * @项目ID 3096
 */
const zlbApiSopOrgInspectionTransferPostRequestConfig: ZlbApiSopOrgInspectionTransferPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_5,
    devUrl: devUrl_0_2_0_5,
    prodUrl: prodUrl_0_2_0_5,
    path: '/zlb/api/sop/org/inspection/transfer',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopOrgInspectionTransferPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [事件转交↗](http://yapi.cai-inc.com/project/3096/interface/api/473850) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [巡检单位侧相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51967)
 * @请求头 `POST /zlb/api/sop/org/inspection/transfer`
 * @更新时间 `2023-06-15 16:32:17`
 * @项目ID 3096
 */
export const zlbApiSopOrgInspectionTransferPost = /*#__PURE__*/ (
  requestData: ZlbApiSopOrgInspectionTransferPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopOrgInspectionTransferPostResponse>(
    prepare(zlbApiSopOrgInspectionTransferPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopOrgInspectionTransferPost.requestConfig = zlbApiSopOrgInspectionTransferPostRequestConfig;

/**
 * 接口 [查询巡检列表（分页）↗](http://yapi.cai-inc.com/project/3096/interface/api/486594) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [巡检单位侧相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51967)
 * @请求头 `POST /zlb/api/sop/org/inspection/page`
 * @更新时间 `2023-06-15 16:32:17`
 * @项目ID 3096
 */
export interface ZlbApiSopOrgInspectionPagePostRequest {
  pageSize?: number;
  pageNo?: number;
  sortField?: string;
  sortBy?: string;
  /**
   * 事件编号
   */
  eventNo?: string;
  /**
   * 巡检状态(0：待下发，1：已下发，待处理，2：单位已处理，待确认，3：单位申请复议，待处理，4：已完结，5：已完结-误判)
   */
  status?: number[];
  /**
   * 事件类型
   */
  eventType?: number;
}

/**
 * 接口 [查询巡检列表（分页）↗](http://yapi.cai-inc.com/project/3096/interface/api/486594) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [巡检单位侧相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51967)
 * @请求头 `POST /zlb/api/sop/org/inspection/page`
 * @更新时间 `2023-06-15 16:32:17`
 * @项目ID 3096
 */
export interface ZlbApiSopOrgInspectionPagePostResponse {
  success?: boolean;
  result?: {
    total?: number;
    data?: {
      /**
       * 事件编号
       */
      eventNo?: string;
      /**
       * 巡检记录
       */
      inspectionLogName?: string;
      /**
       * 巡检次数
       */
      inspectionCount?: number;
      /**
       * 区划名称
       */
      districtName?: string;
      /**
       * 单位名称
       */
      orgName?: string;
      /**
       * 事件类型
       */
      eventType?: number;
      /**
       * 事件类型描述
       */
      eventTypeDesc?: string;
      /**
       * 催办次数
       */
      urgeCount?: number;
      /**
       * 巡检状态
       */
      status?: number;
      /**
       * 巡检状态描述
       */
      statusDesc?: string;
      /**
       * 创建时间
       */
      rAddTime?: string;
      /**
       * 巡检时间
       */
      inspectionDate?: string;
      /**
       * 操作按钮
       */
      operateButton?: {
        /**
         * 详情
         */
        detail?: boolean;
        /**
         * 重新打开
         */
        restart?: boolean;
        /**
         * 处理
         */
        edit?: boolean;
        /**
         * 转交
         */
        transfer?: boolean;
        /**
         * 催办
         */
        reminders?: boolean;
      };
    }[];
    pageNum?: number;
    pageSize?: number;
    pages?: number;
    size?: number;
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [查询巡检列表（分页）↗](http://yapi.cai-inc.com/project/3096/interface/api/486594) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [巡检单位侧相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51967)
 * @请求头 `POST /zlb/api/sop/org/inspection/page`
 * @更新时间 `2023-06-15 16:32:17`
 * @项目ID 3096
 */
type ZlbApiSopOrgInspectionPagePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/org/inspection/page',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [查询巡检列表（分页）↗](http://yapi.cai-inc.com/project/3096/interface/api/486594) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [巡检单位侧相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51967)
 * @请求头 `POST /zlb/api/sop/org/inspection/page`
 * @更新时间 `2023-06-15 16:32:17`
 * @项目ID 3096
 */
const zlbApiSopOrgInspectionPagePostRequestConfig: ZlbApiSopOrgInspectionPagePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_5,
    devUrl: devUrl_0_2_0_5,
    prodUrl: prodUrl_0_2_0_5,
    path: '/zlb/api/sop/org/inspection/page',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopOrgInspectionPagePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询巡检列表（分页）↗](http://yapi.cai-inc.com/project/3096/interface/api/486594) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [巡检单位侧相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51967)
 * @请求头 `POST /zlb/api/sop/org/inspection/page`
 * @更新时间 `2023-06-15 16:32:17`
 * @项目ID 3096
 */
export const zlbApiSopOrgInspectionPagePost = /*#__PURE__*/ (
  requestData: ZlbApiSopOrgInspectionPagePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopOrgInspectionPagePostResponse>(
    prepare(zlbApiSopOrgInspectionPagePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopOrgInspectionPagePost.requestConfig = zlbApiSopOrgInspectionPagePostRequestConfig;

const mockUrl_0_2_0_6 = 'http://yapi.cai-inc.com/mock/3096' as any;
const devUrl_0_2_0_6 = '' as any;
const prodUrl_0_2_0_6 = '' as any;
const dataKey_0_2_0_6 = 'data' as any;

/**
 * 接口 [查询巡检记录↗](http://yapi.cai-inc.com/project/3096/interface/api/473866) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [巡检租户侧相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51968)
 * @请求头 `GET /zlb/api/sop/tenant/inspection/log-page`
 * @更新时间 `2023-12-19 19:54:32`
 * @项目ID 3096
 */
export interface ZlbApiSopTenantInspectionLogPageGetRequest {
  /**
   * 区划code
   */
  districtCode?: string;
  /**
   * 年份
   */
  year?: string;
  /**
   * 月份
   */
  month?: string;
  /**
   * 次数
   */
  count?: string;
  /**
   * 页面大小
   */
  pageSize?: string;
  /**
   * 页码
   */
  pageNo?: string;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
}

/**
 * 接口 [查询巡检记录↗](http://yapi.cai-inc.com/project/3096/interface/api/473866) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [巡检租户侧相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51968)
 * @请求头 `GET /zlb/api/sop/tenant/inspection/log-page`
 * @更新时间 `2023-12-19 19:54:32`
 * @项目ID 3096
 */
export interface ZlbApiSopTenantInspectionLogPageGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 巡检记录名称
       */
      inspectionLogName?: string;
      /**
       * 巡检次数
       */
      inspectionCount?: number;
      /**
       * 巡检时间
       */
      rAddTime?: string;
      /**
       * 巡检城市
       */
      inspectionCity?: string;
      /**
       * 区划code
       */
      districtCode?: string;
      /**
       * 单位风险数
       */
      riskOrgCount?: number;
      /**
       * 总单位数
       */
      totalOrgCount?: number;
      /**
       * 总触发风险数
       */
      totalRiskCount?: number;
      /**
       * 增量风险数
       */
      incrementRiskCount?: number;
      /**
       * 待处理风险数
       */
      pendingRiskCount?: number;
      /**
       * 记录编号
       */
      logNo?: string;
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询巡检记录↗](http://yapi.cai-inc.com/project/3096/interface/api/473866) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [巡检租户侧相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51968)
 * @请求头 `GET /zlb/api/sop/tenant/inspection/log-page`
 * @更新时间 `2023-12-19 19:54:32`
 * @项目ID 3096
 */
type ZlbApiSopTenantInspectionLogPageGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/tenant/inspection/log-page',
    'data',
    string,
    'districtCode' | 'year' | 'month' | 'count' | 'pageSize' | 'pageNo' | 'sortField' | 'sortBy',
    false
  >
>;

/**
 * 接口 [查询巡检记录↗](http://yapi.cai-inc.com/project/3096/interface/api/473866) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [巡检租户侧相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51968)
 * @请求头 `GET /zlb/api/sop/tenant/inspection/log-page`
 * @更新时间 `2023-12-19 19:54:32`
 * @项目ID 3096
 */
const zlbApiSopTenantInspectionLogPageGetRequestConfig: ZlbApiSopTenantInspectionLogPageGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_6,
    devUrl: devUrl_0_2_0_6,
    prodUrl: prodUrl_0_2_0_6,
    path: '/zlb/api/sop/tenant/inspection/log-page',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_6,
    paramNames: [],
    queryNames: [
      'districtCode',
      'year',
      'month',
      'count',
      'pageSize',
      'pageNo',
      'sortField',
      'sortBy',
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopTenantInspectionLogPageGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询巡检记录↗](http://yapi.cai-inc.com/project/3096/interface/api/473866) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [巡检租户侧相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51968)
 * @请求头 `GET /zlb/api/sop/tenant/inspection/log-page`
 * @更新时间 `2023-12-19 19:54:32`
 * @项目ID 3096
 */
export const zlbApiSopTenantInspectionLogPageGet = /*#__PURE__*/ (
  requestData: ZlbApiSopTenantInspectionLogPageGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopTenantInspectionLogPageGetResponse>(
    prepare(zlbApiSopTenantInspectionLogPageGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopTenantInspectionLogPageGet.requestConfig =
  zlbApiSopTenantInspectionLogPageGetRequestConfig;

/**
 * 接口 [事件催办↗](http://yapi.cai-inc.com/project/3096/interface/api/473874) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [巡检租户侧相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51968)
 * @请求头 `GET /zlb/api/sop/tenant/inspection/reminders/{eventNo}`
 * @更新时间 `2023-12-19 19:54:33`
 * @项目ID 3096
 */
export interface ZlbApiSopTenantInspectionRemindersEventNoGetRequest {
  eventNo: string;
}

/**
 * 接口 [事件催办↗](http://yapi.cai-inc.com/project/3096/interface/api/473874) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [巡检租户侧相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51968)
 * @请求头 `GET /zlb/api/sop/tenant/inspection/reminders/{eventNo}`
 * @更新时间 `2023-12-19 19:54:33`
 * @项目ID 3096
 */
export interface ZlbApiSopTenantInspectionRemindersEventNoGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [事件催办↗](http://yapi.cai-inc.com/project/3096/interface/api/473874) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [巡检租户侧相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51968)
 * @请求头 `GET /zlb/api/sop/tenant/inspection/reminders/{eventNo}`
 * @更新时间 `2023-12-19 19:54:33`
 * @项目ID 3096
 */
type ZlbApiSopTenantInspectionRemindersEventNoGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/tenant/inspection/reminders/{eventNo}',
    'data',
    'eventNo',
    string,
    false
  >
>;

/**
 * 接口 [事件催办↗](http://yapi.cai-inc.com/project/3096/interface/api/473874) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [巡检租户侧相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51968)
 * @请求头 `GET /zlb/api/sop/tenant/inspection/reminders/{eventNo}`
 * @更新时间 `2023-12-19 19:54:33`
 * @项目ID 3096
 */
const zlbApiSopTenantInspectionRemindersEventNoGetRequestConfig: ZlbApiSopTenantInspectionRemindersEventNoGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_6,
    devUrl: devUrl_0_2_0_6,
    prodUrl: prodUrl_0_2_0_6,
    path: '/zlb/api/sop/tenant/inspection/reminders/{eventNo}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_6,
    paramNames: ['eventNo'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopTenantInspectionRemindersEventNoGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [事件催办↗](http://yapi.cai-inc.com/project/3096/interface/api/473874) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [巡检租户侧相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51968)
 * @请求头 `GET /zlb/api/sop/tenant/inspection/reminders/{eventNo}`
 * @更新时间 `2023-12-19 19:54:33`
 * @项目ID 3096
 */
export const zlbApiSopTenantInspectionRemindersEventNoGet = /*#__PURE__*/ (
  requestData: ZlbApiSopTenantInspectionRemindersEventNoGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopTenantInspectionRemindersEventNoGetResponse>(
    prepare(zlbApiSopTenantInspectionRemindersEventNoGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopTenantInspectionRemindersEventNoGet.requestConfig =
  zlbApiSopTenantInspectionRemindersEventNoGetRequestConfig;

/**
 * 接口 [事件重新打开↗](http://yapi.cai-inc.com/project/3096/interface/api/473882) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [巡检租户侧相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51968)
 * @请求头 `GET /zlb/api/sop/tenant/inspection/event-reopen/{eventNo}`
 * @更新时间 `2023-12-19 19:54:33`
 * @项目ID 3096
 */
export interface ZlbApiSopTenantInspectionEventReopenEventNoGetRequest {
  eventNo: string;
}

/**
 * 接口 [事件重新打开↗](http://yapi.cai-inc.com/project/3096/interface/api/473882) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [巡检租户侧相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51968)
 * @请求头 `GET /zlb/api/sop/tenant/inspection/event-reopen/{eventNo}`
 * @更新时间 `2023-12-19 19:54:33`
 * @项目ID 3096
 */
export interface ZlbApiSopTenantInspectionEventReopenEventNoGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [事件重新打开↗](http://yapi.cai-inc.com/project/3096/interface/api/473882) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [巡检租户侧相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51968)
 * @请求头 `GET /zlb/api/sop/tenant/inspection/event-reopen/{eventNo}`
 * @更新时间 `2023-12-19 19:54:33`
 * @项目ID 3096
 */
type ZlbApiSopTenantInspectionEventReopenEventNoGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/tenant/inspection/event-reopen/{eventNo}',
    'data',
    'eventNo',
    string,
    false
  >
>;

/**
 * 接口 [事件重新打开↗](http://yapi.cai-inc.com/project/3096/interface/api/473882) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [巡检租户侧相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51968)
 * @请求头 `GET /zlb/api/sop/tenant/inspection/event-reopen/{eventNo}`
 * @更新时间 `2023-12-19 19:54:33`
 * @项目ID 3096
 */
const zlbApiSopTenantInspectionEventReopenEventNoGetRequestConfig: ZlbApiSopTenantInspectionEventReopenEventNoGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_6,
    devUrl: devUrl_0_2_0_6,
    prodUrl: prodUrl_0_2_0_6,
    path: '/zlb/api/sop/tenant/inspection/event-reopen/{eventNo}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_6,
    paramNames: ['eventNo'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopTenantInspectionEventReopenEventNoGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [事件重新打开↗](http://yapi.cai-inc.com/project/3096/interface/api/473882) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [巡检租户侧相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51968)
 * @请求头 `GET /zlb/api/sop/tenant/inspection/event-reopen/{eventNo}`
 * @更新时间 `2023-12-19 19:54:33`
 * @项目ID 3096
 */
export const zlbApiSopTenantInspectionEventReopenEventNoGet = /*#__PURE__*/ (
  requestData: ZlbApiSopTenantInspectionEventReopenEventNoGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopTenantInspectionEventReopenEventNoGetResponse>(
    prepare(zlbApiSopTenantInspectionEventReopenEventNoGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopTenantInspectionEventReopenEventNoGet.requestConfig =
  zlbApiSopTenantInspectionEventReopenEventNoGetRequestConfig;

/**
 * 接口 [事件处理↗](http://yapi.cai-inc.com/project/3096/interface/api/473898) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [巡检租户侧相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51968)
 * @请求头 `POST /zlb/api/sop/tenant/inspection/dispose`
 * @更新时间 `2023-12-19 19:54:34`
 * @项目ID 3096
 */
export interface ZlbApiSopTenantInspectionDisposePostRequest {
  /**
   * 处理状态
   */
  status: number;
  /**
   * 备注
   */
  remark?: string;
  /**
   * 事件编号
   */
  eventNoList: string[];
}

/**
 * 接口 [事件处理↗](http://yapi.cai-inc.com/project/3096/interface/api/473898) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [巡检租户侧相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51968)
 * @请求头 `POST /zlb/api/sop/tenant/inspection/dispose`
 * @更新时间 `2023-12-19 19:54:34`
 * @项目ID 3096
 */
export interface ZlbApiSopTenantInspectionDisposePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [事件处理↗](http://yapi.cai-inc.com/project/3096/interface/api/473898) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [巡检租户侧相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51968)
 * @请求头 `POST /zlb/api/sop/tenant/inspection/dispose`
 * @更新时间 `2023-12-19 19:54:34`
 * @项目ID 3096
 */
type ZlbApiSopTenantInspectionDisposePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/tenant/inspection/dispose',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [事件处理↗](http://yapi.cai-inc.com/project/3096/interface/api/473898) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [巡检租户侧相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51968)
 * @请求头 `POST /zlb/api/sop/tenant/inspection/dispose`
 * @更新时间 `2023-12-19 19:54:34`
 * @项目ID 3096
 */
const zlbApiSopTenantInspectionDisposePostRequestConfig: ZlbApiSopTenantInspectionDisposePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_6,
    devUrl: devUrl_0_2_0_6,
    prodUrl: prodUrl_0_2_0_6,
    path: '/zlb/api/sop/tenant/inspection/dispose',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_6,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopTenantInspectionDisposePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [事件处理↗](http://yapi.cai-inc.com/project/3096/interface/api/473898) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [巡检租户侧相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51968)
 * @请求头 `POST /zlb/api/sop/tenant/inspection/dispose`
 * @更新时间 `2023-12-19 19:54:34`
 * @项目ID 3096
 */
export const zlbApiSopTenantInspectionDisposePost = /*#__PURE__*/ (
  requestData: ZlbApiSopTenantInspectionDisposePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopTenantInspectionDisposePostResponse>(
    prepare(zlbApiSopTenantInspectionDisposePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopTenantInspectionDisposePost.requestConfig =
  zlbApiSopTenantInspectionDisposePostRequestConfig;

/**
 * 接口 [开通应用↗](http://yapi.cai-inc.com/project/3096/interface/api/481314) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [巡检租户侧相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51968)
 * @请求头 `POST /zlb/api/sop/tenant/inspection/open-application`
 * @更新时间 `2023-12-19 19:54:33`
 * @项目ID 3096
 */
export type ZlbApiSopTenantInspectionOpenApplicationPostRequest = string;

/**
 * 接口 [开通应用↗](http://yapi.cai-inc.com/project/3096/interface/api/481314) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [巡检租户侧相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51968)
 * @请求头 `POST /zlb/api/sop/tenant/inspection/open-application`
 * @更新时间 `2023-12-19 19:54:33`
 * @项目ID 3096
 */
export interface ZlbApiSopTenantInspectionOpenApplicationPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [开通应用↗](http://yapi.cai-inc.com/project/3096/interface/api/481314) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [巡检租户侧相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51968)
 * @请求头 `POST /zlb/api/sop/tenant/inspection/open-application`
 * @更新时间 `2023-12-19 19:54:33`
 * @项目ID 3096
 */
type ZlbApiSopTenantInspectionOpenApplicationPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/tenant/inspection/open-application',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [开通应用↗](http://yapi.cai-inc.com/project/3096/interface/api/481314) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [巡检租户侧相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51968)
 * @请求头 `POST /zlb/api/sop/tenant/inspection/open-application`
 * @更新时间 `2023-12-19 19:54:33`
 * @项目ID 3096
 */
const zlbApiSopTenantInspectionOpenApplicationPostRequestConfig: ZlbApiSopTenantInspectionOpenApplicationPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_6,
    devUrl: devUrl_0_2_0_6,
    prodUrl: prodUrl_0_2_0_6,
    path: '/zlb/api/sop/tenant/inspection/open-application',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_6,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopTenantInspectionOpenApplicationPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [开通应用↗](http://yapi.cai-inc.com/project/3096/interface/api/481314) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [巡检租户侧相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51968)
 * @请求头 `POST /zlb/api/sop/tenant/inspection/open-application`
 * @更新时间 `2023-12-19 19:54:33`
 * @项目ID 3096
 */
export const zlbApiSopTenantInspectionOpenApplicationPost = /*#__PURE__*/ (
  requestData: ZlbApiSopTenantInspectionOpenApplicationPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopTenantInspectionOpenApplicationPostResponse>(
    prepare(zlbApiSopTenantInspectionOpenApplicationPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopTenantInspectionOpenApplicationPost.requestConfig =
  zlbApiSopTenantInspectionOpenApplicationPostRequestConfig;

/**
 * 接口 [查询巡检列表（分页）↗](http://yapi.cai-inc.com/project/3096/interface/api/482930) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [巡检租户侧相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51968)
 * @请求头 `POST /zlb/api/sop/tenant/inspection/page`
 * @更新时间 `2023-12-19 19:54:32`
 * @项目ID 3096
 */
export interface ZlbApiSopTenantInspectionPagePostRequest {
  /**
   * 记录编号
   */
  logNo?: string;
  /**
   * 事件编号
   */
  eventNo?: string;
  /**
   * 巡检状态(0：待下发，1：已下发，待处理，2：单位已处理，待确认，3：单位申请复议，待处理，4：已完结，5：已完结-误判)
   */
  status?: number[];
  /**
   * 事件类型
   */
  eventType?: number;
  /**
   * 区划code
   */
  districtCode?: string;
  /**
   * 单位id
   */
  orgId?: number;
  /**
   * 巡检年份
   */
  year?: number;
  /**
   * 巡检月份
   */
  month?: number;
  /**
   * 巡检次数
   */
  inspectionCount?: number;
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
}

/**
 * 接口 [查询巡检列表（分页）↗](http://yapi.cai-inc.com/project/3096/interface/api/482930) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [巡检租户侧相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51968)
 * @请求头 `POST /zlb/api/sop/tenant/inspection/page`
 * @更新时间 `2023-12-19 19:54:32`
 * @项目ID 3096
 */
export interface ZlbApiSopTenantInspectionPagePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 事件编号
       */
      eventNo?: string;
      /**
       * 巡检记录
       */
      inspectionLogName?: string;
      /**
       * 巡检次数
       */
      inspectionCount?: number;
      /**
       * 区划名称
       */
      districtName?: string;
      /**
       * 单位名称
       */
      orgName?: string;
      /**
       * 事件类型
       */
      eventType?: number;
      /**
       * 事件类型描述
       */
      eventTypeDesc?: string;
      /**
       * 催办次数
       */
      urgeCount?: number;
      /**
       * 巡检状态
       */
      status?: number;
      /**
       * 巡检状态描述
       */
      statusDesc?: string;
      /**
       * 创建时间
       */
      rAddTime?: string;
      /**
       * 巡检时间
       */
      inspectionDate?: string;
      /**
       * 操作按钮
       */
      operateButton?: {
        /**
         * 详情
         */
        detail?: boolean;
        /**
         * 重新打开
         */
        restart?: boolean;
        /**
         * 处理
         */
        edit?: boolean;
        /**
         * 转交
         */
        transfer?: boolean;
        /**
         * 催办
         */
        reminders?: boolean;
      };
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询巡检列表（分页）↗](http://yapi.cai-inc.com/project/3096/interface/api/482930) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [巡检租户侧相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51968)
 * @请求头 `POST /zlb/api/sop/tenant/inspection/page`
 * @更新时间 `2023-12-19 19:54:32`
 * @项目ID 3096
 */
type ZlbApiSopTenantInspectionPagePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/tenant/inspection/page',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [查询巡检列表（分页）↗](http://yapi.cai-inc.com/project/3096/interface/api/482930) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [巡检租户侧相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51968)
 * @请求头 `POST /zlb/api/sop/tenant/inspection/page`
 * @更新时间 `2023-12-19 19:54:32`
 * @项目ID 3096
 */
const zlbApiSopTenantInspectionPagePostRequestConfig: ZlbApiSopTenantInspectionPagePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_6,
    devUrl: devUrl_0_2_0_6,
    prodUrl: prodUrl_0_2_0_6,
    path: '/zlb/api/sop/tenant/inspection/page',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_6,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopTenantInspectionPagePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询巡检列表（分页）↗](http://yapi.cai-inc.com/project/3096/interface/api/482930) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [巡检租户侧相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51968)
 * @请求头 `POST /zlb/api/sop/tenant/inspection/page`
 * @更新时间 `2023-12-19 19:54:32`
 * @项目ID 3096
 */
export const zlbApiSopTenantInspectionPagePost = /*#__PURE__*/ (
  requestData: ZlbApiSopTenantInspectionPagePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopTenantInspectionPagePostResponse>(
    prepare(zlbApiSopTenantInspectionPagePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopTenantInspectionPagePost.requestConfig = zlbApiSopTenantInspectionPagePostRequestConfig;

/**
 * 接口 [事件批量催办↗](http://yapi.cai-inc.com/project/3096/interface/api/595506) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [巡检租户侧相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51968)
 * @请求头 `POST /zlb/api/sop/tenant/inspection/batch-reminders`
 * @更新时间 `2023-12-19 19:54:33`
 * @项目ID 3096
 */
export interface ZlbApiSopTenantInspectionBatchRemindersPostRequest {
  /**
   * 事件编号
   */
  eventNoList: string[];
}

/**
 * 接口 [事件批量催办↗](http://yapi.cai-inc.com/project/3096/interface/api/595506) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [巡检租户侧相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51968)
 * @请求头 `POST /zlb/api/sop/tenant/inspection/batch-reminders`
 * @更新时间 `2023-12-19 19:54:33`
 * @项目ID 3096
 */
export interface ZlbApiSopTenantInspectionBatchRemindersPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [事件批量催办↗](http://yapi.cai-inc.com/project/3096/interface/api/595506) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [巡检租户侧相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51968)
 * @请求头 `POST /zlb/api/sop/tenant/inspection/batch-reminders`
 * @更新时间 `2023-12-19 19:54:33`
 * @项目ID 3096
 */
type ZlbApiSopTenantInspectionBatchRemindersPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/tenant/inspection/batch-reminders',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [事件批量催办↗](http://yapi.cai-inc.com/project/3096/interface/api/595506) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [巡检租户侧相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51968)
 * @请求头 `POST /zlb/api/sop/tenant/inspection/batch-reminders`
 * @更新时间 `2023-12-19 19:54:33`
 * @项目ID 3096
 */
const zlbApiSopTenantInspectionBatchRemindersPostRequestConfig: ZlbApiSopTenantInspectionBatchRemindersPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_6,
    devUrl: devUrl_0_2_0_6,
    prodUrl: prodUrl_0_2_0_6,
    path: '/zlb/api/sop/tenant/inspection/batch-reminders',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_6,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopTenantInspectionBatchRemindersPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [事件批量催办↗](http://yapi.cai-inc.com/project/3096/interface/api/595506) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [巡检租户侧相关↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_51968)
 * @请求头 `POST /zlb/api/sop/tenant/inspection/batch-reminders`
 * @更新时间 `2023-12-19 19:54:33`
 * @项目ID 3096
 */
export const zlbApiSopTenantInspectionBatchRemindersPost = /*#__PURE__*/ (
  requestData: ZlbApiSopTenantInspectionBatchRemindersPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopTenantInspectionBatchRemindersPostResponse>(
    prepare(zlbApiSopTenantInspectionBatchRemindersPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopTenantInspectionBatchRemindersPost.requestConfig =
  zlbApiSopTenantInspectionBatchRemindersPostRequestConfig;

const mockUrl_0_2_0_7 = 'http://yapi.cai-inc.com/mock/3096' as any;
const devUrl_0_2_0_7 = '' as any;
const prodUrl_0_2_0_7 = '' as any;
const dataKey_0_2_0_7 = 'data' as any;

/**
 * 接口 [保存↗](http://yapi.cai-inc.com/project/3096/interface/api/499122) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [租户侧弹窗↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52525)
 * @请求头 `POST /zlb/api/sop/tenant/notice/save`
 * @更新时间 `2023-07-18 11:48:49`
 * @项目ID 3096
 */
export interface ZlbApiSopTenantNoticeSavePostRequest {
  /**
   * 接收范围类型 1、按租户 2、按机构
   */
  rangeType: number;
  /**
   * 接收范围
   * 区划或机构
   */
  rangeInfoList: {
    /**
     * 权限code （租户or机构）
     */
    rangeCode: string;
    /**
     * 权限名称 （租户or机构）
     */
    rangeName: string;
  }[];
  /**
   * 状态： 0:禁用 1:启用
   */
  status: number;
  /**
   * 排序
   */
  sort: number;
  /**
   * 公告通知唯一code
   */
  noticeCode?: string;
  /**
   * 公告通知类型 1：图片弹窗 2：系统公告-版本更新 3：系统公告-紧急通知 4、系统公告-营销活动
   */
  noticeType: 1 | 2 | 3 | 4;
  /**
   * 通知弹窗标题
   */
  noticeTitle: string;
  /**
   * 通知弹窗内容
   */
  noticeContent?: string;
  /**
   * 弹窗位置 1、用户端 2、区划后台 3、运营后台
   */
  noticeLocation?: number;
  /**
   * 关联内容类型 0：链接
   */
  linkContentType?: number;
  /**
   * 生效开始时间 时间戳
   */
  effectiveStartTime?: string;
  /**
   * 生效结束时间 时间戳
   */
  effectiveEndTime?: string;
  /**
   * 弹窗频率 1：每日一次 2：每周一次
   */
  noticeFreq?: number;
  /**
   * 扩展字段
   */
  extendInfo?: string;
  /**
   * 附件图片列表
   */
  files?: {
    /**
     * 附件OSSId
     */
    fileId?: string;
    /**
     * 附件名称
     */
    name?: string;
    /**
     * 附件大小
     */
    size?: number;
    /**
     * 附件格式
     */
    type?: string;
    /**
     * 附件地址
     */
    url?: string;
    /**
     * 附件类型：1-封面图，2-附件 3-公告图
     */
    bizType?: number;
    /**
     * 业务子类型 1-PC 2-APP
     */
    subType?: 1 | 2;
  }[];
  /**
   * 链接地址
   */
  noticeLink?: {
    /**
     * APP
     */
    appLink?: string;
    /**
     * PC
     */
    pcLink?: string;
  };
}

/**
 * 接口 [保存↗](http://yapi.cai-inc.com/project/3096/interface/api/499122) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [租户侧弹窗↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52525)
 * @请求头 `POST /zlb/api/sop/tenant/notice/save`
 * @更新时间 `2023-07-18 11:48:49`
 * @项目ID 3096
 */
export interface ZlbApiSopTenantNoticeSavePostResponse {
  success?: boolean;
  result?: boolean;
  code?: string;
  message?: string;
}

/**
 * 接口 [保存↗](http://yapi.cai-inc.com/project/3096/interface/api/499122) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [租户侧弹窗↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52525)
 * @请求头 `POST /zlb/api/sop/tenant/notice/save`
 * @更新时间 `2023-07-18 11:48:49`
 * @项目ID 3096
 */
type ZlbApiSopTenantNoticeSavePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/tenant/notice/save',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [保存↗](http://yapi.cai-inc.com/project/3096/interface/api/499122) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [租户侧弹窗↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52525)
 * @请求头 `POST /zlb/api/sop/tenant/notice/save`
 * @更新时间 `2023-07-18 11:48:49`
 * @项目ID 3096
 */
const zlbApiSopTenantNoticeSavePostRequestConfig: ZlbApiSopTenantNoticeSavePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_7,
    devUrl: devUrl_0_2_0_7,
    prodUrl: prodUrl_0_2_0_7,
    path: '/zlb/api/sop/tenant/notice/save',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_7,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopTenantNoticeSavePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [保存↗](http://yapi.cai-inc.com/project/3096/interface/api/499122) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [租户侧弹窗↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52525)
 * @请求头 `POST /zlb/api/sop/tenant/notice/save`
 * @更新时间 `2023-07-18 11:48:49`
 * @项目ID 3096
 */
export const zlbApiSopTenantNoticeSavePost = /*#__PURE__*/ (
  requestData: ZlbApiSopTenantNoticeSavePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopTenantNoticeSavePostResponse>(
    prepare(zlbApiSopTenantNoticeSavePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopTenantNoticeSavePost.requestConfig = zlbApiSopTenantNoticeSavePostRequestConfig;

/**
 * 接口 [删除↗](http://yapi.cai-inc.com/project/3096/interface/api/499130) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [租户侧弹窗↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52525)
 * @请求头 `DELETE /zlb/api/sop/tenant/notice/delete/{noticeCode}`
 * @更新时间 `2023-07-18 11:48:49`
 * @项目ID 3096
 */
export interface ZlbApiSopTenantNoticeDeleteNoticeCodeDeleteRequest {
  /**
   * 公告通知code唯一编码
   */
  noticeCode: string;
}

/**
 * 接口 [删除↗](http://yapi.cai-inc.com/project/3096/interface/api/499130) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [租户侧弹窗↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52525)
 * @请求头 `DELETE /zlb/api/sop/tenant/notice/delete/{noticeCode}`
 * @更新时间 `2023-07-18 11:48:49`
 * @项目ID 3096
 */
export interface ZlbApiSopTenantNoticeDeleteNoticeCodeDeleteResponse {
  success?: boolean;
  result?: boolean;
  code?: string;
  message?: string;
}

/**
 * 接口 [删除↗](http://yapi.cai-inc.com/project/3096/interface/api/499130) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [租户侧弹窗↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52525)
 * @请求头 `DELETE /zlb/api/sop/tenant/notice/delete/{noticeCode}`
 * @更新时间 `2023-07-18 11:48:49`
 * @项目ID 3096
 */
type ZlbApiSopTenantNoticeDeleteNoticeCodeDeleteRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/tenant/notice/delete/{noticeCode}',
    'data',
    'noticeCode',
    string,
    false
  >
>;

/**
 * 接口 [删除↗](http://yapi.cai-inc.com/project/3096/interface/api/499130) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [租户侧弹窗↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52525)
 * @请求头 `DELETE /zlb/api/sop/tenant/notice/delete/{noticeCode}`
 * @更新时间 `2023-07-18 11:48:49`
 * @项目ID 3096
 */
const zlbApiSopTenantNoticeDeleteNoticeCodeDeleteRequestConfig: ZlbApiSopTenantNoticeDeleteNoticeCodeDeleteRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_7,
    devUrl: devUrl_0_2_0_7,
    prodUrl: prodUrl_0_2_0_7,
    path: '/zlb/api/sop/tenant/notice/delete/{noticeCode}',
    method: Method.DELETE,
    requestHeaders: {},
    requestBodyType: RequestBodyType.none,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_7,
    paramNames: ['noticeCode'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopTenantNoticeDeleteNoticeCodeDelete',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [删除↗](http://yapi.cai-inc.com/project/3096/interface/api/499130) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [租户侧弹窗↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52525)
 * @请求头 `DELETE /zlb/api/sop/tenant/notice/delete/{noticeCode}`
 * @更新时间 `2023-07-18 11:48:49`
 * @项目ID 3096
 */
export const zlbApiSopTenantNoticeDeleteNoticeCodeDelete = /*#__PURE__*/ (
  requestData: ZlbApiSopTenantNoticeDeleteNoticeCodeDeleteRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopTenantNoticeDeleteNoticeCodeDeleteResponse>(
    prepare(zlbApiSopTenantNoticeDeleteNoticeCodeDeleteRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopTenantNoticeDeleteNoticeCodeDelete.requestConfig =
  zlbApiSopTenantNoticeDeleteNoticeCodeDeleteRequestConfig;

/**
 * 接口 [查看详情↗](http://yapi.cai-inc.com/project/3096/interface/api/499138) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [租户侧弹窗↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52525)
 * @请求头 `GET /zlb/api/sop/tenant/notice/{noticeCode}`
 * @更新时间 `2023-07-18 11:48:49`
 * @项目ID 3096
 */
export interface ZlbApiSopTenantNoticeNoticeCodeGetRequest {
  /**
   * 公告通知code唯一编码
   */
  noticeCode: string;
}

/**
 * 接口 [查看详情↗](http://yapi.cai-inc.com/project/3096/interface/api/499138) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [租户侧弹窗↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52525)
 * @请求头 `GET /zlb/api/sop/tenant/notice/{noticeCode}`
 * @更新时间 `2023-07-18 11:48:49`
 * @项目ID 3096
 */
export interface ZlbApiSopTenantNoticeNoticeCodeGetResponse {
  success?: boolean;
  result?: {
    /**
     * 状态： 0:启用 1:禁用
     */
    statusDesc?: string;
    status?: number;
    /**
     * 接收范围类型 1、按区划 2、按机构
     */
    rangeType?: number;
    /**
     * 接收范围类型 1、按区划 2、按机构
     */
    rangeTypeDesc?: string;
    /**
     * 区划或机构
     */
    rangeInfoList?: {
      /**
       * 权限code （租户or机构）
       */
      rangeCode: string;
      /**
       * 权限名称 （租户or机构）
       */
      rangeName: string;
    }[];
    /**
     * 排序
     */
    sort?: number;
    /**
     * 公告通知唯一code
     */
    noticeCode?: string;
    /**
     * 公告通知类型 1：图片 2：文字
     */
    noticeType?: number;
    /**
     * 弹窗位置
     */
    noticeLocation?: number;
    /**
     * 通知弹窗标题
     */
    noticeTitle?: string;
    /**
     * 通知弹窗内容
     */
    noticeContent?: string;
    /**
     * 关联内容类型 0：数据排行
     */
    linkContentType?: number;
    /**
     * 关联内容设置 0:区划数据排行
     */
    linkContentSettings?: number;
    /**
     * 生效开始时间
     */
    effectiveStartTime?: string;
    /**
     * 生效结束时间
     */
    effectiveEndTime?: string;
    /**
     * 弹窗频率 1：每日一次 2：每周一次
     */
    noticeFreq?: number;
    /**
     * 扩展字段
     */
    extendInfo?: string;
    /**
     * 附件图片列表
     */
    files?: {
      /**
       * 附件OSSId
       */
      fileId?: string;
      /**
       * 附件名称
       */
      name?: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 附件格式
       */
      type?: string;
      /**
       * url
       */
      url?: string;
      /**
       * 文件类型 1-标题图片，2-附件
       */
      bizType?: number;
      /**
       * 子业务类型 1-pc   2-app
       */
      subType?: number;
    }[];
    noticeLink?: {
      /**
       * APP
       */
      appLink?: string;
      /**
       * PC
       */
      pcLink?: string;
    };
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [查看详情↗](http://yapi.cai-inc.com/project/3096/interface/api/499138) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [租户侧弹窗↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52525)
 * @请求头 `GET /zlb/api/sop/tenant/notice/{noticeCode}`
 * @更新时间 `2023-07-18 11:48:49`
 * @项目ID 3096
 */
type ZlbApiSopTenantNoticeNoticeCodeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/tenant/notice/{noticeCode}',
    'data',
    'noticeCode',
    string,
    false
  >
>;

/**
 * 接口 [查看详情↗](http://yapi.cai-inc.com/project/3096/interface/api/499138) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [租户侧弹窗↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52525)
 * @请求头 `GET /zlb/api/sop/tenant/notice/{noticeCode}`
 * @更新时间 `2023-07-18 11:48:49`
 * @项目ID 3096
 */
const zlbApiSopTenantNoticeNoticeCodeGetRequestConfig: ZlbApiSopTenantNoticeNoticeCodeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_7,
    devUrl: devUrl_0_2_0_7,
    prodUrl: prodUrl_0_2_0_7,
    path: '/zlb/api/sop/tenant/notice/{noticeCode}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_7,
    paramNames: ['noticeCode'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopTenantNoticeNoticeCodeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查看详情↗](http://yapi.cai-inc.com/project/3096/interface/api/499138) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [租户侧弹窗↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52525)
 * @请求头 `GET /zlb/api/sop/tenant/notice/{noticeCode}`
 * @更新时间 `2023-07-18 11:48:49`
 * @项目ID 3096
 */
export const zlbApiSopTenantNoticeNoticeCodeGet = /*#__PURE__*/ (
  requestData: ZlbApiSopTenantNoticeNoticeCodeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopTenantNoticeNoticeCodeGetResponse>(
    prepare(zlbApiSopTenantNoticeNoticeCodeGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopTenantNoticeNoticeCodeGet.requestConfig = zlbApiSopTenantNoticeNoticeCodeGetRequestConfig;

/**
 * 接口 [查询通知列表（分页）治理端↗](http://yapi.cai-inc.com/project/3096/interface/api/499146) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [租户侧弹窗↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52525)
 * @请求头 `POST /zlb/api/sop/tenant/notice/list`
 * @更新时间 `2023-07-18 11:48:49`
 * @项目ID 3096
 */
export interface ZlbApiSopTenantNoticeListPostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 接收范围类型 1、按区划 2、按机构
   */
  rangeType?: number;
  /**
   * 区划或机构
   */
  rangeContent?: string;
  /**
   * 状态： 0:启用 1:禁用
   */
  status?: number;
  /**
   * 租户code
   */
  tenantCode?: string;
  /**
   * 通知弹窗标题
   */
  noticeTitle?: string;
}

/**
 * 接口 [查询通知列表（分页）治理端↗](http://yapi.cai-inc.com/project/3096/interface/api/499146) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [租户侧弹窗↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52525)
 * @请求头 `POST /zlb/api/sop/tenant/notice/list`
 * @更新时间 `2023-07-18 11:48:49`
 * @项目ID 3096
 */
export interface ZlbApiSopTenantNoticeListPostResponse {
  success?: boolean;
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 状态： 0:启用 1:禁用
       */
      statusDesc?: string;
      status?: number;
      /**
       * 接收范围类型 1、按区划 2、按机构
       */
      rangeType?: number;
      /**
       * 接收范围类型 1、按区划 2、按机构
       */
      rangeTypeDesc?: string;
      /**
       * 区划或机构
       */
      rangeInfoList?: {
        /**
         * 权限code （租户or机构）
         */
        rangeCode: string;
        /**
         * 权限名称 （租户or机构）
         */
        rangeName: string;
      }[];
      /**
       * 排序
       */
      sort?: number;
      /**
       * 公告通知唯一code
       */
      noticeCode?: string;
      /**
       * 通知弹窗标题
       */
      noticeTitle?: string;
      /**
       * 通知弹窗内容
       */
      noticeContent?: string;
      noticeLocation?: number;
      /**
       * 通知弹窗类型
       */
      noticeType?: number;
      /**
       * 通知弹窗类型
       */
      noticeTypeName?: string;
      /**
       * 生效开始时间 时间戳
       */
      effectiveStartTime?: string;
      /**
       * 生效结束时间 时间戳
       */
      effectiveEndTime?: string;
      /**
       * 弹窗频率 1：每日一次 2：每周一次
       */
      noticeFreqName?: string;
      /**
       * 附件图片列表
       */
      files?: {
        /**
         * 附件OSSId
         */
        fileId?: string;
        /**
         * 附件名称
         */
        name?: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 附件格式
         */
        type?: string;
        /**
         * url
         */
        url?: string;
        /**
         * 文件类型 1-标题图片，2-附件
         */
        bizType?: number;
        /**
         * 子业务类型 1-pc   2-app
         */
        subType?: number;
      }[];
      /**
       * 链接地址
       */
      noticeLink?: {
        /**
         * APP
         */
        appLink?: string;
        /**
         * PC
         */
        pcLink?: string;
      };
    }[];
    /**
     * 第几页
     */
    pageNum?: number;
    /**
     * 每页记录数
     */
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 当前页的数量 <= pageSize，该属性来自ArrayList的size属性
     */
    size?: number;
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [查询通知列表（分页）治理端↗](http://yapi.cai-inc.com/project/3096/interface/api/499146) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [租户侧弹窗↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52525)
 * @请求头 `POST /zlb/api/sop/tenant/notice/list`
 * @更新时间 `2023-07-18 11:48:49`
 * @项目ID 3096
 */
type ZlbApiSopTenantNoticeListPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/tenant/notice/list',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [查询通知列表（分页）治理端↗](http://yapi.cai-inc.com/project/3096/interface/api/499146) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [租户侧弹窗↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52525)
 * @请求头 `POST /zlb/api/sop/tenant/notice/list`
 * @更新时间 `2023-07-18 11:48:49`
 * @项目ID 3096
 */
const zlbApiSopTenantNoticeListPostRequestConfig: ZlbApiSopTenantNoticeListPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_7,
    devUrl: devUrl_0_2_0_7,
    prodUrl: prodUrl_0_2_0_7,
    path: '/zlb/api/sop/tenant/notice/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_7,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopTenantNoticeListPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询通知列表（分页）治理端↗](http://yapi.cai-inc.com/project/3096/interface/api/499146) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [租户侧弹窗↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52525)
 * @请求头 `POST /zlb/api/sop/tenant/notice/list`
 * @更新时间 `2023-07-18 11:48:49`
 * @项目ID 3096
 */
export const zlbApiSopTenantNoticeListPost = /*#__PURE__*/ (
  requestData: ZlbApiSopTenantNoticeListPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopTenantNoticeListPostResponse>(
    prepare(zlbApiSopTenantNoticeListPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopTenantNoticeListPost.requestConfig = zlbApiSopTenantNoticeListPostRequestConfig;

const mockUrl_0_2_0_8 = 'http://yapi.cai-inc.com/mock/3096' as any;
const devUrl_0_2_0_8 = '' as any;
const prodUrl_0_2_0_8 = '' as any;
const dataKey_0_2_0_8 = 'data' as any;

/**
 * 接口 [查询文章详情↗](http://yapi.cai-inc.com/project/3096/interface/api/502210) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [文章管理-运营侧↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52527)
 * @请求头 `GET /zlb/api/sop/operation/article/{articleCode}`
 * @更新时间 `2023-07-18 11:49:00`
 * @项目ID 3096
 */
export interface ZlbApiSopOperationArticleArticleCodeGetRequest {
  articleCode: string;
}

/**
 * 接口 [查询文章详情↗](http://yapi.cai-inc.com/project/3096/interface/api/502210) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [文章管理-运营侧↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52527)
 * @请求头 `GET /zlb/api/sop/operation/article/{articleCode}`
 * @更新时间 `2023-07-18 11:49:00`
 * @项目ID 3096
 */
export interface ZlbApiSopOperationArticleArticleCodeGetResponse {
  success?: boolean;
  result?: {
    /**
     * 状态： 0:启用 1:禁用
     */
    statusDesc?: string;
    status?: number;
    /**
     * 接收范围类型 1、按区划 2、按机构
     */
    rangeType?: number;
    /**
     * 接收范围类型 1、按区划 2、按机构
     */
    rangeTypeDesc?: string;
    /**
     * 区划或机构
     */
    rangeInfoList?: {
      /**
       * 权限code （租户or机构）
       */
      rangeCode: string;
      /**
       * 权限名称 （租户or机构）
       */
      rangeName: string;
    }[];
    /**
     * 排序
     */
    sort?: number;
    /**
     * 文章code
     */
    articleCode?: string;
    /**
     * 文章类型
     */
    articleType?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
    /**
     * 标题
     */
    articleTitle?: string;
    /**
     * 发布单位名称
     */
    publishOrgName?: string;
    /**
     * 文件编号
     */
    fileNo?: string;
    /**
     * 文号
     */
    issueNo?: string;
    /**
     * 条法类别
     */
    lawsType?: string;
    /**
     * 法规层次
     */
    lawsLevel?: string;
    /**
     * 颁布日期
     */
    issueDate?: string;
    /**
     * 实施日期
     */
    implementDate?: string;
    /**
     * 发布时间
     */
    postTime?: string;
    /**
     * 正文
     */
    articleContent?: string;
    /**
     * 单据附件
     */
    formAttachmentDTOS?: {
      /**
       * 附件业务子类型
       */
      bizType?: number;
      /**
       * 附件OssId
       */
      fileId?: string;
      /**
       * 附件名称
       */
      name?: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 链接
       */
      url?: string;
    }[];
    /**
     * 附件是否能下载
     */
    isDownload?: boolean
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [查询文章详情↗](http://yapi.cai-inc.com/project/3096/interface/api/502210) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [文章管理-运营侧↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52527)
 * @请求头 `GET /zlb/api/sop/operation/article/{articleCode}`
 * @更新时间 `2023-07-18 11:49:00`
 * @项目ID 3096
 */
type ZlbApiSopOperationArticleArticleCodeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/operation/article/{articleCode}',
    'data',
    'articleCode',
    string,
    false
  >
>;

/**
 * 接口 [查询文章详情↗](http://yapi.cai-inc.com/project/3096/interface/api/502210) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [文章管理-运营侧↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52527)
 * @请求头 `GET /zlb/api/sop/operation/article/{articleCode}`
 * @更新时间 `2023-07-18 11:49:00`
 * @项目ID 3096
 */
const zlbApiSopOperationArticleArticleCodeGetRequestConfig: ZlbApiSopOperationArticleArticleCodeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_8,
    devUrl: devUrl_0_2_0_8,
    prodUrl: prodUrl_0_2_0_8,
    path: '/zlb/api/sop/operation/article/{articleCode}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_8,
    paramNames: ['articleCode'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopOperationArticleArticleCodeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询文章详情↗](http://yapi.cai-inc.com/project/3096/interface/api/502210) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [文章管理-运营侧↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52527)
 * @请求头 `GET /zlb/api/sop/operation/article/{articleCode}`
 * @更新时间 `2023-07-18 11:49:00`
 * @项目ID 3096
 */
export const zlbApiSopOperationArticleArticleCodeGet = /*#__PURE__*/ (
  requestData: ZlbApiSopOperationArticleArticleCodeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopOperationArticleArticleCodeGetResponse>(
    prepare(zlbApiSopOperationArticleArticleCodeGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopOperationArticleArticleCodeGet.requestConfig =
  zlbApiSopOperationArticleArticleCodeGetRequestConfig;

/**
 * 接口 [编辑文章↗](http://yapi.cai-inc.com/project/3096/interface/api/502226) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [文章管理-运营侧↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52527)
 * @请求头 `POST /zlb/api/sop/operation/article/save`
 * @更新时间 `2023-07-18 11:49:00`
 * @项目ID 3096
 */
export interface ZlbApiSopOperationArticleSavePostRequest {
  /**
   * 接收范围类型 1、按租户 2、按机构
   */
  rangeType: number;
  /**
   * 接收范围
   * 区划或机构
   */
  rangeInfoList: {
    /**
     * 权限code （租户or机构）
     */
    rangeCode: string;
    /**
     * 权限名称 （租户or机构）
     */
    rangeName: string;
  }[];
  /**
   * 状态： 0:禁用 1:启用
   */
  status: number;
  /**
   * 排序
   */
  sort: number;
  /**
   * 文章code
   */
  articleCode?: string;
  /**
   * 文章类型
   */
  articleType: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
  /**
   * 标题
   */
  articleTitle: string;
  /**
   * 发布单位名称
   */
  publishOrgName?: string;
  /**
   * 文件编号
   */
  fileNo?: string;
  /**
   * 文号
   */
  issueNo?: string;
  /**
   * 条法类别
   */
  lawsType?: string;
  /**
   * 法规层次
   */
  lawsLevel?: string;
  /**
   * 颁布日期
   */
  issueDate?: string;
  /**
   * 实施日期
   */
  implementDate?: string;
  /**
   * 发布时间
   */
  postTime?: string;
  /**
   * 正文
   */
  articleContent?: string;
  /**
   * 单据附件
   */
  formAttachmentDTOS?: {
    /**
     * 附件业务子类型
     */
    bizType?: number;
    /**
     * 附件OssId
     */
    fileId?: string;
    /**
     * 附件名称
     */
    name?: string;
    /**
     * 附件大小
     */
    size?: number;
    /**
     * 附件类型
     */
    type?: string;
    /**
     * 链接
     */
    url?: string;
  }[];
}

/**
 * 接口 [编辑文章↗](http://yapi.cai-inc.com/project/3096/interface/api/502226) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [文章管理-运营侧↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52527)
 * @请求头 `POST /zlb/api/sop/operation/article/save`
 * @更新时间 `2023-07-18 11:49:00`
 * @项目ID 3096
 */
export interface ZlbApiSopOperationArticleSavePostResponse {
  success?: boolean;
  result?: boolean;
  code?: string;
  message?: string;
}

/**
 * 接口 [编辑文章↗](http://yapi.cai-inc.com/project/3096/interface/api/502226) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [文章管理-运营侧↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52527)
 * @请求头 `POST /zlb/api/sop/operation/article/save`
 * @更新时间 `2023-07-18 11:49:00`
 * @项目ID 3096
 */
type ZlbApiSopOperationArticleSavePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/operation/article/save',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [编辑文章↗](http://yapi.cai-inc.com/project/3096/interface/api/502226) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [文章管理-运营侧↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52527)
 * @请求头 `POST /zlb/api/sop/operation/article/save`
 * @更新时间 `2023-07-18 11:49:00`
 * @项目ID 3096
 */
const zlbApiSopOperationArticleSavePostRequestConfig: ZlbApiSopOperationArticleSavePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_8,
    devUrl: devUrl_0_2_0_8,
    prodUrl: prodUrl_0_2_0_8,
    path: '/zlb/api/sop/operation/article/save',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_8,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopOperationArticleSavePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [编辑文章↗](http://yapi.cai-inc.com/project/3096/interface/api/502226) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [文章管理-运营侧↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52527)
 * @请求头 `POST /zlb/api/sop/operation/article/save`
 * @更新时间 `2023-07-18 11:49:00`
 * @项目ID 3096
 */
export const zlbApiSopOperationArticleSavePost = /*#__PURE__*/ (
  requestData: ZlbApiSopOperationArticleSavePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopOperationArticleSavePostResponse>(
    prepare(zlbApiSopOperationArticleSavePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopOperationArticleSavePost.requestConfig = zlbApiSopOperationArticleSavePostRequestConfig;

/**
 * 接口 [删除文章↗](http://yapi.cai-inc.com/project/3096/interface/api/502234) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [文章管理-运营侧↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52527)
 * @请求头 `POST /zlb/api/sop/operation/article/delete`
 * @更新时间 `2023-07-18 11:49:00`
 * @项目ID 3096
 */
export interface ZlbApiSopOperationArticleDeletePostRequest {
  articleCode?: string;
}

/**
 * 接口 [删除文章↗](http://yapi.cai-inc.com/project/3096/interface/api/502234) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [文章管理-运营侧↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52527)
 * @请求头 `POST /zlb/api/sop/operation/article/delete`
 * @更新时间 `2023-07-18 11:49:00`
 * @项目ID 3096
 */
export interface ZlbApiSopOperationArticleDeletePostResponse {
  success?: boolean;
  result?: boolean;
  code?: string;
  message?: string;
}

/**
 * 接口 [删除文章↗](http://yapi.cai-inc.com/project/3096/interface/api/502234) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [文章管理-运营侧↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52527)
 * @请求头 `POST /zlb/api/sop/operation/article/delete`
 * @更新时间 `2023-07-18 11:49:00`
 * @项目ID 3096
 */
type ZlbApiSopOperationArticleDeletePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/operation/article/delete',
    'data',
    string,
    'articleCode',
    false
  >
>;

/**
 * 接口 [删除文章↗](http://yapi.cai-inc.com/project/3096/interface/api/502234) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [文章管理-运营侧↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52527)
 * @请求头 `POST /zlb/api/sop/operation/article/delete`
 * @更新时间 `2023-07-18 11:49:00`
 * @项目ID 3096
 */
const zlbApiSopOperationArticleDeletePostRequestConfig: ZlbApiSopOperationArticleDeletePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_8,
    devUrl: devUrl_0_2_0_8,
    prodUrl: prodUrl_0_2_0_8,
    path: '/zlb/api/sop/operation/article/delete',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.none,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_8,
    paramNames: [],
    queryNames: ['articleCode'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopOperationArticleDeletePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [删除文章↗](http://yapi.cai-inc.com/project/3096/interface/api/502234) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [文章管理-运营侧↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52527)
 * @请求头 `POST /zlb/api/sop/operation/article/delete`
 * @更新时间 `2023-07-18 11:49:00`
 * @项目ID 3096
 */
export const zlbApiSopOperationArticleDeletePost = /*#__PURE__*/ (
  requestData: ZlbApiSopOperationArticleDeletePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopOperationArticleDeletePostResponse>(
    prepare(zlbApiSopOperationArticleDeletePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopOperationArticleDeletePost.requestConfig =
  zlbApiSopOperationArticleDeletePostRequestConfig;

/**
 * 接口 [启用停用状态修改↗](http://yapi.cai-inc.com/project/3096/interface/api/502242) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [文章管理-运营侧↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52527)
 * @请求头 `POST /zlb/api/sop/operation/article/update-status`
 * @更新时间 `2023-07-18 11:49:00`
 * @项目ID 3096
 */
export interface ZlbApiSopOperationArticleUpdateStatusPostRequest {
  /**
   * 文章code
   */
  articleCode?: string;
  /**
   * 状态： 0:启用 1:禁用
   */
  status?: number;
}

/**
 * 接口 [启用停用状态修改↗](http://yapi.cai-inc.com/project/3096/interface/api/502242) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [文章管理-运营侧↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52527)
 * @请求头 `POST /zlb/api/sop/operation/article/update-status`
 * @更新时间 `2023-07-18 11:49:00`
 * @项目ID 3096
 */
export interface ZlbApiSopOperationArticleUpdateStatusPostResponse {
  success?: boolean;
  result?: boolean;
  code?: string;
  message?: string;
}

/**
 * 接口 [启用停用状态修改↗](http://yapi.cai-inc.com/project/3096/interface/api/502242) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [文章管理-运营侧↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52527)
 * @请求头 `POST /zlb/api/sop/operation/article/update-status`
 * @更新时间 `2023-07-18 11:49:00`
 * @项目ID 3096
 */
type ZlbApiSopOperationArticleUpdateStatusPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/operation/article/update-status',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [启用停用状态修改↗](http://yapi.cai-inc.com/project/3096/interface/api/502242) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [文章管理-运营侧↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52527)
 * @请求头 `POST /zlb/api/sop/operation/article/update-status`
 * @更新时间 `2023-07-18 11:49:00`
 * @项目ID 3096
 */
const zlbApiSopOperationArticleUpdateStatusPostRequestConfig: ZlbApiSopOperationArticleUpdateStatusPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_8,
    devUrl: devUrl_0_2_0_8,
    prodUrl: prodUrl_0_2_0_8,
    path: '/zlb/api/sop/operation/article/update-status',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_8,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopOperationArticleUpdateStatusPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [启用停用状态修改↗](http://yapi.cai-inc.com/project/3096/interface/api/502242) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [文章管理-运营侧↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52527)
 * @请求头 `POST /zlb/api/sop/operation/article/update-status`
 * @更新时间 `2023-07-18 11:49:00`
 * @项目ID 3096
 */
export const zlbApiSopOperationArticleUpdateStatusPost = /*#__PURE__*/ (
  requestData: ZlbApiSopOperationArticleUpdateStatusPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopOperationArticleUpdateStatusPostResponse>(
    prepare(zlbApiSopOperationArticleUpdateStatusPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopOperationArticleUpdateStatusPost.requestConfig =
  zlbApiSopOperationArticleUpdateStatusPostRequestConfig;

/**
 * 接口 [文章列表↗](http://yapi.cai-inc.com/project/3096/interface/api/502250) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [文章管理-运营侧↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52527)
 * @请求头 `POST /zlb/api/sop/operation/article/list`
 * @更新时间 `2023-07-18 11:49:01`
 * @项目ID 3096
 */
export interface ZlbApiSopOperationArticleListPostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 接收范围类型 1、按区划 2、按机构
   */
  rangeType?: number;
  /**
   * 区划或机构
   */
  rangeContent?: string;
  /**
   * 状态： 0:启用 1:禁用
   */
  status?: number;
  /**
   * 租户code
   */
  tenantCode?: string;
  /**
   * 文章标题
   */
  articleTitle?: string;
  /**
   * 文章类型
   */
  articleType?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
  /**
   * 数据来源： 1:运营后台 1:治理端
   */
  dataSource?: number;
}

/**
 * 接口 [文章列表↗](http://yapi.cai-inc.com/project/3096/interface/api/502250) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [文章管理-运营侧↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52527)
 * @请求头 `POST /zlb/api/sop/operation/article/list`
 * @更新时间 `2023-07-18 11:49:01`
 * @项目ID 3096
 */
export interface ZlbApiSopOperationArticleListPostResponse {
  success?: boolean;
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 状态： 0:启用 1:禁用
       */
      statusDesc?: string;
      status?: number;
      /**
       * 接收范围类型 1、按区划 2、按机构
       */
      rangeType?: number;
      /**
       * 接收范围类型 1、按区划 2、按机构
       */
      rangeTypeDesc?: string;
      /**
       * 区划或机构
       */
      rangeInfoList?: {
        /**
         * 权限code （租户or机构）
         */
        rangeCode: string;
        /**
         * 权限名称 （租户or机构）
         */
        rangeName: string;
      }[];
      /**
       * 排序
       */
      sort?: number;
      /**
       * 文章code
       */
      articleCode?: string;
      /**
       * 标题
       */
      articleTitle?: string;
      /**
       * 文章类型
       */
      articleType?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
      /**
       * 内容类型描述
       */
      articleTypeDesc?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
      /**
       * 发布时间
       */
      postTime?: string;
      /**
       * 数据来源： 1:运营后台 2:治理端
       */
      dataSource?: number;
      /**
       * 数据来源描述： 1:运营后台 2:治理端
       */
      dataSourceDesc?: string;
    }[];
    /**
     * 第几页
     */
    pageNum?: number;
    /**
     * 每页记录数
     */
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 当前页的数量 <= pageSize，该属性来自ArrayList的size属性
     */
    size?: number;
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [文章列表↗](http://yapi.cai-inc.com/project/3096/interface/api/502250) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [文章管理-运营侧↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52527)
 * @请求头 `POST /zlb/api/sop/operation/article/list`
 * @更新时间 `2023-07-18 11:49:01`
 * @项目ID 3096
 */
type ZlbApiSopOperationArticleListPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/operation/article/list',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [文章列表↗](http://yapi.cai-inc.com/project/3096/interface/api/502250) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [文章管理-运营侧↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52527)
 * @请求头 `POST /zlb/api/sop/operation/article/list`
 * @更新时间 `2023-07-18 11:49:01`
 * @项目ID 3096
 */
const zlbApiSopOperationArticleListPostRequestConfig: ZlbApiSopOperationArticleListPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_8,
    devUrl: devUrl_0_2_0_8,
    prodUrl: prodUrl_0_2_0_8,
    path: '/zlb/api/sop/operation/article/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_8,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopOperationArticleListPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [文章列表↗](http://yapi.cai-inc.com/project/3096/interface/api/502250) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [文章管理-运营侧↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52527)
 * @请求头 `POST /zlb/api/sop/operation/article/list`
 * @更新时间 `2023-07-18 11:49:01`
 * @项目ID 3096
 */
export const zlbApiSopOperationArticleListPost = /*#__PURE__*/ (
  requestData: ZlbApiSopOperationArticleListPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopOperationArticleListPostResponse>(
    prepare(zlbApiSopOperationArticleListPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopOperationArticleListPost.requestConfig = zlbApiSopOperationArticleListPostRequestConfig;

const mockUrl_0_2_0_9 = 'http://yapi.cai-inc.com/mock/3096' as any;
const devUrl_0_2_0_9 = '' as any;
const prodUrl_0_2_0_9 = '' as any;
const dataKey_0_2_0_9 = 'data' as any;

/**
 * 接口 [查询文章详情↗](http://yapi.cai-inc.com/project/3096/interface/api/502258) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [文章管理-治理端↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52600)
 * @请求头 `GET /zlb/api/sop/tenant/article/{articleCode}`
 * @更新时间 `2023-12-14 20:23:48`
 * @项目ID 3096
 */
export interface ZlbApiSopTenantArticleArticleCodeGetRequest {
  articleCode: string;
}

/**
 * 接口 [查询文章详情↗](http://yapi.cai-inc.com/project/3096/interface/api/502258) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [文章管理-治理端↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52600)
 * @请求头 `GET /zlb/api/sop/tenant/article/{articleCode}`
 * @更新时间 `2023-12-14 20:23:48`
 * @项目ID 3096
 */
export interface ZlbApiSopTenantArticleArticleCodeGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 文章code
     */
    articleCode?: string;
    /**
     * 文章类型
     */
    articleType?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 999;
    /**
     * 标题
     */
    articleTitle?: string;
    /**
     * 发布单位名称
     */
    publishOrgName?: string;
    /**
     * 文件编号
     */
    fileNo?: string;
    /**
     * 文号
     */
    issueNo?: string;
    /**
     * 条法类别
     */
    lawsType?: string;
    /**
     * 法规层次
     */
    lawsLevel?: string;
    /**
     * 颁布日期
     */
    issueDate?: string;
    /**
     * 实施日期
     */
    implementDate?: string;
    /**
     * 发布时间
     */
    postTime?: string;
    /**
     * 正文
     */
    articleContent?: string;
    /**
     * 单据附件
     */
    formAttachmentDTOS?: {
      /**
       * 附件业务子类型
       */
      bizType?: number;
      /**
       * 附件OssId
       */
      fileId?: string;
      /**
       * 附件名称
       */
      name?: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 链接
       */
      url?: string;
    }[];
    /**
     * 状态： 0:启用 1:禁用
     */
    statusDesc?: string;
    status?: number;
    /**
     * 接收范围类型 1、按区划 2、按机构
     */
    rangeType?: number;
    /**
     * 接收范围类型 1、按区划 2、按机构
     */
    rangeTypeDesc?: string;
    /**
     * 区划或机构
     */
    rangeInfoList?: {
      /**
       * 权限code （租户or机构）
       */
      rangeCode: string;
      /**
       * 权限名称 （租户or机构）
       */
      rangeName: string;
    }[];
    /**
     * 排序
     */
    displayOrder?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询文章详情↗](http://yapi.cai-inc.com/project/3096/interface/api/502258) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [文章管理-治理端↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52600)
 * @请求头 `GET /zlb/api/sop/tenant/article/{articleCode}`
 * @更新时间 `2023-12-14 20:23:48`
 * @项目ID 3096
 */
type ZlbApiSopTenantArticleArticleCodeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/tenant/article/{articleCode}',
    'data',
    'articleCode',
    string,
    false
  >
>;

/**
 * 接口 [查询文章详情↗](http://yapi.cai-inc.com/project/3096/interface/api/502258) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [文章管理-治理端↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52600)
 * @请求头 `GET /zlb/api/sop/tenant/article/{articleCode}`
 * @更新时间 `2023-12-14 20:23:48`
 * @项目ID 3096
 */
const zlbApiSopTenantArticleArticleCodeGetRequestConfig: ZlbApiSopTenantArticleArticleCodeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_9,
    devUrl: devUrl_0_2_0_9,
    prodUrl: prodUrl_0_2_0_9,
    path: '/zlb/api/sop/tenant/article/{articleCode}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_9,
    paramNames: ['articleCode'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopTenantArticleArticleCodeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询文章详情↗](http://yapi.cai-inc.com/project/3096/interface/api/502258) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [文章管理-治理端↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52600)
 * @请求头 `GET /zlb/api/sop/tenant/article/{articleCode}`
 * @更新时间 `2023-12-14 20:23:48`
 * @项目ID 3096
 */
export const zlbApiSopTenantArticleArticleCodeGet = /*#__PURE__*/ (
  requestData: ZlbApiSopTenantArticleArticleCodeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopTenantArticleArticleCodeGetResponse>(
    prepare(zlbApiSopTenantArticleArticleCodeGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopTenantArticleArticleCodeGet.requestConfig =
  zlbApiSopTenantArticleArticleCodeGetRequestConfig;

/**
 * 接口 [编辑文章↗](http://yapi.cai-inc.com/project/3096/interface/api/502266) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [文章管理-治理端↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52600)
 * @请求头 `POST /zlb/api/sop/tenant/article/save`
 * @更新时间 `2023-12-14 20:23:49`
 * @项目ID 3096
 */
export interface ZlbApiSopTenantArticleSavePostRequest {
  /**
   * 文章code
   */
  articleCode?: string;
  /**
   * 文章类型
   */
  articleType: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 999;
  /**
   * 标题
   */
  articleTitle: string;
  /**
   * 发布单位名称
   */
  publishOrgName?: string;
  /**
   * 文件编号
   */
  fileNo?: string;
  /**
   * 文号
   */
  issueNo?: string;
  /**
   * 条法类别
   */
  lawsType?: string;
  /**
   * 法规层次
   */
  lawsLevel?: string;
  /**
   * 颁布日期
   */
  issueDate?: string;
  /**
   * 实施日期
   */
  implementDate?: string;
  /**
   * 发布时间
   */
  postTime?: string;
  /**
   * 正文
   */
  articleContent?: string;
  /**
   * 单据附件
   */
  formAttachmentDTOS?: {
    /**
     * 附件业务子类型
     */
    bizType?: number;
    /**
     * 附件OssId
     */
    fileId?: string;
    /**
     * 附件名称
     */
    name?: string;
    /**
     * 附件大小
     */
    size?: number;
    /**
     * 附件类型
     */
    type?: string;
    /**
     * 链接
     */
    url?: string;
  }[];
  /**
   * 接收范围类型 1、按租户 2、按机构
   */
  rangeType: number;
  /**
   * 接收范围
   * 区划或机构
   */
  rangeInfoList: {
    /**
     * 权限code （租户or机构）
     */
    rangeCode: string;
    /**
     * 权限名称 （租户or机构）
     */
    rangeName: string;
  }[];
  /**
   * 状态： 0:禁用 1:启用
   */
  status: number;
  /**
   * 排序
   */
  displayOrder: number;
}

/**
 * 接口 [编辑文章↗](http://yapi.cai-inc.com/project/3096/interface/api/502266) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [文章管理-治理端↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52600)
 * @请求头 `POST /zlb/api/sop/tenant/article/save`
 * @更新时间 `2023-12-14 20:23:49`
 * @项目ID 3096
 */
export interface ZlbApiSopTenantArticleSavePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [编辑文章↗](http://yapi.cai-inc.com/project/3096/interface/api/502266) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [文章管理-治理端↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52600)
 * @请求头 `POST /zlb/api/sop/tenant/article/save`
 * @更新时间 `2023-12-14 20:23:49`
 * @项目ID 3096
 */
type ZlbApiSopTenantArticleSavePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/tenant/article/save',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [编辑文章↗](http://yapi.cai-inc.com/project/3096/interface/api/502266) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [文章管理-治理端↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52600)
 * @请求头 `POST /zlb/api/sop/tenant/article/save`
 * @更新时间 `2023-12-14 20:23:49`
 * @项目ID 3096
 */
const zlbApiSopTenantArticleSavePostRequestConfig: ZlbApiSopTenantArticleSavePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_9,
    devUrl: devUrl_0_2_0_9,
    prodUrl: prodUrl_0_2_0_9,
    path: '/zlb/api/sop/tenant/article/save',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopTenantArticleSavePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [编辑文章↗](http://yapi.cai-inc.com/project/3096/interface/api/502266) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [文章管理-治理端↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52600)
 * @请求头 `POST /zlb/api/sop/tenant/article/save`
 * @更新时间 `2023-12-14 20:23:49`
 * @项目ID 3096
 */
export const zlbApiSopTenantArticleSavePost = /*#__PURE__*/ (
  requestData: ZlbApiSopTenantArticleSavePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopTenantArticleSavePostResponse>(
    prepare(zlbApiSopTenantArticleSavePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopTenantArticleSavePost.requestConfig = zlbApiSopTenantArticleSavePostRequestConfig;

/**
 * 接口 [删除文章↗](http://yapi.cai-inc.com/project/3096/interface/api/502274) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [文章管理-治理端↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52600)
 * @请求头 `POST /zlb/api/sop/tenant/article/delete`
 * @更新时间 `2023-12-14 20:23:49`
 * @项目ID 3096
 */
export interface ZlbApiSopTenantArticleDeletePostRequest {
  articleCode: string;
}

/**
 * 接口 [删除文章↗](http://yapi.cai-inc.com/project/3096/interface/api/502274) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [文章管理-治理端↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52600)
 * @请求头 `POST /zlb/api/sop/tenant/article/delete`
 * @更新时间 `2023-12-14 20:23:49`
 * @项目ID 3096
 */
export interface ZlbApiSopTenantArticleDeletePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [删除文章↗](http://yapi.cai-inc.com/project/3096/interface/api/502274) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [文章管理-治理端↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52600)
 * @请求头 `POST /zlb/api/sop/tenant/article/delete`
 * @更新时间 `2023-12-14 20:23:49`
 * @项目ID 3096
 */
type ZlbApiSopTenantArticleDeletePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/tenant/article/delete',
    'data',
    string,
    'articleCode',
    false
  >
>;

/**
 * 接口 [删除文章↗](http://yapi.cai-inc.com/project/3096/interface/api/502274) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [文章管理-治理端↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52600)
 * @请求头 `POST /zlb/api/sop/tenant/article/delete`
 * @更新时间 `2023-12-14 20:23:49`
 * @项目ID 3096
 */
const zlbApiSopTenantArticleDeletePostRequestConfig: ZlbApiSopTenantArticleDeletePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_9,
    devUrl: devUrl_0_2_0_9,
    prodUrl: prodUrl_0_2_0_9,
    path: '/zlb/api/sop/tenant/article/delete',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.none,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_9,
    paramNames: [],
    queryNames: ['articleCode'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopTenantArticleDeletePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [删除文章↗](http://yapi.cai-inc.com/project/3096/interface/api/502274) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [文章管理-治理端↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52600)
 * @请求头 `POST /zlb/api/sop/tenant/article/delete`
 * @更新时间 `2023-12-14 20:23:49`
 * @项目ID 3096
 */
export const zlbApiSopTenantArticleDeletePost = /*#__PURE__*/ (
  requestData: ZlbApiSopTenantArticleDeletePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopTenantArticleDeletePostResponse>(
    prepare(zlbApiSopTenantArticleDeletePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopTenantArticleDeletePost.requestConfig = zlbApiSopTenantArticleDeletePostRequestConfig;

/**
 * 接口 [启用停用状态修改↗](http://yapi.cai-inc.com/project/3096/interface/api/502282) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [文章管理-治理端↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52600)
 * @请求头 `POST /zlb/api/sop/tenant/article/update-status`
 * @更新时间 `2023-12-14 20:23:49`
 * @项目ID 3096
 */
export interface ZlbApiSopTenantArticleUpdateStatusPostRequest {
  /**
   * 文章code
   */
  articleCode?: string;
  /**
   * 状态： 0:启用 1:禁用
   */
  status?: number;
}

/**
 * 接口 [启用停用状态修改↗](http://yapi.cai-inc.com/project/3096/interface/api/502282) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [文章管理-治理端↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52600)
 * @请求头 `POST /zlb/api/sop/tenant/article/update-status`
 * @更新时间 `2023-12-14 20:23:49`
 * @项目ID 3096
 */
export interface ZlbApiSopTenantArticleUpdateStatusPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [启用停用状态修改↗](http://yapi.cai-inc.com/project/3096/interface/api/502282) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [文章管理-治理端↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52600)
 * @请求头 `POST /zlb/api/sop/tenant/article/update-status`
 * @更新时间 `2023-12-14 20:23:49`
 * @项目ID 3096
 */
type ZlbApiSopTenantArticleUpdateStatusPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/tenant/article/update-status',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [启用停用状态修改↗](http://yapi.cai-inc.com/project/3096/interface/api/502282) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [文章管理-治理端↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52600)
 * @请求头 `POST /zlb/api/sop/tenant/article/update-status`
 * @更新时间 `2023-12-14 20:23:49`
 * @项目ID 3096
 */
const zlbApiSopTenantArticleUpdateStatusPostRequestConfig: ZlbApiSopTenantArticleUpdateStatusPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_9,
    devUrl: devUrl_0_2_0_9,
    prodUrl: prodUrl_0_2_0_9,
    path: '/zlb/api/sop/tenant/article/update-status',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopTenantArticleUpdateStatusPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [启用停用状态修改↗](http://yapi.cai-inc.com/project/3096/interface/api/502282) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [文章管理-治理端↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52600)
 * @请求头 `POST /zlb/api/sop/tenant/article/update-status`
 * @更新时间 `2023-12-14 20:23:49`
 * @项目ID 3096
 */
export const zlbApiSopTenantArticleUpdateStatusPost = /*#__PURE__*/ (
  requestData: ZlbApiSopTenantArticleUpdateStatusPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopTenantArticleUpdateStatusPostResponse>(
    prepare(zlbApiSopTenantArticleUpdateStatusPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopTenantArticleUpdateStatusPost.requestConfig =
  zlbApiSopTenantArticleUpdateStatusPostRequestConfig;

/**
 * 接口 [文章列表↗](http://yapi.cai-inc.com/project/3096/interface/api/502290) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [文章管理-治理端↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52600)
 * @请求头 `POST /zlb/api/sop/tenant/article/list`
 * @更新时间 `2023-12-14 20:23:49`
 * @项目ID 3096
 */
export interface ZlbApiSopTenantArticleListPostRequest {
  /**
   * 分组id
   */
  groupId?: number;
  /**
   * 文章标题
   */
  articleTitle?: string;
  /**
   * 文章类型
   */
  articleType?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 999;
  /**
   * 接收范围类型 1、按区划 2、按机构
   */
  rangeType?: number;
  /**
   * 区划或机构
   */
  rangeContent?: string;
  /**
   * 状态： 0:启用 1:禁用
   */
  status?: number;
  /**
   * 租户code
   */
  tenantCode?: string;
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
}

/**
 * 接口 [文章列表↗](http://yapi.cai-inc.com/project/3096/interface/api/502290) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [文章管理-治理端↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52600)
 * @请求头 `POST /zlb/api/sop/tenant/article/list`
 * @更新时间 `2023-12-14 20:23:49`
 * @项目ID 3096
 */
export interface ZlbApiSopTenantArticleListPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 权限按钮
       */
      authButton?: {
        /**
         * 能否删除
         */
        canDeleted?: boolean;
        /**
         * 能否编辑
         */
        canEdited?: boolean;
        /**
         * 能否启用/停用
         */
        enEnabled?: boolean;
      };
      /**
       * 文章code
       */
      articleCode?: string;
      /**
       * 标题
       */
      articleTitle?: string;
      /**
       * 文章类型
       */
      articleType?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 999;
      /**
       * 内容类型描述
       */
      articleTypeDesc?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 999;
      /**
       * 发布时间
       */
      postTime?: string;
      /**
       * 状态： 0:启用 1:禁用
       */
      statusDesc?: string;
      status?: number;
      /**
       * 接收范围类型 1、按区划 2、按机构
       */
      rangeType?: number;
      /**
       * 接收范围类型 1、按区划 2、按机构
       */
      rangeTypeDesc?: string;
      /**
       * 区划或机构
       */
      rangeInfoList?: {
        /**
         * 权限code （租户or机构）
         */
        rangeCode: string;
        /**
         * 权限名称 （租户or机构）
         */
        rangeName: string;
      }[];
      /**
       * 排序
       */
      displayOrder?: number;
    }[];
    /**
     * 第几页
     */
    pageNum?: number;
    /**
     * 每页记录数
     */
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 当前页的数量 <= pageSize，该属性来自ArrayList的size属性
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [文章列表↗](http://yapi.cai-inc.com/project/3096/interface/api/502290) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [文章管理-治理端↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52600)
 * @请求头 `POST /zlb/api/sop/tenant/article/list`
 * @更新时间 `2023-12-14 20:23:49`
 * @项目ID 3096
 */
type ZlbApiSopTenantArticleListPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/tenant/article/list',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [文章列表↗](http://yapi.cai-inc.com/project/3096/interface/api/502290) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [文章管理-治理端↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52600)
 * @请求头 `POST /zlb/api/sop/tenant/article/list`
 * @更新时间 `2023-12-14 20:23:49`
 * @项目ID 3096
 */
const zlbApiSopTenantArticleListPostRequestConfig: ZlbApiSopTenantArticleListPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_9,
    devUrl: devUrl_0_2_0_9,
    prodUrl: prodUrl_0_2_0_9,
    path: '/zlb/api/sop/tenant/article/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopTenantArticleListPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [文章列表↗](http://yapi.cai-inc.com/project/3096/interface/api/502290) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [文章管理-治理端↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52600)
 * @请求头 `POST /zlb/api/sop/tenant/article/list`
 * @更新时间 `2023-12-14 20:23:49`
 * @项目ID 3096
 */
export const zlbApiSopTenantArticleListPost = /*#__PURE__*/ (
  requestData: ZlbApiSopTenantArticleListPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopTenantArticleListPostResponse>(
    prepare(zlbApiSopTenantArticleListPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopTenantArticleListPost.requestConfig = zlbApiSopTenantArticleListPostRequestConfig;

/**
 * 接口 [删除文章↗](http://yapi.cai-inc.com/project/3096/interface/api/502978) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [文章管理-治理端↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52600)
 * @请求头 `POST /zlb/api/sop/tenant/article/delete/{articleCode}`
 * @更新时间 `2023-07-17 15:50:03`
 * @项目ID 3096
 */
export interface ZlbApiSopTenantArticleDeleteArticleCodePostRequest {
  articleCode: string;
}

/**
 * 接口 [删除文章↗](http://yapi.cai-inc.com/project/3096/interface/api/502978) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [文章管理-治理端↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52600)
 * @请求头 `POST /zlb/api/sop/tenant/article/delete/{articleCode}`
 * @更新时间 `2023-07-17 15:50:03`
 * @项目ID 3096
 */
export interface ZlbApiSopTenantArticleDeleteArticleCodePostResponse {
  success?: boolean;
  result?: boolean;
  code?: string;
  message?: string;
}

/**
 * 接口 [删除文章↗](http://yapi.cai-inc.com/project/3096/interface/api/502978) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [文章管理-治理端↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52600)
 * @请求头 `POST /zlb/api/sop/tenant/article/delete/{articleCode}`
 * @更新时间 `2023-07-17 15:50:03`
 * @项目ID 3096
 */
type ZlbApiSopTenantArticleDeleteArticleCodePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/tenant/article/delete/{articleCode}',
    'data',
    'articleCode',
    string,
    false
  >
>;

/**
 * 接口 [删除文章↗](http://yapi.cai-inc.com/project/3096/interface/api/502978) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [文章管理-治理端↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52600)
 * @请求头 `POST /zlb/api/sop/tenant/article/delete/{articleCode}`
 * @更新时间 `2023-07-17 15:50:03`
 * @项目ID 3096
 */
const zlbApiSopTenantArticleDeleteArticleCodePostRequestConfig: ZlbApiSopTenantArticleDeleteArticleCodePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_9,
    devUrl: devUrl_0_2_0_9,
    prodUrl: prodUrl_0_2_0_9,
    path: '/zlb/api/sop/tenant/article/delete/{articleCode}',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.none,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_9,
    paramNames: ['articleCode'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopTenantArticleDeleteArticleCodePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [删除文章↗](http://yapi.cai-inc.com/project/3096/interface/api/502978) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [文章管理-治理端↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52600)
 * @请求头 `POST /zlb/api/sop/tenant/article/delete/{articleCode}`
 * @更新时间 `2023-07-17 15:50:03`
 * @项目ID 3096
 */
export const zlbApiSopTenantArticleDeleteArticleCodePost = /*#__PURE__*/ (
  requestData: ZlbApiSopTenantArticleDeleteArticleCodePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopTenantArticleDeleteArticleCodePostResponse>(
    prepare(zlbApiSopTenantArticleDeleteArticleCodePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopTenantArticleDeleteArticleCodePost.requestConfig =
  zlbApiSopTenantArticleDeleteArticleCodePostRequestConfig;

/**
 * 接口 [移动文章↗](http://yapi.cai-inc.com/project/3096/interface/api/558554) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [文章管理-治理端↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52600)
 * @请求头 `POST /zlb/api/sop/tenant/article/move`
 * @更新时间 `2023-12-14 20:23:50`
 * @项目ID 3096
 */
export interface ZlbApiSopTenantArticleMovePostRequest {
  /**
   * 文章code
   */
  articleCode: string;
  /**
   * 分组id
   */
  groupId: number;
}

/**
 * 接口 [移动文章↗](http://yapi.cai-inc.com/project/3096/interface/api/558554) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [文章管理-治理端↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52600)
 * @请求头 `POST /zlb/api/sop/tenant/article/move`
 * @更新时间 `2023-12-14 20:23:50`
 * @项目ID 3096
 */
export interface ZlbApiSopTenantArticleMovePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [移动文章↗](http://yapi.cai-inc.com/project/3096/interface/api/558554) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [文章管理-治理端↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52600)
 * @请求头 `POST /zlb/api/sop/tenant/article/move`
 * @更新时间 `2023-12-14 20:23:50`
 * @项目ID 3096
 */
type ZlbApiSopTenantArticleMovePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/tenant/article/move',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [移动文章↗](http://yapi.cai-inc.com/project/3096/interface/api/558554) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [文章管理-治理端↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52600)
 * @请求头 `POST /zlb/api/sop/tenant/article/move`
 * @更新时间 `2023-12-14 20:23:50`
 * @项目ID 3096
 */
const zlbApiSopTenantArticleMovePostRequestConfig: ZlbApiSopTenantArticleMovePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_9,
    devUrl: devUrl_0_2_0_9,
    prodUrl: prodUrl_0_2_0_9,
    path: '/zlb/api/sop/tenant/article/move',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopTenantArticleMovePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [移动文章↗](http://yapi.cai-inc.com/project/3096/interface/api/558554) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [文章管理-治理端↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52600)
 * @请求头 `POST /zlb/api/sop/tenant/article/move`
 * @更新时间 `2023-12-14 20:23:50`
 * @项目ID 3096
 */
export const zlbApiSopTenantArticleMovePost = /*#__PURE__*/ (
  requestData: ZlbApiSopTenantArticleMovePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopTenantArticleMovePostResponse>(
    prepare(zlbApiSopTenantArticleMovePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopTenantArticleMovePost.requestConfig = zlbApiSopTenantArticleMovePostRequestConfig;

/**
 * 接口 [批量移动文章↗](http://yapi.cai-inc.com/project/3096/interface/api/558562) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [文章管理-治理端↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52600)
 * @请求头 `POST /zlb/api/sop/tenant/article/batch-move`
 * @更新时间 `2023-12-14 20:23:51`
 * @项目ID 3096
 */
export interface ZlbApiSopTenantArticleBatchMovePostRequest {
  /**
   * 文章code
   */
  articleCodes: string[];
  /**
   * 分组id
   */
  groupId: number;
}

/**
 * 接口 [批量移动文章↗](http://yapi.cai-inc.com/project/3096/interface/api/558562) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [文章管理-治理端↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52600)
 * @请求头 `POST /zlb/api/sop/tenant/article/batch-move`
 * @更新时间 `2023-12-14 20:23:51`
 * @项目ID 3096
 */
export interface ZlbApiSopTenantArticleBatchMovePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [批量移动文章↗](http://yapi.cai-inc.com/project/3096/interface/api/558562) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [文章管理-治理端↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52600)
 * @请求头 `POST /zlb/api/sop/tenant/article/batch-move`
 * @更新时间 `2023-12-14 20:23:51`
 * @项目ID 3096
 */
type ZlbApiSopTenantArticleBatchMovePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/tenant/article/batch-move',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [批量移动文章↗](http://yapi.cai-inc.com/project/3096/interface/api/558562) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [文章管理-治理端↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52600)
 * @请求头 `POST /zlb/api/sop/tenant/article/batch-move`
 * @更新时间 `2023-12-14 20:23:51`
 * @项目ID 3096
 */
const zlbApiSopTenantArticleBatchMovePostRequestConfig: ZlbApiSopTenantArticleBatchMovePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_9,
    devUrl: devUrl_0_2_0_9,
    prodUrl: prodUrl_0_2_0_9,
    path: '/zlb/api/sop/tenant/article/batch-move',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopTenantArticleBatchMovePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [批量移动文章↗](http://yapi.cai-inc.com/project/3096/interface/api/558562) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [文章管理-治理端↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52600)
 * @请求头 `POST /zlb/api/sop/tenant/article/batch-move`
 * @更新时间 `2023-12-14 20:23:51`
 * @项目ID 3096
 */
export const zlbApiSopTenantArticleBatchMovePost = /*#__PURE__*/ (
  requestData: ZlbApiSopTenantArticleBatchMovePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopTenantArticleBatchMovePostResponse>(
    prepare(zlbApiSopTenantArticleBatchMovePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopTenantArticleBatchMovePost.requestConfig =
  zlbApiSopTenantArticleBatchMovePostRequestConfig;

const mockUrl_0_2_0_10 = 'http://yapi.cai-inc.com/mock/3096' as any;
const devUrl_0_2_0_10 = '' as any;
const prodUrl_0_2_0_10 = '' as any;
const dataKey_0_2_0_10 = 'data' as any;

/**
 * 接口 [查询文章类型↗](http://yapi.cai-inc.com/project/3096/interface/api/503226) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [文章↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52610)
 * @请求头 `GET /zlb/api/sop/article/article-type`
 * @更新时间 `2023-07-20 11:01:22`
 * @项目ID 3096
 */
export interface ZlbApiSopArticleArticleTypeGetRequest {}

/**
 * 接口 [查询文章类型↗](http://yapi.cai-inc.com/project/3096/interface/api/503226) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [文章↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52610)
 * @请求头 `GET /zlb/api/sop/article/article-type`
 * @更新时间 `2023-07-20 11:01:22`
 * @项目ID 3096
 */
export interface ZlbApiSopArticleArticleTypeGetResponse {
  success?: boolean;
  result?: {
    /**
     * 文章类型
     */
    articleType?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
    /**
     * 文章类型
     */
    articleTypeDesc?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
  }[];
  code?: string;
  message?: string;
}

/**
 * 接口 [查询文章类型↗](http://yapi.cai-inc.com/project/3096/interface/api/503226) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [文章↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52610)
 * @请求头 `GET /zlb/api/sop/article/article-type`
 * @更新时间 `2023-07-20 11:01:22`
 * @项目ID 3096
 */
type ZlbApiSopArticleArticleTypeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/article/article-type',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [查询文章类型↗](http://yapi.cai-inc.com/project/3096/interface/api/503226) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [文章↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52610)
 * @请求头 `GET /zlb/api/sop/article/article-type`
 * @更新时间 `2023-07-20 11:01:22`
 * @项目ID 3096
 */
const zlbApiSopArticleArticleTypeGetRequestConfig: ZlbApiSopArticleArticleTypeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_10,
    devUrl: devUrl_0_2_0_10,
    prodUrl: prodUrl_0_2_0_10,
    path: '/zlb/api/sop/article/article-type',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_10,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopArticleArticleTypeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询文章类型↗](http://yapi.cai-inc.com/project/3096/interface/api/503226) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [文章↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52610)
 * @请求头 `GET /zlb/api/sop/article/article-type`
 * @更新时间 `2023-07-20 11:01:22`
 * @项目ID 3096
 */
export const zlbApiSopArticleArticleTypeGet = /*#__PURE__*/ (
  requestData?: ZlbApiSopArticleArticleTypeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopArticleArticleTypeGetResponse>(
    prepare(zlbApiSopArticleArticleTypeGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopArticleArticleTypeGet.requestConfig = zlbApiSopArticleArticleTypeGetRequestConfig;

/**
 * 接口 [查询文章详情↗](http://yapi.cai-inc.com/project/3096/interface/api/505378) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [文章↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52610)
 * @请求头 `GET /zlb/api/sop/article/{articleCode}`
 * @更新时间 `2024-04-29 10:22:19`
 * @项目ID 3096
 */
export interface ZlbApiSopArticleArticleCodeGetRequest {
  articleCode: string;
}

/**
 * 接口 [查询文章详情↗](http://yapi.cai-inc.com/project/3096/interface/api/505378) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [文章↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52610)
 * @请求头 `GET /zlb/api/sop/article/{articleCode}`
 * @更新时间 `2024-04-29 10:22:19`
 * @项目ID 3096
 */
export interface ZlbApiSopArticleArticleCodeGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 文章code
     */
    articleCode?: string;
    /**
     * 文章类型
     */
    articleType?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 999;
    /**
     * 标题
     */
    articleTitle?: string;
    /**
     * 发布单位名称
     */
    publishOrgName?: string;
    /**
     * 文件编号
     */
    fileNo?: string;
    /**
     * 文号
     */
    issueNo?: string;
    /**
     * 条法类别
     */
    lawsType?: string;
    /**
     * 法规层次
     */
    lawsLevel?: string;
    /**
     * 颁布日期
     */
    issueDate?: string;
    /**
     * 实施日期
     */
    implementDate?: string;
    /**
     * 发布时间
     */
    postTime?: string;
    /**
     * 正文
     */
    articleContent?: string;
    /**
     * 单据附件
     */
    formAttachmentDTOS?: {
      /**
       * 附件业务子类型
       */
      bizType?: number;
      /**
       * 附件OssId
       */
      fileId?: string;
      /**
       * 附件名称
       */
      name?: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 链接
       */
      url?: string;
    }[];
    /**
     * 状态： 0:启用 1:禁用
     */
    statusDesc?: string;
    status?: number;
    /**
     * 接收范围类型 1、按区划 2、按机构
     */
    rangeType?: number;
    /**
     * 接收范围类型 1、按区划 2、按机构
     */
    rangeTypeDesc?: string;
    /**
     * 是否子单位可见
     */
    subOrgVisible?: boolean;
    /**
     * 区划或机构
     */
    rangeInfoList?: {
      /**
       * 权限code （租户or机构）
       */
      rangeCode: string;
      /**
       * 权限名称 （租户or机构）
       */
      rangeName: string;
    }[];
    /**
     * 排序
     */
    displayOrder?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询文章详情↗](http://yapi.cai-inc.com/project/3096/interface/api/505378) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [文章↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52610)
 * @请求头 `GET /zlb/api/sop/article/{articleCode}`
 * @更新时间 `2024-04-29 10:22:19`
 * @项目ID 3096
 */
type ZlbApiSopArticleArticleCodeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/article/{articleCode}',
    'data',
    'articleCode',
    string,
    false
  >
>;

/**
 * 接口 [查询文章详情↗](http://yapi.cai-inc.com/project/3096/interface/api/505378) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [文章↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52610)
 * @请求头 `GET /zlb/api/sop/article/{articleCode}`
 * @更新时间 `2024-04-29 10:22:19`
 * @项目ID 3096
 */
const zlbApiSopArticleArticleCodeGetRequestConfig: ZlbApiSopArticleArticleCodeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_10,
    devUrl: devUrl_0_2_0_10,
    prodUrl: prodUrl_0_2_0_10,
    path: '/zlb/api/sop/article/{articleCode}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_10,
    paramNames: ['articleCode'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopArticleArticleCodeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询文章详情↗](http://yapi.cai-inc.com/project/3096/interface/api/505378) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [文章↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_52610)
 * @请求头 `GET /zlb/api/sop/article/{articleCode}`
 * @更新时间 `2024-04-29 10:22:19`
 * @项目ID 3096
 */
export const zlbApiSopArticleArticleCodeGet = /*#__PURE__*/ (
  requestData: ZlbApiSopArticleArticleCodeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopArticleArticleCodeGetResponse>(
    prepare(zlbApiSopArticleArticleCodeGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopArticleArticleCodeGet.requestConfig = zlbApiSopArticleArticleCodeGetRequestConfig;

const mockUrl_0_2_0_11 = 'http://yapi.cai-inc.com/mock/3096' as any;
const devUrl_0_2_0_11 = '' as any;
const prodUrl_0_2_0_11 = '' as any;
const dataKey_0_2_0_11 = 'data' as any;

/**
 * 接口 [数据概览↗](http://yapi.cai-inc.com/project/3096/interface/api/605498) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [治理端-工作台改版↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_54608)
 * @请求头 `GET /zlb/api/sop/inspection/work-table/overview`
 * @更新时间 `2024-01-17 18:03:16`
 * @项目ID 3096
 */
export interface ZlbApiSopInspectionWorkTableOverviewGetRequest {
  /**
   * 区划code
   */
  districtCode: string;
  /**
   * 类型 eg：province、city，与datapi保持一致
   */
  type?: string;
}

/**
 * 接口 [数据概览↗](http://yapi.cai-inc.com/project/3096/interface/api/605498) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [治理端-工作台改版↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_54608)
 * @请求头 `GET /zlb/api/sop/inspection/work-table/overview`
 * @更新时间 `2024-01-17 18:03:16`
 * @项目ID 3096
 */
export interface ZlbApiSopInspectionWorkTableOverviewGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 单位数
     */
    unitNum?: number;
    /**
     * 活跃率
     */
    activityRate?: number;
    /**
     * 报销单数量
     */
    expenseFormNum?: number;
    /**
     * 申请单数量
     */
    applyFormNum?: number;
    /**
     * 报销金额
     */
    expenseAmount?: number;
    /**
     * 预算总金额
     */
    budgetTotalAmount?: number;
    /**
     * 金额比率
     */
    amountRate?: number;
    /**
     * 事件数
     */
    eventNum?: number;
    /**
     * 强控数
     */
    hardControlNum?: number;
    /**
     * 弱控数
     */
    weakControlNum?: number;
    /**
     * 累计报销金额
     */
    totalExpenseAmount?: number;
    /**
     * 本年申请单
     */
    applyNum?: number;
    /**
     * 本年报销单
     */
    expenseNum?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [数据概览↗](http://yapi.cai-inc.com/project/3096/interface/api/605498) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [治理端-工作台改版↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_54608)
 * @请求头 `GET /zlb/api/sop/inspection/work-table/overview`
 * @更新时间 `2024-01-17 18:03:16`
 * @项目ID 3096
 */
type ZlbApiSopInspectionWorkTableOverviewGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/inspection/work-table/overview',
    'data',
    string,
    'districtCode' | 'type',
    false
  >
>;

/**
 * 接口 [数据概览↗](http://yapi.cai-inc.com/project/3096/interface/api/605498) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [治理端-工作台改版↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_54608)
 * @请求头 `GET /zlb/api/sop/inspection/work-table/overview`
 * @更新时间 `2024-01-17 18:03:16`
 * @项目ID 3096
 */
const zlbApiSopInspectionWorkTableOverviewGetRequestConfig: ZlbApiSopInspectionWorkTableOverviewGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_11,
    devUrl: devUrl_0_2_0_11,
    prodUrl: prodUrl_0_2_0_11,
    path: '/zlb/api/sop/inspection/work-table/overview',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_11,
    paramNames: [],
    queryNames: ['districtCode', 'type'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopInspectionWorkTableOverviewGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [数据概览↗](http://yapi.cai-inc.com/project/3096/interface/api/605498) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [治理端-工作台改版↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_54608)
 * @请求头 `GET /zlb/api/sop/inspection/work-table/overview`
 * @更新时间 `2024-01-17 18:03:16`
 * @项目ID 3096
 */
export const zlbApiSopInspectionWorkTableOverviewGet = /*#__PURE__*/ (
  requestData: ZlbApiSopInspectionWorkTableOverviewGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopInspectionWorkTableOverviewGetResponse>(
    prepare(zlbApiSopInspectionWorkTableOverviewGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopInspectionWorkTableOverviewGet.requestConfig =
  zlbApiSopInspectionWorkTableOverviewGetRequestConfig;

/**
 * 接口 [治理分析↗](http://yapi.cai-inc.com/project/3096/interface/api/605506) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [治理端-工作台改版↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_54608)
 * @请求头 `GET /zlb/api/sop/inspection/work-table/governance/analysis`
 * @更新时间 `2024-01-17 18:03:16`
 * @项目ID 3096
 */
export interface ZlbApiSopInspectionWorkTableGovernanceAnalysisGetRequest {
  /**
   * 区划code
   */
  districtCode: string;
  /**
   * 类型 eg：province、city，与datapi保持一致
   */
  type?: string;
}

/**
 * 接口 [治理分析↗](http://yapi.cai-inc.com/project/3096/interface/api/605506) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [治理端-工作台改版↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_54608)
 * @请求头 `GET /zlb/api/sop/inspection/work-table/governance/analysis`
 * @更新时间 `2024-01-17 18:03:16`
 * @项目ID 3096
 */
export interface ZlbApiSopInspectionWorkTableGovernanceAnalysisGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 累计检测次数
     */
    totalMonitorNum?: number;
    /**
     * 累计风险单位数
     */
    totalRiskUnitNum?: number;
    /**
     * 累计检测风险数
     */
    totalMonitorRiskNum?: number;
    /**
     * 下发率
     */
    deliveryRate?: number;
    /**
     * 处置率
     */
    disposalRate?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [治理分析↗](http://yapi.cai-inc.com/project/3096/interface/api/605506) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [治理端-工作台改版↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_54608)
 * @请求头 `GET /zlb/api/sop/inspection/work-table/governance/analysis`
 * @更新时间 `2024-01-17 18:03:16`
 * @项目ID 3096
 */
type ZlbApiSopInspectionWorkTableGovernanceAnalysisGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/inspection/work-table/governance/analysis',
    'data',
    string,
    'districtCode' | 'type',
    false
  >
>;

/**
 * 接口 [治理分析↗](http://yapi.cai-inc.com/project/3096/interface/api/605506) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [治理端-工作台改版↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_54608)
 * @请求头 `GET /zlb/api/sop/inspection/work-table/governance/analysis`
 * @更新时间 `2024-01-17 18:03:16`
 * @项目ID 3096
 */
const zlbApiSopInspectionWorkTableGovernanceAnalysisGetRequestConfig: ZlbApiSopInspectionWorkTableGovernanceAnalysisGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_11,
    devUrl: devUrl_0_2_0_11,
    prodUrl: prodUrl_0_2_0_11,
    path: '/zlb/api/sop/inspection/work-table/governance/analysis',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_11,
    paramNames: [],
    queryNames: ['districtCode', 'type'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopInspectionWorkTableGovernanceAnalysisGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [治理分析↗](http://yapi.cai-inc.com/project/3096/interface/api/605506) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [治理端-工作台改版↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_54608)
 * @请求头 `GET /zlb/api/sop/inspection/work-table/governance/analysis`
 * @更新时间 `2024-01-17 18:03:16`
 * @项目ID 3096
 */
export const zlbApiSopInspectionWorkTableGovernanceAnalysisGet = /*#__PURE__*/ (
  requestData: ZlbApiSopInspectionWorkTableGovernanceAnalysisGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopInspectionWorkTableGovernanceAnalysisGetResponse>(
    prepare(zlbApiSopInspectionWorkTableGovernanceAnalysisGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopInspectionWorkTableGovernanceAnalysisGet.requestConfig =
  zlbApiSopInspectionWorkTableGovernanceAnalysisGetRequestConfig;

/**
 * 接口 [单位排名↗](http://yapi.cai-inc.com/project/3096/interface/api/605514) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [治理端-工作台改版↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_54608)
 * @请求头 `GET /zlb/api/sop/inspection/work-table/unit/ranking`
 * @更新时间 `2024-01-17 18:03:16`
 * @项目ID 3096
 */
export interface ZlbApiSopInspectionWorkTableUnitRankingGetRequest {
  /**
   * 区划code
   */
  districtCode: string;
  /**
   * 类型 eg：province、city，与datapi保持一致
   */
  type?: string;
}

/**
 * 接口 [单位排名↗](http://yapi.cai-inc.com/project/3096/interface/api/605514) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [治理端-工作台改版↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_54608)
 * @请求头 `GET /zlb/api/sop/inspection/work-table/unit/ranking`
 * @更新时间 `2024-01-17 18:03:16`
 * @项目ID 3096
 */
export interface ZlbApiSopInspectionWorkTableUnitRankingGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    orgId?: number;
    orgName?: string;
    eventNum?: number;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [单位排名↗](http://yapi.cai-inc.com/project/3096/interface/api/605514) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [治理端-工作台改版↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_54608)
 * @请求头 `GET /zlb/api/sop/inspection/work-table/unit/ranking`
 * @更新时间 `2024-01-17 18:03:16`
 * @项目ID 3096
 */
type ZlbApiSopInspectionWorkTableUnitRankingGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/inspection/work-table/unit/ranking',
    'data',
    string,
    'districtCode' | 'type',
    false
  >
>;

/**
 * 接口 [单位排名↗](http://yapi.cai-inc.com/project/3096/interface/api/605514) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [治理端-工作台改版↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_54608)
 * @请求头 `GET /zlb/api/sop/inspection/work-table/unit/ranking`
 * @更新时间 `2024-01-17 18:03:16`
 * @项目ID 3096
 */
const zlbApiSopInspectionWorkTableUnitRankingGetRequestConfig: ZlbApiSopInspectionWorkTableUnitRankingGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_11,
    devUrl: devUrl_0_2_0_11,
    prodUrl: prodUrl_0_2_0_11,
    path: '/zlb/api/sop/inspection/work-table/unit/ranking',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_11,
    paramNames: [],
    queryNames: ['districtCode', 'type'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopInspectionWorkTableUnitRankingGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [单位排名↗](http://yapi.cai-inc.com/project/3096/interface/api/605514) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [治理端-工作台改版↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_54608)
 * @请求头 `GET /zlb/api/sop/inspection/work-table/unit/ranking`
 * @更新时间 `2024-01-17 18:03:16`
 * @项目ID 3096
 */
export const zlbApiSopInspectionWorkTableUnitRankingGet = /*#__PURE__*/ (
  requestData: ZlbApiSopInspectionWorkTableUnitRankingGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopInspectionWorkTableUnitRankingGetResponse>(
    prepare(zlbApiSopInspectionWorkTableUnitRankingGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopInspectionWorkTableUnitRankingGet.requestConfig =
  zlbApiSopInspectionWorkTableUnitRankingGetRequestConfig;

/**
 * 接口 [事件类型占比↗](http://yapi.cai-inc.com/project/3096/interface/api/605522) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [治理端-工作台改版↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_54608)
 * @请求头 `GET /zlb/api/sop/inspection/work-table/event/rate`
 * @更新时间 `2024-01-17 18:03:17`
 * @项目ID 3096
 */
export interface ZlbApiSopInspectionWorkTableEventRateGetRequest {
  /**
   * 区划code
   */
  districtCode: string;
  /**
   * 类型 eg：province、city，与datapi保持一致
   */
  type?: string;
}

/**
 * 接口 [事件类型占比↗](http://yapi.cai-inc.com/project/3096/interface/api/605522) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [治理端-工作台改版↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_54608)
 * @请求头 `GET /zlb/api/sop/inspection/work-table/event/rate`
 * @更新时间 `2024-01-17 18:03:17`
 * @项目ID 3096
 */
export interface ZlbApiSopInspectionWorkTableEventRateGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 月份
     */
    month?: string;
    /**
     * 风险事件列表
     */
    riskEventList?: {
      /**
       * 事件类型
       */
      eventType?: string;
      /**
       * 事件数量
       */
      eventNum?: number;
      /**
       * 事件百分比
       */
      eventRate?: number;
    }[];
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [事件类型占比↗](http://yapi.cai-inc.com/project/3096/interface/api/605522) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [治理端-工作台改版↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_54608)
 * @请求头 `GET /zlb/api/sop/inspection/work-table/event/rate`
 * @更新时间 `2024-01-17 18:03:17`
 * @项目ID 3096
 */
type ZlbApiSopInspectionWorkTableEventRateGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/inspection/work-table/event/rate',
    'data',
    string,
    'districtCode' | 'type',
    false
  >
>;

/**
 * 接口 [事件类型占比↗](http://yapi.cai-inc.com/project/3096/interface/api/605522) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [治理端-工作台改版↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_54608)
 * @请求头 `GET /zlb/api/sop/inspection/work-table/event/rate`
 * @更新时间 `2024-01-17 18:03:17`
 * @项目ID 3096
 */
const zlbApiSopInspectionWorkTableEventRateGetRequestConfig: ZlbApiSopInspectionWorkTableEventRateGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_11,
    devUrl: devUrl_0_2_0_11,
    prodUrl: prodUrl_0_2_0_11,
    path: '/zlb/api/sop/inspection/work-table/event/rate',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_11,
    paramNames: [],
    queryNames: ['districtCode', 'type'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopInspectionWorkTableEventRateGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [事件类型占比↗](http://yapi.cai-inc.com/project/3096/interface/api/605522) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [治理端-工作台改版↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_54608)
 * @请求头 `GET /zlb/api/sop/inspection/work-table/event/rate`
 * @更新时间 `2024-01-17 18:03:17`
 * @项目ID 3096
 */
export const zlbApiSopInspectionWorkTableEventRateGet = /*#__PURE__*/ (
  requestData: ZlbApiSopInspectionWorkTableEventRateGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopInspectionWorkTableEventRateGetResponse>(
    prepare(zlbApiSopInspectionWorkTableEventRateGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopInspectionWorkTableEventRateGet.requestConfig =
  zlbApiSopInspectionWorkTableEventRateGetRequestConfig;

/**
 * 接口 [效能提升↗](http://yapi.cai-inc.com/project/3096/interface/api/605530) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [治理端-工作台改版↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_54608)
 * @请求头 `GET /zlb/api/sop/inspection/work-table/efficiency/improvement`
 * @更新时间 `2024-01-17 18:03:17`
 * @项目ID 3096
 */
export interface ZlbApiSopInspectionWorkTableEfficiencyImprovementGetRequest {
  /**
   * 区划code
   */
  districtCode: string;
  /**
   * 类型 eg：province、city，与datapi保持一致
   */
  type?: string;
}

/**
 * 接口 [效能提升↗](http://yapi.cai-inc.com/project/3096/interface/api/605530) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [治理端-工作台改版↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_54608)
 * @请求头 `GET /zlb/api/sop/inspection/work-table/efficiency/improvement`
 * @更新时间 `2024-01-17 18:03:17`
 * @项目ID 3096
 */
export interface ZlbApiSopInspectionWorkTableEfficiencyImprovementGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 平均报销周期
     */
    avgExpensePeriod?: number;
    /**
     * 单据平均审批时长
     */
    avgApprovalDuration?: number;
    /**
     * 平均支付时长
     */
    avgPayDuration?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [效能提升↗](http://yapi.cai-inc.com/project/3096/interface/api/605530) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [治理端-工作台改版↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_54608)
 * @请求头 `GET /zlb/api/sop/inspection/work-table/efficiency/improvement`
 * @更新时间 `2024-01-17 18:03:17`
 * @项目ID 3096
 */
type ZlbApiSopInspectionWorkTableEfficiencyImprovementGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/inspection/work-table/efficiency/improvement',
    'data',
    string,
    'districtCode' | 'type',
    false
  >
>;

/**
 * 接口 [效能提升↗](http://yapi.cai-inc.com/project/3096/interface/api/605530) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [治理端-工作台改版↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_54608)
 * @请求头 `GET /zlb/api/sop/inspection/work-table/efficiency/improvement`
 * @更新时间 `2024-01-17 18:03:17`
 * @项目ID 3096
 */
const zlbApiSopInspectionWorkTableEfficiencyImprovementGetRequestConfig: ZlbApiSopInspectionWorkTableEfficiencyImprovementGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_11,
    devUrl: devUrl_0_2_0_11,
    prodUrl: prodUrl_0_2_0_11,
    path: '/zlb/api/sop/inspection/work-table/efficiency/improvement',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_11,
    paramNames: [],
    queryNames: ['districtCode', 'type'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopInspectionWorkTableEfficiencyImprovementGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [效能提升↗](http://yapi.cai-inc.com/project/3096/interface/api/605530) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [治理端-工作台改版↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_54608)
 * @请求头 `GET /zlb/api/sop/inspection/work-table/efficiency/improvement`
 * @更新时间 `2024-01-17 18:03:17`
 * @项目ID 3096
 */
export const zlbApiSopInspectionWorkTableEfficiencyImprovementGet = /*#__PURE__*/ (
  requestData: ZlbApiSopInspectionWorkTableEfficiencyImprovementGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopInspectionWorkTableEfficiencyImprovementGetResponse>(
    prepare(zlbApiSopInspectionWorkTableEfficiencyImprovementGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopInspectionWorkTableEfficiencyImprovementGet.requestConfig =
  zlbApiSopInspectionWorkTableEfficiencyImprovementGetRequestConfig;

/**
 * 接口 [风险拦截↗](http://yapi.cai-inc.com/project/3096/interface/api/605538) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [治理端-工作台改版↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_54608)
 * @请求头 `GET /zlb/api/sop/inspection/work-table/risk/interception`
 * @更新时间 `2024-01-17 18:03:17`
 * @项目ID 3096
 */
export interface ZlbApiSopInspectionWorkTableRiskInterceptionGetRequest {
  /**
   * 区划code
   */
  districtCode: string;
  /**
   * 类型 eg：province、city，与datapi保持一致
   */
  type?: string;
}

/**
 * 接口 [风险拦截↗](http://yapi.cai-inc.com/project/3096/interface/api/605538) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [治理端-工作台改版↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_54608)
 * @请求头 `GET /zlb/api/sop/inspection/work-table/risk/interception`
 * @更新时间 `2024-01-17 18:03:17`
 * @项目ID 3096
 */
export interface ZlbApiSopInspectionWorkTableRiskInterceptionGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 累计拦截次数
     */
    totalInterceptionNum?: number;
    /**
     * 统计信息
     */
    statInfo?: {
      /**
       * 弱控数量
       */
      weakControlNum?: number;
      /**
       * 月份
       */
      month?: string;
    }[];
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [风险拦截↗](http://yapi.cai-inc.com/project/3096/interface/api/605538) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [治理端-工作台改版↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_54608)
 * @请求头 `GET /zlb/api/sop/inspection/work-table/risk/interception`
 * @更新时间 `2024-01-17 18:03:17`
 * @项目ID 3096
 */
type ZlbApiSopInspectionWorkTableRiskInterceptionGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/inspection/work-table/risk/interception',
    'data',
    string,
    'districtCode' | 'type',
    false
  >
>;

/**
 * 接口 [风险拦截↗](http://yapi.cai-inc.com/project/3096/interface/api/605538) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [治理端-工作台改版↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_54608)
 * @请求头 `GET /zlb/api/sop/inspection/work-table/risk/interception`
 * @更新时间 `2024-01-17 18:03:17`
 * @项目ID 3096
 */
const zlbApiSopInspectionWorkTableRiskInterceptionGetRequestConfig: ZlbApiSopInspectionWorkTableRiskInterceptionGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_11,
    devUrl: devUrl_0_2_0_11,
    prodUrl: prodUrl_0_2_0_11,
    path: '/zlb/api/sop/inspection/work-table/risk/interception',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_11,
    paramNames: [],
    queryNames: ['districtCode', 'type'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopInspectionWorkTableRiskInterceptionGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [风险拦截↗](http://yapi.cai-inc.com/project/3096/interface/api/605538) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [治理端-工作台改版↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_54608)
 * @请求头 `GET /zlb/api/sop/inspection/work-table/risk/interception`
 * @更新时间 `2024-01-17 18:03:17`
 * @项目ID 3096
 */
export const zlbApiSopInspectionWorkTableRiskInterceptionGet = /*#__PURE__*/ (
  requestData: ZlbApiSopInspectionWorkTableRiskInterceptionGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopInspectionWorkTableRiskInterceptionGetResponse>(
    prepare(zlbApiSopInspectionWorkTableRiskInterceptionGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopInspectionWorkTableRiskInterceptionGet.requestConfig =
  zlbApiSopInspectionWorkTableRiskInterceptionGetRequestConfig;

/**
 * 接口 [决策支持↗](http://yapi.cai-inc.com/project/3096/interface/api/605546) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [治理端-工作台改版↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_54608)
 * @请求头 `GET /zlb/api/sop/inspection/work-table/decision/support`
 * @更新时间 `2024-01-17 18:03:17`
 * @项目ID 3096
 */
export interface ZlbApiSopInspectionWorkTableDecisionSupportGetRequest {
  /**
   * 区划code
   */
  districtCode: string;
  /**
   * 类型 eg：province、city，与datapi保持一致
   */
  type?: string;
}

/**
 * 接口 [决策支持↗](http://yapi.cai-inc.com/project/3096/interface/api/605546) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [治理端-工作台改版↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_54608)
 * @请求头 `GET /zlb/api/sop/inspection/work-table/decision/support`
 * @更新时间 `2024-01-17 18:03:17`
 * @项目ID 3096
 */
export interface ZlbApiSopInspectionWorkTableDecisionSupportGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 预算编制支持
     */
    budgetSupportNum?: number;
    /**
     * 采购计划支持
     */
    purchasePlanNum?: number;
    /**
     * 供应商评价支持
     */
    supplierEvaluation?: number;
    /**
     * 内部控制度支持
     */
    innerControlNum?: number;
    /**
     * 统计信息
     */
    statInfo?: {
      /**
       * 数值
       */
      value?: number;
      /**
       * 标签
       */
      label?: string;
      /**
       * 单位
       */
      unit?: string;
    }[];
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [决策支持↗](http://yapi.cai-inc.com/project/3096/interface/api/605546) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [治理端-工作台改版↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_54608)
 * @请求头 `GET /zlb/api/sop/inspection/work-table/decision/support`
 * @更新时间 `2024-01-17 18:03:17`
 * @项目ID 3096
 */
type ZlbApiSopInspectionWorkTableDecisionSupportGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/inspection/work-table/decision/support',
    'data',
    string,
    'districtCode' | 'type',
    false
  >
>;

/**
 * 接口 [决策支持↗](http://yapi.cai-inc.com/project/3096/interface/api/605546) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [治理端-工作台改版↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_54608)
 * @请求头 `GET /zlb/api/sop/inspection/work-table/decision/support`
 * @更新时间 `2024-01-17 18:03:17`
 * @项目ID 3096
 */
const zlbApiSopInspectionWorkTableDecisionSupportGetRequestConfig: ZlbApiSopInspectionWorkTableDecisionSupportGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_11,
    devUrl: devUrl_0_2_0_11,
    prodUrl: prodUrl_0_2_0_11,
    path: '/zlb/api/sop/inspection/work-table/decision/support',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_11,
    paramNames: [],
    queryNames: ['districtCode', 'type'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopInspectionWorkTableDecisionSupportGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [决策支持↗](http://yapi.cai-inc.com/project/3096/interface/api/605546) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [治理端-工作台改版↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_54608)
 * @请求头 `GET /zlb/api/sop/inspection/work-table/decision/support`
 * @更新时间 `2024-01-17 18:03:17`
 * @项目ID 3096
 */
export const zlbApiSopInspectionWorkTableDecisionSupportGet = /*#__PURE__*/ (
  requestData: ZlbApiSopInspectionWorkTableDecisionSupportGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopInspectionWorkTableDecisionSupportGetResponse>(
    prepare(zlbApiSopInspectionWorkTableDecisionSupportGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopInspectionWorkTableDecisionSupportGet.requestConfig =
  zlbApiSopInspectionWorkTableDecisionSupportGetRequestConfig;

/**
 * 接口 [用户画像↗](http://yapi.cai-inc.com/project/3096/interface/api/605554) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [治理端-工作台改版↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_54608)
 * @请求头 `GET /zlb/api/sop/inspection/work-table/user/portrait`
 * @更新时间 `2024-01-17 18:03:18`
 * @项目ID 3096
 */
export interface ZlbApiSopInspectionWorkTableUserPortraitGetRequest {
  /**
   * 区划code
   */
  districtCode: string;
  /**
   * 类型 eg：province、city，与datapi保持一致
   */
  type?: string;
}

/**
 * 接口 [用户画像↗](http://yapi.cai-inc.com/project/3096/interface/api/605554) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [治理端-工作台改版↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_54608)
 * @请求头 `GET /zlb/api/sop/inspection/work-table/user/portrait`
 * @更新时间 `2024-01-17 18:03:18`
 * @项目ID 3096
 */
export interface ZlbApiSopInspectionWorkTableUserPortraitGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 区划画像
     */
    districtPortrait?: number;
    /**
     * 单位肖像
     */
    unitPortrait?: number;
    /**
     * 用户画像
     */
    userPortrait?: number;
    /**
     * 统计信息
     */
    statInfo?: {
      /**
       * 数值
       */
      value?: number;
      /**
       * 标签
       */
      label?: string;
      /**
       * 单位
       */
      unit?: string;
    }[];
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [用户画像↗](http://yapi.cai-inc.com/project/3096/interface/api/605554) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [治理端-工作台改版↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_54608)
 * @请求头 `GET /zlb/api/sop/inspection/work-table/user/portrait`
 * @更新时间 `2024-01-17 18:03:18`
 * @项目ID 3096
 */
type ZlbApiSopInspectionWorkTableUserPortraitGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/inspection/work-table/user/portrait',
    'data',
    string,
    'districtCode' | 'type',
    false
  >
>;

/**
 * 接口 [用户画像↗](http://yapi.cai-inc.com/project/3096/interface/api/605554) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [治理端-工作台改版↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_54608)
 * @请求头 `GET /zlb/api/sop/inspection/work-table/user/portrait`
 * @更新时间 `2024-01-17 18:03:18`
 * @项目ID 3096
 */
const zlbApiSopInspectionWorkTableUserPortraitGetRequestConfig: ZlbApiSopInspectionWorkTableUserPortraitGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_11,
    devUrl: devUrl_0_2_0_11,
    prodUrl: prodUrl_0_2_0_11,
    path: '/zlb/api/sop/inspection/work-table/user/portrait',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_11,
    paramNames: [],
    queryNames: ['districtCode', 'type'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopInspectionWorkTableUserPortraitGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [用户画像↗](http://yapi.cai-inc.com/project/3096/interface/api/605554) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [治理端-工作台改版↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_54608)
 * @请求头 `GET /zlb/api/sop/inspection/work-table/user/portrait`
 * @更新时间 `2024-01-17 18:03:18`
 * @项目ID 3096
 */
export const zlbApiSopInspectionWorkTableUserPortraitGet = /*#__PURE__*/ (
  requestData: ZlbApiSopInspectionWorkTableUserPortraitGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopInspectionWorkTableUserPortraitGetResponse>(
    prepare(zlbApiSopInspectionWorkTableUserPortraitGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopInspectionWorkTableUserPortraitGet.requestConfig =
  zlbApiSopInspectionWorkTableUserPortraitGetRequestConfig;

/**
 * 接口 [我的待办↗](http://yapi.cai-inc.com/project/3096/interface/api/605682) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [治理端-工作台改版↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_54608)
 * @请求头 `GET /zlb/api/sop/inspection/work-table/todo-list`
 * @更新时间 `2024-01-17 18:03:18`
 * @项目ID 3096
 */
export interface ZlbApiSopInspectionWorkTableTodoListGetRequest {
  /**
   * 区划编号
   */
  districtCode: string;
}

/**
 * 接口 [我的待办↗](http://yapi.cai-inc.com/project/3096/interface/api/605682) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [治理端-工作台改版↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_54608)
 * @请求头 `GET /zlb/api/sop/inspection/work-table/todo-list`
 * @更新时间 `2024-01-17 18:03:18`
 * @项目ID 3096
 */
export interface ZlbApiSopInspectionWorkTableTodoListGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 待办总数
     */
    total?: number;
    /**
     * 待办信息
     *     AGAIN_DISPOSE_EVENT(1, "%s条申请复议事件", "处理"),
     *     PENDING_EVENT(2, "%s条待下发事件", "处理"),
     *     TO_CONFIRMED(3, "%s条单位已处理待确认事件", "处理"),
     *     GENERATE_REPORT(4, "%s月第%s次报告已生成", "查看"),
     */
    msgList?: {
      /**
       * 待办类型
       */
      type?: number;
      /**
       * 待办信息
       */
      msg?: string;
      /**
       * 按钮
       */
      button?: string;
      /**
       * 数字
       */
      number?: number;
    }[];
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [我的待办↗](http://yapi.cai-inc.com/project/3096/interface/api/605682) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [治理端-工作台改版↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_54608)
 * @请求头 `GET /zlb/api/sop/inspection/work-table/todo-list`
 * @更新时间 `2024-01-17 18:03:18`
 * @项目ID 3096
 */
type ZlbApiSopInspectionWorkTableTodoListGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3096',
    '',
    '',
    '/zlb/api/sop/inspection/work-table/todo-list',
    'data',
    string,
    'districtCode',
    false
  >
>;

/**
 * 接口 [我的待办↗](http://yapi.cai-inc.com/project/3096/interface/api/605682) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [治理端-工作台改版↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_54608)
 * @请求头 `GET /zlb/api/sop/inspection/work-table/todo-list`
 * @更新时间 `2024-01-17 18:03:18`
 * @项目ID 3096
 */
const zlbApiSopInspectionWorkTableTodoListGetRequestConfig: ZlbApiSopInspectionWorkTableTodoListGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_11,
    devUrl: devUrl_0_2_0_11,
    prodUrl: prodUrl_0_2_0_11,
    path: '/zlb/api/sop/inspection/work-table/todo-list',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_11,
    paramNames: [],
    queryNames: ['districtCode'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiSopInspectionWorkTableTodoListGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [我的待办↗](http://yapi.cai-inc.com/project/3096/interface/api/605682) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [治理端-工作台改版↗](http://yapi.cai-inc.com/project/3096/interface/api/cat_54608)
 * @请求头 `GET /zlb/api/sop/inspection/work-table/todo-list`
 * @更新时间 `2024-01-17 18:03:18`
 * @项目ID 3096
 */
export const zlbApiSopInspectionWorkTableTodoListGet = /*#__PURE__*/ (
  requestData: ZlbApiSopInspectionWorkTableTodoListGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiSopInspectionWorkTableTodoListGetResponse>(
    prepare(zlbApiSopInspectionWorkTableTodoListGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiSopInspectionWorkTableTodoListGet.requestConfig =
  zlbApiSopInspectionWorkTableTodoListGetRequestConfig;

/* prettier-ignore-end */
